var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _polygon5, _polygon6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-64",
    d: "M250.05,194.15S62,302.27,17.21,328.7v84.36h0a465.47,465.47,0,0,0,465.71,0l.08,0V328.7Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-64",
    d: "M280,443.91l-8.13-4.7-37.86,21.85a6.86,6.86,0,0,1-6.24,0l-94.43-54.51c-1.72-1-1.72-2.61,0-3.6l47.37-27.31-16.19-9.36c-1.73-1-1.73-2.61,0-3.6L185,350.9a6.86,6.86,0,0,1,6.24,0l16.18,9.36L244.21,339a6.93,6.93,0,0,1,6.24,0l94.43,54.51c1.72,1,1.72,2.61,0,3.6l-26.15,15.1,8.14,4.71c1.72,1,1.72,2.61,0,3.6l-40.59,23.43A6.86,6.86,0,0,1,280,443.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M81.07,322.55,56.46,308.36a.63.63,0,0,1,0-1.2l26.38-15.29a2.29,2.29,0,0,1,2.07,0l24.62,14.19a.63.63,0,0,1,0,1.19l-26.38,15.3A2.31,2.31,0,0,1,81.07,322.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-64",
    points: "374.9 268.97 414.43 291.86 384.56 309.11 345.03 286.21 374.9 268.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64",
    cx: 247.63,
    cy: 242.74,
    rx: 39.95,
    ry: 23.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64",
    cx: 436.64,
    cy: 380.01,
    rx: 39.95,
    ry: 23.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M347.26,257.7c6.23,3.64,6.23,9.54,0,13.18s-16.34,3.64-22.57,0-6.24-9.54,0-13.18S341,254.06,347.26,257.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M366.88,420.39,335.1,402a.75.75,0,0,1,0-1.41l47-27.12a2.67,2.67,0,0,1,2.43,0l31.78,18.35a.74.74,0,0,1,0,1.4l-47,27.13A2.73,2.73,0,0,1,366.88,420.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64",
    cx: 67.08,
    cy: 389.61,
    rx: 39.84,
    ry: 23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-64",
    cx: 196.51,
    cy: 260.38,
    rx: 18.51,
    ry: 10.69,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Walls--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Wall--inject-64",
    d: "M17.21,328.7C62,302.27,250.05,194.15,250.05,194.15L483,328.7h2L250.55,193.28V25.91h-1V193.28S60.47,302,15.24,328.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.41,130h0l0,0h0l-2.77-1.61h0l0,0h0c-3-1.52-7-1.07-11.31,1.7C40.6,135.61,34,148.46,34.48,158.75c.25,5.13,2.22,8.64,5.21,10.2h0l2.77,1.62h0c3,1.53,7,1.08,11.31-1.7,8.66-5.57,15.27-18.43,14.77-28.72C68.37,135.05,66.4,131.53,63.41,130Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.27,170.46,39.72,169h0l0,0c-3-1.55-5-5.07-5.2-10.19a32,32,0,0,1,3.13-14.41L40.39,146a32,32,0,0,0-3.13,14.41C37.5,165.38,39.4,168.86,42.27,170.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.84,168.89c8.66-5.57,15.27-18.43,14.77-28.72s-7.92-14.1-16.58-8.52-15.27,18.43-14.77,28.72S45.19,174.47,53.84,168.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.59,168.18c-5.11.24-5.94-5.5-6.06-8-.44-9.08,5.64-20.89,13.28-25.81a11.59,11.59,0,0,1,5.48-2c5.1-.24,5.93,5.5,6.05,8,.45,9.08-5.63,20.89-13.27,25.81a11.59,11.59,0,0,1-5.48,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.94,152a.57.57,0,0,1-.18,0,.56.56,0,0,1-.38-.52V138.29a.56.56,0,1,1,1.12,0V149.8l6.12-7.87a.56.56,0,0,1,.87.69l-7.11,9.14A.58.58,0,0,1,53.94,152Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,161.66h-.08a.22.22,0,0,1-.16-.29L53.65,151a.23.23,0,0,1,.29-.15.24.24,0,0,1,.16.29L51,161.5A.24.24,0,0,1,50.81,161.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.76,148.79c1-.66,1.9-.21,2,1A4.18,4.18,0,0,1,54,153.17c-1,.66-1.9.21-1.95-1A4.22,4.22,0,0,1,53.76,148.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.51 136.47 230.52 44.13 112.8 112.1 112.81 204.43 230.51 136.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.52 41.41 232.91 42.75 232.9 137.8 230.51 136.47 230.52 41.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.08 163.86 200.94 153.54 230.51 90.94 230.52 63.43 183.08 163.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.8 103.43 112.8 135.19 112.81 145.79 134.69 99.46 127.8 103.43",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.47 146.88 230.51 108.69 230.51 103.11 208.84 148.98 212.47 146.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.52 47.9 172.99 169.68 176.62 167.58 230.52 53.49 230.52 47.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.44 51.11 192.59 66.03 132.62 192.99 158.46 178.07 218.44 51.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.38 71.93 175.49 75.91 115.51 202.87 122.4 198.89 182.38 71.93",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.55 85.68 140.68 96 112.81 155.01 112.81 182.51 158.55 85.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,140.37V35.07l-129,74.46V214.84ZM112.79,207.15V112.1L232.91,42.75V137.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.9 137.8 230.51 136.47 112.81 204.43 112.79 207.15 232.9 137.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.87 67.02 193.25 65.64 193.25 160.7 190.86 159.37 190.87 67.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.64 93.13 148.03 91.75 148.03 186.81 145.64 185.47 145.64 93.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.36 214.84 105.98 213.45 105.99 108.15 108.36 109.53 108.36 214.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.99 108.15 108.36 109.53 237.35 35.06 234.97 33.68 105.99 108.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.79 154.31 112.79 157.06 232.91 87.71 230.53 86.33 112.79 154.31",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.8 162.18 112.79 157.06 232.91 87.71 232.9 92.84 112.8 162.18",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.03 191.93 152.46 189.37 152.47 84.07 148.03 86.63 148.03 191.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.24 165.83 197.67 163.27 197.68 57.97 193.25 60.53 193.24 165.83",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.03 136.72 145.64 135.34 145.64 93.13 148.03 91.75 148.03 136.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.22 110.63 190.83 109.25 190.84 67.04 193.23 65.66 193.22 110.63",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.74,36.08l-.72.42v99.91a7.7,7.7,0,0,0,3.2,6.13l85.33,49.27a2.1,2.1,0,0,0,2,.22l.83-.48a2.83,2.83,0,0,0,1.1-2.58V89.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.55,191.81l-85.33-49.27a7.7,7.7,0,0,1-3.2-6.13V36.5l91.74,53v99.9C354.76,191.75,353.32,192.84,351.55,191.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.84,37.93l90.09,52v99.43c0,.92-.29,2-1.11,2a1.8,1.8,0,0,1-.86-.28l-85.33-49.28a6.89,6.89,0,0,1-2.79-5.41V37.93M263,36.5v99.91a7.7,7.7,0,0,0,3.2,6.13l85.33,49.27a2.48,2.48,0,0,0,1.27.39c1.14,0,1.94-1,1.94-2.81V89.49L263,36.5Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sticky-notes--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--notes-shadows--inject-64",
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 159.54 326.34 155.4 326.34 144.36 333.5 148.5 333.5 159.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "343.92 165.55 336.75 161.41 336.75 150.37 343.92 154.51 343.92 165.55"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 174.71 326.34 170.57 326.34 159.54 333.5 163.68 333.5 174.71"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "345.49 179.97 337.01 176.96 336.12 166.69 344.6 169.7 345.49 179.97"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Note--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.36,155l4.95,2.77c.55.31.92-.58.92-1.12.55.35,1.69.57,1.74-.13l.46-6.26L326,146Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.98 145.99 333.43 150.29 333.43 148.91 325.98 144.6 325.98 145.99",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.74 156.93 330.7 157.82 331.33 156.16 332.74 156.93",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.77 161.04 343.18 165.26 343.85 156.3 336.39 152 335.77 161.04",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.39 152 343.85 156.3 343.85 154.92 336.39 150.62 336.39 152",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.39 152 343.85 156.3 343.85 154.92 336.39 150.62 336.39 152",
    style: {
      fill: "#e6e6e6",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "336.86 177.44 344.88 180.34 344.02 171.39 335.94 168.42 336.86 177.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.94 168.42 344.02 171.39 343.78 170.03 335.71 167.06 335.94 168.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.94 168.42 344.02 171.39 343.78 170.03 335.71 167.06 335.94 168.42",
    style: {
      fill: "#e6e6e6",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "325.36 170.1 332.77 174.32 333.43 165.37 325.98 161.06 325.36 170.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.98 161.06 333.43 165.37 333.43 163.98 325.98 159.68 325.98 161.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.98 161.06 333.43 165.37 333.43 163.98 325.98 159.68 325.98 161.06",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.48 151.7 304.37 125.66 304.37 74.3 349.48 100.34 349.48 151.7",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63,151.12l.2-.12a1.31,1.31,0,0,0,.6-1v-48.3a1.31,1.31,0,0,0-.6-1L304.35,75.47a1.28,1.28,0,0,0-1.2,0l-.21.11a1.35,1.35,0,0,0-.6,1v48.3a1.32,1.32,0,0,0,.6,1l43.49,25.16A1.33,1.33,0,0,0,347.63,151.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.43,101.66V150a1.31,1.31,0,0,1-.6,1l-.2.12a1.37,1.37,0,0,1-1.07.06c.27.08.47-.08.47-.41v-48.3a1.22,1.22,0,0,0-.18-.59l1.41-.81A1.32,1.32,0,0,1,348.43,101.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94,76.28l43.49,25.15a1.33,1.33,0,0,1,.6,1v48.3c0,.38-.27.54-.6.35L302.94,126a1.32,1.32,0,0,1-.6-1V76.62C302.34,76.24,302.61,76.09,302.94,76.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,83.15a2.25,2.25,0,0,1,1,1.78c0,.65-.46.92-1,.59a2.28,2.28,0,0,1-1-1.78C306.57,83.09,307,82.82,307.6,83.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,85.15a1.63,1.63,0,0,0,.76,1.26l7,4c.42.24.76.07.76-.38a1.61,1.61,0,0,0-.76-1.26l-7-4C309.75,84.53,309.41,84.7,309.41,85.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,88.06a2.28,2.28,0,0,1,1,1.78c0,.66-.46.92-1,.59a2.25,2.25,0,0,1-1-1.77C306.57,88,307,87.74,307.6,88.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,88.06a2.28,2.28,0,0,1,1,1.78c0,.66-.46.92-1,.59a2.25,2.25,0,0,1-1-1.77C306.57,88,307,87.74,307.6,88.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,90.07a1.61,1.61,0,0,0,.76,1.25l7,4.05c.42.24.76.07.76-.39a1.61,1.61,0,0,0-.76-1.25l-7-4C309.75,89.44,309.41,89.61,309.41,90.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.37,113V98.84c-3.76-2.13-7.17,0-8.37,5-1.48,6.18,1,15.83,5.52,20.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.83,127a6.41,6.41,0,0,0,2.29.83l-2.29-12.17-2.29,9.53A10.84,10.84,0,0,0,324.83,127Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.83,127a6.41,6.41,0,0,0,2.29.83l-2.29-12.17-2.29,9.53A10.84,10.84,0,0,0,324.83,127Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,128.64c2.46.09,4.5-1.88,5.37-5.18l-8-8.58Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,128.64c2.46.09,4.5-1.88,5.37-5.18l-8-8.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.35,121.82a16.43,16.43,0,0,0,.3-3.35c0-7.25-3.71-15.34-8.37-18.4v13.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.35,121.82a16.43,16.43,0,0,0,.3-3.35c0-7.25-3.71-15.34-8.37-18.4v13.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38,105l-.55-.31a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.43.43,0,0,1,.14.24c0,.08,0,.13,0,.14Zm-1.09-.63-.54-.31a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.55.31a.48.48,0,0,1,.14.25c0,.07,0,.12,0,.14Zm-1.09-.62-.54-.32a.41.41,0,0,1-.14-.24c0-.1,0-.17,0-.14l.54.32a.45.45,0,0,1,.14.24c0,.07,0,.12,0,.14Zm-1.08-.63-.55-.31a.48.48,0,0,1-.14-.25c0-.1,0-.17,0-.14l.54.32a.5.5,0,0,1,.15.24.31.31,0,0,1,0,.14A0,0,0,0,1,315.12,103.16Zm-1.09-.63-.54-.31a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.55.31a.49.49,0,0,1,.14.24c0,.08,0,.13,0,.14S314.05,102.54,314,102.53Zm-1.09-.62-.4-.24a.45.45,0,0,1-.14-.24c0-.11,0-.17,0-.14l.4.23a.48.48,0,0,1,.14.25c0,.07,0,.12,0,.14S313,101.92,312.94,101.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,114.73l-.55-.31a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.48.48,0,0,1,.14.25c0,.07,0,.12,0,.14Zm-1.09-.62-.54-.32a.45.45,0,0,1-.15-.24c0-.11,0-.17,0-.14l.54.32a.41.41,0,0,1,.15.24c0,.07,0,.12,0,.14S335.79,114.12,335.77,114.11Zm-1.09-.63-.54-.31a.42.42,0,0,1-.14-.25c0-.1,0-.17,0-.14l.55.32a.49.49,0,0,1,.14.24c0,.07,0,.12,0,.14Zm-1.08-.63-.55-.31a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.49.49,0,0,1,.14.24c0,.08,0,.13,0,.14A0,0,0,0,1,333.6,112.85Zm-1.09-.62-.54-.32a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.54.31a.49.49,0,0,1,.15.25.21.21,0,0,1,0,.14Zm-1.09-.63-.39-.23a.45.45,0,0,1-.14-.24c0-.11,0-.17,0-.14l.39.23a.41.41,0,0,1,.14.24c0,.07,0,.12,0,.14S331.44,111.61,331.42,111.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,105.39a.91.91,0,0,0-.33-.71c-.19-.1-.34,0-.34.33a.89.89,0,0,0,.34.71C319.11,105.82,319.26,105.68,319.26,105.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.19,111.3a.91.91,0,0,0-.33-.71c-.19-.1-.34,0-.34.33a.89.89,0,0,0,.34.71C331,111.73,331.19,111.59,331.19,111.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,125.79a.91.91,0,0,0-.33-.71c-.19-.11-.34,0-.34.32a.86.86,0,0,0,.34.71C325,126.22,325.16,126.07,325.16,125.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.6,115.79a.21.21,0,0,0,.09.1s.07,0,.09,0a.15.15,0,0,0,0-.1v-.16a.33.33,0,0,0,0-.1v-.06a.32.32,0,0,0,0-.14.22.22,0,0,0-.09-.1s-.07,0-.09,0a.18.18,0,0,0,0,.11v.32A.35.35,0,0,0,338.6,115.79Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.6,115.79a.21.21,0,0,0,.09.1s.07,0,.09,0a.15.15,0,0,0,0-.1v-.16a.33.33,0,0,0,0-.1v-.06a.32.32,0,0,0,0-.14.22.22,0,0,0-.09-.1s-.07,0-.09,0a.18.18,0,0,0,0,.11v.32A.35.35,0,0,0,338.6,115.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.7,133.43l-.55-.31a.48.48,0,0,1-.14-.25c0-.1,0-.17,0-.13l.54.31a.5.5,0,0,1,.15.24.21.21,0,0,1,0,.14Zm-1.09-.63-.54-.31a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.55.31a.49.49,0,0,1,.14.24c0,.08,0,.13,0,.14Zm-1.09-.62-.54-.32a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.48.48,0,0,1,.14.25c0,.07,0,.12,0,.14Zm-1.08-.63-.55-.32a.41.41,0,0,1-.14-.24c0-.1,0-.17,0-.14l.54.32a.45.45,0,0,1,.15.24.21.21,0,0,1,0,.14Zm-1.09-.63-.54-.31a.49.49,0,0,1-.15-.25c0-.1,0-.16,0-.13l.55.31a.49.49,0,0,1,.14.24c0,.07,0,.12,0,.14S331.37,130.93,331.35,130.92Zm-.83-1a.5.5,0,0,1-.1-.28v-.83c0-.08,0-.08.1,0a.55.55,0,0,1,.11.28V130a.08.08,0,0,1,0,.05S330.56,130,330.52,129.94Zm0-1.67a.53.53,0,0,1-.1-.28v-.84c0-.07,0-.07.1,0a.52.52,0,0,1,.11.28v.83s0,0,0,0S330.56,128.32,330.52,128.27Zm0-1.67a.53.53,0,0,1-.1-.28v-.82c0-.08,0-.08.1,0a.58.58,0,0,1,.11.28v.82a.06.06,0,0,1,0,.05S330.56,126.65,330.52,126.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,125.32a.87.87,0,0,0-.34-.71c-.18-.11-.33,0-.33.32a.89.89,0,0,0,.33.71C330.71,125.75,330.86,125.6,330.86,125.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,130.15l-.22-.13a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.17.09v-.41c0-.08,0-.08.11,0a.53.53,0,0,1,.1.28v.5a.07.07,0,0,1,0,.05Zm-.76-.45-.55-.31a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.42.42,0,0,1,.14.25c0,.07,0,.12,0,.14Zm.71-.94a.55.55,0,0,1-.11-.28v-.83c0-.08,0-.08.11,0a.5.5,0,0,1,.1.28v.83s0,.05,0,.05S324.87,128.81,324.83,128.76Zm-1.8.32-.54-.32a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.54.32a.41.41,0,0,1,.15.24c0,.07,0,.12,0,.14Zm1.8-2a.55.55,0,0,1-.11-.28V126c0-.08,0-.08.11,0a.56.56,0,0,1,.1.28v.84s0,0,0,0S324.87,127.14,324.83,127.09Zm-2.89,1.36-.54-.31a.48.48,0,0,1-.14-.25c0-.1,0-.17,0-.14l.55.32a.45.45,0,0,1,.14.24c0,.07,0,.12,0,.14S322,128.46,321.94,128.45Zm-1.08-.63-.55-.31a.49.49,0,0,1-.14-.24c0-.11,0-.17,0-.14l.54.31a.43.43,0,0,1,.14.24c0,.07,0,.13,0,.14S320.87,127.83,320.86,127.82Zm-1.09-.63-.54-.31a.5.5,0,0,1-.15-.24c0-.11,0-.17,0-.14l.54.31a.49.49,0,0,1,.15.25c0,.07,0,.12,0,.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,126.57s0-.07,0-.14a.41.41,0,0,0-.14-.24l-.55-.32s-.06,0,0,.14a.49.49,0,0,0,.14.24l.54.32S318.71,126.58,318.72,126.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.63,125.94s0-.07,0-.14a.43.43,0,0,0-.14-.24l-.54-.32c-.05,0-.07,0,0,.14a.48.48,0,0,0,.14.25l.55.31A0,0,0,0,0,317.63,125.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,125.31s0-.07,0-.14a.5.5,0,0,0-.15-.24l-.54-.31c-.05,0-.07,0,0,.13a.49.49,0,0,0,.15.25l.54.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.46,124.68s0-.06,0-.14a.49.49,0,0,0-.14-.24l-.55-.31s-.06,0,0,.14a.49.49,0,0,0,.14.24l.54.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.79,122l-6.24-3.66a1,1,0,0,1-.44-.81c0-.31.19-.44.43-.31l6.3,3.6a1,1,0,0,1,.41.84C344.23,122,344,122.12,343.79,122Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.36,140.17l-6.24-3.65a1,1,0,0,1-.44-.81c0-.31.19-.45.43-.31l6.3,3.6a1,1,0,0,1,.41.83C343.8,140.16,343.6,140.31,343.36,140.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,126.64,307.65,123a1,1,0,0,1-.44-.81c0-.31.19-.44.43-.31l6.3,3.6a1,1,0,0,1,.41.84C314.33,126.63,314.13,126.79,313.89,126.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,105.16l-6.24-3.66a1.05,1.05,0,0,1-.44-.81c0-.3.2-.44.43-.31L312,104a1,1,0,0,1,.41.84C312.44,105.15,312.23,105.3,312,105.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "322.31 164.23 307.61 155.74 307.61 131.01 322.31 139.5 322.31 164.23",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,164.46l-14-8.06a.82.82,0,0,1-.37-.64V131.89c0-.24.17-.33.37-.22l14,8.07a.78.78,0,0,1,.37.64v23.87C321.61,164.49,321.45,164.58,321.24,164.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,143.35l-11.14-6.43a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,143.44,320.06,143.48,319.83,143.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,145.11l-11.14-6.43a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,145.2,320.06,145.24,319.83,145.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,148.77l-11.14-6.43a.83.83,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,148.86,320.06,148.9,319.83,148.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,150.53l-11.14-6.43a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,150.62,320.06,150.66,319.83,150.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,156l-11.14-6.43a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,156,320.06,156.08,319.83,156Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,154.19l-11.14-6.43a.83.83,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.14,6.43a.79.79,0,0,1,.41.58C320.24,154.28,320.06,154.32,319.83,154.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pushpin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.45,138l0,0a.07.07,0,0,0,0,0s.05,0,.09,0l.28-.16.39-.24.45-.28s0-.17-.09-.15l-.46.25-.4.23-.28.16s-.07,0-.07.06a.17.17,0,0,0,0,.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,138.17c.21.37.57.58.94.37h0a.4.4,0,0,0,.16-.36,1.26,1.26,0,0,0-.57-1,.39.39,0,0,0-.38-.05h0l0,0A.69.69,0,0,0,313.16,138.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.16,138.17c.21.37.57.58.94.37h0a.4.4,0,0,0,.16-.36,1.26,1.26,0,0,0-.57-1,.39.39,0,0,0-.38-.05h0l0,0A.69.69,0,0,0,313.16,138.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M312.7,138.91l-.42-.72a3.53,3.53,0,0,0,.89-.61h0l0,0h0c.06-.06.16-.06.28,0a.8.8,0,0,1,.36.63.27.27,0,0,1-.1.24h0l-.07,0A4.06,4.06,0,0,0,312.7,138.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,138.33a.44.44,0,0,1,.44-.44.41.41,0,0,1,.16,0h0l.07,0a1,1,0,0,1,.44.78.37.37,0,0,1,0,.11.44.44,0,0,1-.43.36.43.43,0,0,1-.44-.44v0A.44.44,0,0,1,311.92,138.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,138.33a.44.44,0,0,1,.44-.44.41.41,0,0,1,.16,0h0l.07,0a1,1,0,0,1,.44.78.37.37,0,0,1,0,.11.44.44,0,0,1-.43.36.43.43,0,0,1-.44-.44v0A.44.44,0,0,1,311.92,138.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M312.36,138.11c-.24-.14-.44,0-.44.26a1,1,0,0,0,.44.77c.25.14.45,0,.45-.26A1,1,0,0,0,312.36,138.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "301.19 154.59 268.27 135.59 268.27 76.89 301.19 95.89 301.19 154.59",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.22 127.23 267.31 108.23 267.31 77.5 300.22 96.51 300.22 127.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299 123.12 268.53 105.53 268.53 81.41 299 99.01 299 123.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299 123.12 268.53 105.53 268.53 81.41 299 99.01 299 123.12",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.53 93.41 299 111.01 299 123.12 268.53 105.53 268.53 93.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,111l-17.83-10.29s-7.14-2.08-5.57.43,7.63,4.38,10.75,10.49c2.42,4.75,12.65,9.84,12.65,9.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,111l-17.83-10.29s-7.14-2.08-5.57.43,7.63,4.38,10.75,10.49c2.42,4.75,12.65,9.84,12.65,9.84Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,102s-6.88-13.28-8.87-15.24-2.89.56-3.41.34-2.52-5.65-2.52-5.65v12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,102s-6.88-13.28-8.87-15.24-2.89.56-3.41.34-2.52-5.65-2.52-5.65v12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,106.31a5.29,5.29,0,0,0-2-2.38,9.81,9.81,0,0,1-4-4.34c-.57-1.7-2.2-5.78-3.79-6.38s-5.21,4.41-5.21,4.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.29,99.9c0-1.56.82-2.35,1.83-1.77A4.85,4.85,0,0,1,297,102c0,1.56-.82,2.35-1.83,1.76A4.82,4.82,0,0,1,293.29,99.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.28 127.84 266.26 108.77 266.26 137.1 299.28 156.16 299.28 127.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.22 127.29 300.22 155.62 299.28 156.16 299.28 127.84 300.22 127.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.26 108.77 267.2 108.23 300.22 127.29 299.28 127.84 266.26 108.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "266.26 108.77 267.2 108.23 300.22 127.29 299.28 127.84 266.26 108.77",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "300.22 127.29 299.28 127.84 299.28 133.28 300.22 132.74 300.22 127.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "300.22 127.29 299.28 127.84 299.28 133.28 300.22 132.74 300.22 127.29",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "299.28 133.28 266.26 114.22 266.26 108.77 299.28 127.84 299.28 133.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,135c0,.3-.23.42-.51.26l-2.47-1.43a1.08,1.08,0,0,1-.5-.84c0-.3.22-.41.5-.25l2.47,1.43A1.07,1.07,0,0,1,297,135Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.86,132.63c0,.3-.22.41-.5.25l-2.48-1.42a1.08,1.08,0,0,1-.5-.84c0-.3.22-.41.5-.25l2.48,1.43A1.06,1.06,0,0,1,292.86,132.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,130.22c0,.3-.22.41-.5.25L285.71,129a1.07,1.07,0,0,1-.51-.83c0-.3.23-.42.51-.25l2.47,1.42A1.08,1.08,0,0,1,288.68,130.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.51,127.81c0,.3-.23.41-.5.25l-2.48-1.43a1.06,1.06,0,0,1-.5-.83c0-.3.22-.42.5-.26L284,127A1.11,1.11,0,0,1,284.51,127.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,125.4c0,.3-.22.41-.5.25l-2.48-1.43a1.09,1.09,0,0,1-.5-.83c0-.3.23-.42.5-.26l2.48,1.43A1.08,1.08,0,0,1,280.33,125.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,123c0,.31-.23.42-.51.26l-2.47-1.43a1.07,1.07,0,0,1-.51-.83c0-.31.23-.42.51-.26l2.47,1.43A1.07,1.07,0,0,1,276.16,123Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,120.57c0,.3-.23.42-.5.26L269,119.4a1.08,1.08,0,0,1-.5-.84c0-.3.22-.41.5-.25l2.48,1.43A1.09,1.09,0,0,1,272,120.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.82 137.9 293.78 136.16 293.78 138.89 296.82 140.69 296.82 137.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.82 141.75 293.78 140 293.78 142.74 296.82 144.53 296.82 141.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.82 145.59 293.78 143.85 293.78 146.58 296.82 148.38 296.82 145.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.82 149.44 293.78 147.69 293.78 150.43 296.82 152.22 296.82 149.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.64 135.49 289.6 133.74 289.6 136.48 292.64 138.27 292.64 135.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.64 139.34 289.6 137.59 289.6 140.32 292.64 142.12 292.64 139.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.64 143.18 289.6 141.43 289.6 144.17 292.64 145.96 292.64 143.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.64 147.03 289.6 145.28 289.6 148.01 292.64 149.81 292.64 147.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.46 133.08 285.42 131.33 285.42 134.07 288.46 135.86 288.46 133.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.46 136.92 285.42 135.18 285.42 137.91 288.46 139.7 288.46 136.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.46 140.77 285.42 139.02 285.42 141.76 288.46 143.55 288.46 140.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.46 144.61 285.42 142.87 285.42 145.6 288.46 147.4 288.46 144.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.28 130.66 281.25 128.92 281.25 131.65 284.28 133.45 284.28 130.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.28 134.51 281.25 132.76 281.25 135.5 284.28 137.29 284.28 134.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.28 138.35 281.25 136.61 281.25 139.34 284.28 141.14 284.28 138.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.28 142.2 281.25 140.45 281.25 143.19 284.28 144.98 284.28 142.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.1 128.25 277.06 126.5 277.06 129.24 280.1 131.03 280.1 128.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.1 132.1 277.06 130.35 277.06 133.09 280.1 134.88 280.1 132.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.1 135.94 277.06 134.19 277.06 136.93 280.1 138.72 280.1 135.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.1 139.79 277.06 138.04 277.06 140.78 280.1 142.57 280.1 139.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 125.84 272.89 124.09 272.89 126.83 275.93 128.62 275.93 125.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 129.68 272.89 127.94 272.89 130.67 275.93 132.47 275.93 129.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 133.53 272.89 131.78 272.89 134.52 275.93 136.31 275.93 133.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 137.37 272.89 135.63 272.89 138.36 275.93 140.16 275.93 137.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.75 123.43 268.71 121.68 268.71 124.42 271.75 126.21 271.75 123.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.75 127.27 268.71 125.52 268.71 128.26 271.75 130.05 271.75 127.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.75 131.12 268.71 129.37 268.71 132.1 271.75 133.9 271.75 131.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.75 134.96 268.71 133.21 268.71 135.95 271.75 137.74 271.75 134.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.78,120.7l-.23.5a.07.07,0,0,1-.08,0l-.53-.2c-.08,0-.12.08-.06.2l.39.72a.31.31,0,0,1,0,.13l-.09.66c0,.1.07.23.15.23l.47-.06s.06,0,.09,0l.48.61c.07.09.16.06.15-.06l-.09-.76a.09.09,0,0,1,0-.1l.38-.28c.06,0,0-.2-.06-.26l-.53-.41a.24.24,0,0,1-.07-.12l-.24-.78C268.93,120.68,268.82,120.62,268.78,120.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,137.6a1.33,1.33,0,0,1,.79-1.28c.69-.25,1.26.3,1.69.75.11.12-.09.18-.18.1-.44-.42-1.25-.83-1.73-.28s-.22,1.37,0,2a2.79,2.79,0,0,0,2.58,1.88c2.55-.19-.21-4.68-1.72-4.94-.13,0-.21-.21,0-.23.76-.13,1.3.55,1.78,1.06a5.74,5.74,0,0,1,1.22,2c.51,1.35-.24,3-1.89,2.49A3.59,3.59,0,0,1,280.57,137.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.18,136a3.23,3.23,0,0,1,.46-.52c.06-.07.21,0,.17.1s-.27.33-.38.52l-.06.09a3,3,0,0,1,1.07-.35,3.65,3.65,0,0,1,2.19.2c.07,0,0,.09,0,.09a.72.72,0,0,1-.32,0,4.36,4.36,0,0,0-1.14-.09,3.78,3.78,0,0,0-1.61.42,1,1,0,0,1,1,.25s0,.09,0,.1c-.24,0-.45-.06-.69,0a2.52,2.52,0,0,0-.82.14c-.1,0-.18-.07-.18-.17C284.86,136.39,285.06,136.19,285.18,136Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.06,89.45l0,0a.1.1,0,0,0,.05,0s.05,0,.09,0l.28-.17.39-.23.45-.28c.05,0,0-.18-.09-.15l-.46.25-.4.22-.28.16s-.07,0-.07.07a.17.17,0,0,0,0,.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77,89.65a.68.68,0,0,0,.94.38h0a.42.42,0,0,0,.16-.37,1.24,1.24,0,0,0-.57-1,.39.39,0,0,0-.38-.05h0l0,0A.68.68,0,0,0,282.77,89.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,90.4l-.42-.72a3.84,3.84,0,0,0,.89-.61h0l0,0h0c.06-.05.16-.05.28,0a.8.8,0,0,1,.36.63.27.27,0,0,1-.1.24h0l-.07,0A3.68,3.68,0,0,0,282.31,90.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.53,89.82a.44.44,0,0,1,.44-.44.41.41,0,0,1,.16,0h0l.07,0a1,1,0,0,1,.44.77.46.46,0,0,1-.44.48.44.44,0,0,1-.44-.44v0A.44.44,0,0,1,281.53,89.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,89.6c-.24-.15-.44,0-.44.25a1,1,0,0,0,.44.78c.25.14.45,0,.45-.26A1,1,0,0,0,282,89.6Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.28,92.59l2.44-4.26-94.19-54.4h0a1.2,1.2,0,0,0-1.26.1,3.85,3.85,0,0,0-1.73,3,1.22,1.22,0,0,0,.48,1.1h0l0,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,91.46a3.82,3.82,0,0,1,1.73-3c1-.55,1.74-.1,1.74,1a3.83,3.83,0,0,1-1.74,3C355.53,93,354.76,92.56,354.76,91.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "298.62 81.79 283.91 73.3 283.91 48.57 298.62 57.06 298.62 81.79",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54,82l-14-8.06a.81.81,0,0,1-.37-.64V49.44c0-.23.16-.33.37-.21l14,8.06a.81.81,0,0,1,.37.64V81.81C297.91,82,297.75,82.14,297.54,82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,60.9,285,54.47a.79.79,0,0,1-.41-.57c0-.19.18-.24.41-.1l11.14,6.43a.79.79,0,0,1,.41.58C296.54,61,296.36,61,296.13,60.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,62.67,285,56.24a.83.83,0,0,1-.41-.58c0-.19.18-.23.41-.1L296.13,62a.79.79,0,0,1,.41.58C296.54,62.75,296.36,62.8,296.13,62.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,66.32,285,59.89a.79.79,0,0,1-.41-.57c0-.19.18-.24.41-.1l11.14,6.43a.79.79,0,0,1,.41.58C296.54,66.41,296.36,66.46,296.13,66.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,68.09,285,61.65a.79.79,0,0,1-.41-.57c0-.19.18-.23.41-.1l11.14,6.43a.79.79,0,0,1,.41.58C296.54,68.17,296.36,68.22,296.13,68.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,73.51,285,67.07a.79.79,0,0,1-.41-.57c0-.19.18-.24.41-.1l11.14,6.43a.79.79,0,0,1,.41.58C296.54,73.59,296.36,73.64,296.13,73.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,71.74,285,65.31a.79.79,0,0,1-.41-.58c0-.18.18-.23.41-.09l11.14,6.43a.79.79,0,0,1,.41.57C296.54,71.83,296.36,71.88,296.13,71.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.75,55.52l0,0,.05,0s.06,0,.09,0l.28-.17.39-.23.45-.28c.05,0,0-.18-.08-.15l-.47.25-.4.22-.28.16s-.07,0-.07.07,0,0,0,.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,55.72c.22.38.57.58.94.38h0a.39.39,0,0,0,.16-.36,1.24,1.24,0,0,0-.57-1,.43.43,0,0,0-.37-.05h0l0,0C289.24,55,289.25,55.35,289.46,55.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.46,55.72c.22.38.57.58.94.38h0a.39.39,0,0,0,.16-.36,1.24,1.24,0,0,0-.57-1,.43.43,0,0,0-.37-.05h0l0,0C289.24,55,289.25,55.35,289.46,55.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M289,56.47l-.41-.72a4.52,4.52,0,0,0,.88-.61l0,0h0a.26.26,0,0,1,.28,0,.84.84,0,0,1,.37.64A.28.28,0,0,1,290,56h0L290,56A3.53,3.53,0,0,0,289,56.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,55.89a.43.43,0,0,1,.44-.44.4.4,0,0,1,.15,0h0l.07,0a1,1,0,0,1,.45.77.5.5,0,0,1,0,.12.43.43,0,0,1-.43.36.44.44,0,0,1-.44-.44v0A.43.43,0,0,1,288.23,55.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.23,55.89a.43.43,0,0,1,.44-.44.4.4,0,0,1,.15,0h0l.07,0a1,1,0,0,1,.45.77.5.5,0,0,1,0,.12.43.43,0,0,1-.43.36.44.44,0,0,1-.44-.44v0A.43.43,0,0,1,288.23,55.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.67,55.66c-.25-.14-.45,0-.45.26a1,1,0,0,0,.45.78c.24.14.44,0,.44-.26A1,1,0,0,0,288.67,55.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "296.17 57.93 294.96 57.24 294.96 52.65 296.17 53.34 296.17 57.93",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.64 71.98 266.94 63.49 266.94 38.77 281.64 47.26 281.64 71.98",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,72.22l-14-8.07a.81.81,0,0,1-.37-.64V39.64c0-.24.17-.33.37-.21l14,8.06a.82.82,0,0,1,.37.64V72C280.94,72.24,280.77,72.34,280.57,72.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,51.1,268,44.67a.81.81,0,0,1-.42-.58c0-.18.19-.23.42-.1l11.13,6.43a.85.85,0,0,1,.42.58C279.57,51.19,279.38,51.23,279.15,51.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,52.86,268,46.43a.81.81,0,0,1-.42-.58c0-.18.19-.23.42-.1l11.13,6.44a.81.81,0,0,1,.42.57C279.57,53,279.38,53,279.15,52.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,56.52,268,50.09a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.13,6.43a.83.83,0,0,1,.42.58C279.57,56.61,279.38,56.65,279.15,56.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,58.28,268,51.85a.81.81,0,0,1-.42-.58c0-.18.19-.23.42-.1l11.13,6.44a.81.81,0,0,1,.42.57C279.57,58.37,279.38,58.41,279.15,58.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,63.7,268,57.27a.81.81,0,0,1-.42-.58c0-.18.19-.23.42-.1L279.15,63a.85.85,0,0,1,.42.58C279.57,63.79,279.38,63.83,279.15,63.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,61.94,268,55.51a.81.81,0,0,1-.42-.58c0-.19.19-.23.42-.1l11.13,6.43a.83.83,0,0,1,.42.58C279.57,62,279.38,62.07,279.15,61.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.77,45.72l0,0,0,0s.06,0,.1,0l.28-.16.39-.24.45-.27s0-.18-.09-.16l-.46.25-.4.23-.29.16s-.06,0-.06.07a.13.13,0,0,0,0,.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,45.92c.22.38.58.58.95.38h0a.41.41,0,0,0,.15-.36,1.25,1.25,0,0,0-.56-1,.42.42,0,0,0-.38,0h0l0,0A.7.7,0,0,0,272.48,45.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.48,45.92c.22.38.58.58.95.38h0a.41.41,0,0,0,.15-.36,1.25,1.25,0,0,0-.56-1,.42.42,0,0,0-.38,0h0l0,0A.7.7,0,0,0,272.48,45.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272,46.66l-.42-.71a4,4,0,0,0,.88-.61l0,0h0a.26.26,0,0,1,.28,0,.8.8,0,0,1,.37.64.27.27,0,0,1-.11.24h0l-.07,0A3.84,3.84,0,0,0,272,46.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,46.08a.44.44,0,0,1,.44-.44.41.41,0,0,1,.16,0h0l.07,0a1,1,0,0,1,.45.77.37.37,0,0,1,0,.11.45.45,0,0,1-.44.37.44.44,0,0,1-.44-.44s0,0,0-.05A.44.44,0,0,1,271.25,46.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.25,46.08a.44.44,0,0,1,.44-.44.41.41,0,0,1,.16,0h0l.07,0a1,1,0,0,1,.45.77.37.37,0,0,1,0,.11.45.45,0,0,1-.44.37.44.44,0,0,1-.44-.44s0,0,0-.05A.44.44,0,0,1,271.25,46.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.69,45.86c-.24-.14-.44,0-.44.26a1,1,0,0,0,.44.77c.25.15.45,0,.45-.26A1,1,0,0,0,271.69,45.86Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "279.19 48.13 277.99 47.44 277.99 42.84 279.19 43.54 279.19 48.13",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.46 91.1 292.29 86.96 292.29 75.93 299.46 80.07 299.46 91.1",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.08,86.62l5,2.77c.55.31.91-.58.91-1.12.56.35,1.69.57,1.75-.13l.46-6.26-7.46-4.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.7 77.58 299.16 81.88 299.16 80.5 291.7 76.2 291.7 77.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.46 88.52 296.42 89.42 297.06 87.75 298.46 88.52",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--diplomas--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.81 171.98 401.95 172.48 380.56 159.99 381.42 159.49 402.81 171.98",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.42 159.49 401.95 171.48 401.95 153.48 381.42 141.49 381.42 159.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.71,160.49,402.81,174V153l-23.1-13.49Zm.85-19.5L402,153.48v19L380.56,160Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.56 159.99 381.42 159.49 381.42 141.49 380.56 140.99 380.56 159.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.71 139.49 380.56 138.99 403.66 152.48 402.81 152.98 379.71 139.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.66 152.48 402.81 152.98 402.81 173.98 403.66 173.48 403.66 152.48",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398.89,164a3.51,3.51,0,0,1,1.67,2.66c0,.94-.75,1.26-1.67.72a3.51,3.51,0,0,1-1.67-2.66C397.22,163.74,398,163.43,398.89,164Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,145.47,398,152.8a1.34,1.34,0,0,1,.63,1v0c0,.36-.28.48-.63.27l-12.56-7.32a1.33,1.33,0,0,1-.63-1v0C384.78,145.39,385.07,145.27,385.41,145.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,148.31,400,158a1.25,1.25,0,0,1,.63.87c0,.28-.28.34-.63.13l-16.54-9.65a1.27,1.27,0,0,1-.62-.87C382.79,148.17,383.08,148.11,383.43,148.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,150.31,400,160a1.23,1.23,0,0,1,.63.87c0,.28-.28.33-.63.13l-16.54-9.66a1.23,1.23,0,0,1-.62-.86C382.79,150.16,383.08,150.11,383.43,150.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,152.31,400,162a1.22,1.22,0,0,1,.63.87c0,.27-.28.33-.63.13l-16.54-9.66a1.25,1.25,0,0,1-.62-.87C382.79,152.16,383.08,152.1,383.43,152.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,165a2,2,0,0,1-.41-.35,1,1,0,0,1-.31-.87c0-.09-.15-.41-.23-.37s-.49.12-.72.2-.41.21-.75-.23a.83.83,0,0,1-.18-.53c.16-.1.25-.29.22-.66,0-.1-.2-.42-.25-.35a1,1,0,0,0-.22.59,1.18,1.18,0,0,1-.53.12,1.34,1.34,0,0,1-.35,0,.17.17,0,0,1-.13,0,.29.29,0,0,1-.12-.24.35.35,0,0,1,.05-.24h0v0h0c0-.1-.14-.4-.2-.35a1,1,0,0,1-1,.36l-.06,0c0-.06,0-.14,0-.2a3.42,3.42,0,0,0-.08-.48c0-.09-.16-.33-.22-.32-.35.07-.63.29-1.1.14a1.24,1.24,0,0,1-.23-.11c-.08-.12,0-.35.05-.38a2,2,0,0,1,.17-.29.6.6,0,0,0,.13-.24c0-.09-.21-.53-.26-.42a2.27,2.27,0,0,1-.15.25,2.19,2.19,0,0,1-.93.37,1.64,1.64,0,0,1-1.29-.32,1.87,1.87,0,0,1-.58-.56,1.27,1.27,0,0,1-.15-.58,1.81,1.81,0,0,1,.15-.83,5.89,5.89,0,0,0,1.44.67,1.65,1.65,0,0,0,1.08.13c.15-.07.23-.36-.12-.88a2.65,2.65,0,0,0-.77-.68,2.47,2.47,0,0,0-.79-.32.9.9,0,0,0-1,.51,2.22,2.22,0,0,0-.11.22,8.47,8.47,0,0,1-1.82-1.72s-.05,0,0,.06a9.37,9.37,0,0,0,1.78,1.79,2,2,0,0,0,.39,2,2,2,0,0,0,1.77,1,1.44,1.44,0,0,0,.69-.22h.06a1,1,0,0,0,.38.85.79.79,0,0,0,.78.2,4.05,4.05,0,0,0,.47-.12,1.3,1.3,0,0,0,.35.88.56.56,0,0,0,.64.05.82.82,0,0,0,.31-.11l.06.15c.23.47.5.53.65.52a3.49,3.49,0,0,0,.65-.06,1.89,1.89,0,0,0,.27.56c.35.53.68.64.89.63a1.35,1.35,0,0,0,.66-.21,1.85,1.85,0,0,0,.24.56,2.46,2.46,0,0,0,.84.86C396.14,165.4,396,165.08,395.92,165Zm-7.73-7.21c.16.1.51.35.52.61s-.13.17-.22.18a2.17,2.17,0,0,1-1-.15,5,5,0,0,1-1.2-.51C386.63,157.35,387.21,157.15,388.19,157.79Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.81 143.5 401.95 144 380.56 131.5 381.42 131 402.81 143.5",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.42 131 401.95 143 401.95 124.99 381.42 113 381.42 131",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.71,132l23.1,13.49v-21L379.71,111Zm.85-19.5L402,125v19l-21.39-12.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.56 131.5 381.42 131 381.42 113 380.56 112.5 380.56 131.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.71 111 380.56 110.5 403.66 124 402.81 124.49 379.71 111",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.66 124 402.81 124.49 402.81 145.5 403.66 145 403.66 124",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398.89,135.48a3.48,3.48,0,0,1,1.67,2.66c0,.93-.75,1.25-1.67.71a3.51,3.51,0,0,1-1.67-2.66C397.22,135.26,398,134.94,398.89,135.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,117,398,124.31a1.34,1.34,0,0,1,.63,1v0c0,.36-.28.48-.63.28l-12.56-7.33a1.33,1.33,0,0,1-.63-1v0C384.78,116.9,385.07,116.78,385.41,117Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,119.83,400,129.48a1.22,1.22,0,0,1,.63.87c0,.27-.28.33-.63.13l-16.54-9.66a1.25,1.25,0,0,1-.62-.87C382.79,119.68,383.08,119.62,383.43,119.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,121.82,400,131.47a1.25,1.25,0,0,1,.63.87c0,.28-.28.34-.63.13l-16.54-9.66a1.23,1.23,0,0,1-.62-.86C382.79,121.68,383.08,121.62,383.43,121.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,123.82,400,133.47a1.22,1.22,0,0,1,.63.87c0,.28-.28.33-.63.13l-16.54-9.66a1.23,1.23,0,0,1-.62-.86C382.79,123.67,383.08,123.62,383.43,123.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,136.52a2.51,2.51,0,0,1-.41-.36,1,1,0,0,1-.31-.87c0-.09-.15-.41-.23-.37a5.9,5.9,0,0,1-.72.2c-.14,0-.41.21-.75-.22a.85.85,0,0,1-.18-.53c.16-.11.25-.3.22-.66,0-.11-.2-.43-.25-.36a1,1,0,0,0-.22.6,1.17,1.17,0,0,1-.53.11,2,2,0,0,1-.35,0s-.08,0-.13,0a.29.29,0,0,1-.12-.24.35.35,0,0,1,.05-.24h0c0-.1-.14-.4-.2-.34a1,1,0,0,1-1,.36l-.06,0c0-.06,0-.13,0-.2a3.42,3.42,0,0,0-.08-.48c0-.09-.16-.32-.22-.31-.35.06-.63.28-1.1.13l-.23-.11c-.08-.12,0-.34.05-.38a2,2,0,0,1,.17-.29.6.6,0,0,0,.13-.24c0-.09-.21-.53-.26-.42s-.08.14-.15.26a2.18,2.18,0,0,1-.93.36,1.66,1.66,0,0,1-1.29-.31,1.92,1.92,0,0,1-.58-.57,1.27,1.27,0,0,1-.15-.58,1.81,1.81,0,0,1,.15-.83,6,6,0,0,0,1.44.68,1.79,1.79,0,0,0,1.08.13c.15-.08.23-.36-.12-.88a2.38,2.38,0,0,0-.77-.68,2.08,2.08,0,0,0-.79-.32.91.91,0,0,0-1,.5c0,.06-.07.13-.11.22a8.39,8.39,0,0,1-1.82-1.71s-.05,0,0,0a8.81,8.81,0,0,0,1.78,1.79,2.39,2.39,0,0,0,2.16,3,1.44,1.44,0,0,0,.69-.22h.06a1,1,0,0,0,.38.85.79.79,0,0,0,.78.2,4,4,0,0,0,.47-.11,1.29,1.29,0,0,0,.35.87.55.55,0,0,0,.64.06,1.05,1.05,0,0,0,.31-.12l.06.15c.23.47.5.54.65.53a3.5,3.5,0,0,0,.65-.07,2.06,2.06,0,0,0,.27.57c.35.53.68.63.89.63a1.6,1.6,0,0,0,.66-.21,2,2,0,0,0,.24.56,2.65,2.65,0,0,0,.84.86C396.14,136.91,396,136.59,395.92,136.52Zm-7.73-7.22c.16.11.51.35.52.62s-.13.16-.22.18a2.51,2.51,0,0,1-1-.15,6,6,0,0,1-1.2-.51C386.63,128.86,387.21,128.66,388.19,129.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.74,234.94l-13.83-8a8.43,8.43,0,0,0-7.61,0l-13.83,8a8.44,8.44,0,0,0-3.81,6.6v65.75L82.1,319.67l21.45-12.38V241.54A8.44,8.44,0,0,0,99.74,234.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,253.92a8.44,8.44,0,0,1,3.81-6.6l13.83-8c2.1-1.21,3.81-.23,3.81,2.2v65.75L82.1,319.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.66,241.54V307.3l21.45,12.38V253.92a8.1,8.1,0,0,1,1.54-4.43L62.22,237.11A8.13,8.13,0,0,0,60.66,241.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.76 250.65 83.89 260.97 83.89 284.72 101.76 274.4 101.76 250.65",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.82 271.55 96.82 253.49 83.89 260.97 83.89 279.03 96.82 271.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.82 271.55 101.76 274.4 83.89 284.72 83.89 279.03 96.82 271.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,252.16l-.65,3.16-.72.4a2.18,2.18,0,0,1-2.18,0l-.13-.08-.28-1.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,257.15l-.66,3.21-.71.4a2.2,2.2,0,0,1-2.19,0l-.13-.08-.28-1.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,229.15c0-2.37,1.79-4.76,4.91-6.57a27,27,0,0,1,13.07-3.1,26.94,26.94,0,0,1,13.06,3.1c3.13,1.81,4.92,4.2,4.92,6.57v2.93c0,2.37-1.79,4.77-4.92,6.57a26.94,26.94,0,0,1-13.06,3.1A27,27,0,0,1,69,238.65c-3.12-1.81-4.91-4.2-4.91-6.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,238.82a26.94,26.94,0,0,0,13.06-3.1c3.13-1.8,4.92-4.2,4.92-6.57s-1.79-4.76-4.92-6.57a26.94,26.94,0,0,0-13.06-3.1A27,27,0,0,0,69,222.58c-3.12,1.81-4.91,4.2-4.91,6.57s1.79,4.77,4.91,6.57A27,27,0,0,0,82.1,238.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,225.13v-38c-.39-3.17,1.5-6.41,5.69-8.83,7.68-4.43,20.13-4.43,27.81,0,3.85,2.22,5.77,5.13,5.76,8h0v40.47h-.07c-.36,2.6-2.24,5.14-5.69,7.13-7.68,4.43-20.13,4.43-27.81,0-3.44-2-5.33-4.53-5.68-7.13h0v-.11A6,6,0,0,1,62.5,225.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,234.76a25.71,25.71,0,0,0,12.64-3c2.61-1.5,4.19-3.38,4.45-5.29l0-.36V199.94c0-2.08-1.64-4.21-4.5-5.87a25.82,25.82,0,0,0-12.64-3,25.83,25.83,0,0,0-12.65,3c-3.09,1.79-4.72,4.1-4.45,6.34l0,.15v24.72l0,.16a5.35,5.35,0,0,0,0,1l0,.16c.3,1.87,1.87,3.71,4.43,5.19A25.72,25.72,0,0,0,82.1,234.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,194.07a26.74,26.74,0,0,1,12.65-3,30,30,0,0,1,12.64,3c2.87,1.35,4.52,3.76,4.5,6.34s-1.63,5-4.5,6.33a29.88,29.88,0,0,1-12.64,3,25.72,25.72,0,0,1-12.65-3c-3.09-1.79-4.45-4-4.45-6.33S66.28,195.82,69.45,194.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,196a26.94,26.94,0,0,0,13.06-3.1c3.13-1.81,4.92-4.2,4.92-6.58s-1.79-4.76-4.92-6.57a26.94,26.94,0,0,0-13.06-3.1A27,27,0,0,0,69,179.77c-3.12,1.81-4.91,4.2-4.91,6.57s1.79,4.77,4.91,6.58A27,27,0,0,0,82.1,196Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,250.79l.76.44,0,.06a1,1,0,0,1,.14.56,2.58,2.58,0,0,1-1.18,2,1,1,0,0,1-.55.16l0,.07-.77-.44h0a.85.85,0,0,1-.34-.77,2.59,2.59,0,0,1,1.17-2A.82.82,0,0,1,89,250.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.71,253.35c0,.75.53,1.05,1.18.67a2.57,2.57,0,0,0,1.17-2c0-.75-.52-1.06-1.17-.68A2.6,2.6,0,0,0,87.71,253.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,245.85l.77.44,0,.06a1.13,1.13,0,0,1,.13.56,2.57,2.57,0,0,1-1.17,2,1,1,0,0,1-.55.16l0,.07-.76-.44h0a.83.83,0,0,1-.35-.76,2.62,2.62,0,0,1,1.18-2A.82.82,0,0,1,97.6,245.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.36,248.41c0,.75.52,1.05,1.17.68a2.62,2.62,0,0,0,1.18-2c0-.75-.53-1.05-1.18-.68A2.61,2.61,0,0,0,96.36,248.41Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.39,264.47c-5.12-5.29-8.13-18.65-3.13-22.84h25.43c5,4.19,2,17.54-3.13,22.83l-.14.15-.18.17-.46.42-.13.09-.38.3a6.9,6.9,0,0,1-.67.43,16.7,16.7,0,0,1-15.26,0h0c-.22-.13-.45-.28-.67-.43l-.36-.28-.15-.12a5.66,5.66,0,0,1-.44-.4l-.21-.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.48,239.94c5.8,3.38,5.8,8.88,0,12.26s-15.21,3.39-21,0-5.8-8.88,0-12.26S340.68,236.55,346.48,239.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.69,241.57c4.26,2.48,4.26,6.52,0,9a16.87,16.87,0,0,1-15.43,0c-4.26-2.48-4.26-6.52,0-9A16.87,16.87,0,0,1,343.69,241.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,245.84a16.87,16.87,0,0,1,15.43,0,7.19,7.19,0,0,1,2.55,2.37,7.17,7.17,0,0,1-2.55,2.36,16.87,16.87,0,0,1-15.43,0,7.09,7.09,0,0,1-2.55-2.36A7.1,7.1,0,0,1,328.26,245.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,221.4c-1.71,2.17-6.87,3.12-9.44-2.19-2.41-5-5-9.68-5.73-11.52a2,2,0,0,1,1.06-2.6s-.07-2.84,4.86-1.29a17.62,17.62,0,0,1,11,8.73C336.61,217,335.65,220.52,332.49,221.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,228.48a24.46,24.46,0,0,0-.63-2.82,39.12,39.12,0,0,0-2-5.39,40.76,40.76,0,0,0-6.33-9.81,34.93,34.93,0,0,0-4.73-4.61c-.05,0-.08.07,0,.11a43.71,43.71,0,0,1,7.54,8.9,44.61,44.61,0,0,1,4.76,10.39c.31,1,.61,2.05.89,3.08s.46,2.12.73,3.18c0,.1.19.16.19,0A19.43,19.43,0,0,0,335.11,228.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,228.48a24.46,24.46,0,0,0-.63-2.82,39.12,39.12,0,0,0-2-5.39,40.76,40.76,0,0,0-6.33-9.81,34.93,34.93,0,0,0-4.73-4.61c-.05,0-.08.07,0,.11a43.71,43.71,0,0,1,7.54,8.9,44.61,44.61,0,0,1,4.76,10.39c.31,1,.61,2.05.89,3.08s.46,2.12.73,3.18c0,.1.19.16.19,0A19.43,19.43,0,0,0,335.11,228.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,217.59c-4.47,1.39-7.79-2.11-6.64-7.58s6.9-11.56,9.07-9.93c1.36-1.35,4.35-.87,5.76,3.58S346.39,219.53,338.08,217.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,203.42a61,61,0,0,0-3,9.84,96.62,96.62,0,0,0-1.72,10.3c-.81,6.69-.94,6.32-.9,13.05,0,1.87,0,3.73.07,5.59s0,3.86.17,5.77c.07.73,1.11.54,1.12-.13.07-3.36-.12-6.73-.15-10.08a23.92,23.92,0,0,1,.06-2.81,140.38,140.38,0,0,1,1.81-20.17c.32-1.86.68-3.71,1.11-5.54s1-3.84,1.52-5.75C340.84,203.41,340.75,203.31,340.71,203.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,203.42a61,61,0,0,0-3,9.84,96.62,96.62,0,0,0-1.72,10.3c-.81,6.69-.94,6.32-.9,13.05,0,1.87,0,3.73.07,5.59s0,3.86.17,5.77c.07.73,1.11.54,1.12-.13.07-3.36-.12-6.73-.15-10.08a23.92,23.92,0,0,1,.06-2.81,140.38,140.38,0,0,1,1.81-20.17c.32-1.86.68-3.71,1.11-5.54s1-3.84,1.52-5.75C340.84,203.41,340.75,203.31,340.71,203.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,232.4c-.58,2.89-4.54,5-9.13,3.08s-13.62-13.81-9.49-15.12c-.23-2.17,12.26-3.94,18.44,3.67C332,229.57,327.73,232.4,327.73,232.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,236.7a20.11,20.11,0,0,0-1.86-2,55.77,55.77,0,0,0-4.21-3.77,56.69,56.69,0,0,0-9.67-6.22A51.18,51.18,0,0,0,312.7,222c-.05,0,0,.09,0,.1,1.67.79,3.34,1.56,4.95,2.46s3.29,2,4.86,3.06a71.52,71.52,0,0,1,8.54,7c.75.72,1.47,1.48,2.23,2.2s1.64,1.43,2.4,2.21c.11.11.3.06.18-.1C335.33,238.19,334.84,237.42,334.28,236.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,236.7a20.11,20.11,0,0,0-1.86-2,55.77,55.77,0,0,0-4.21-3.77,56.69,56.69,0,0,0-9.67-6.22A51.18,51.18,0,0,0,312.7,222c-.05,0,0,.09,0,.1,1.67.79,3.34,1.56,4.95,2.46s3.29,2,4.86,3.06a71.52,71.52,0,0,1,8.54,7c.75.72,1.47,1.48,2.23,2.2s1.64,1.43,2.4,2.21c.11.11.3.06.18-.1C335.33,238.19,334.84,237.42,334.28,236.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.05,237.65c-2.4-1.06-1.94-4.1,1.91-7.2s12.07-3.18,12.15-1.55c1.75.34.69,5.85-4.18,10.15S338.63,241.09,339.05,237.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,233.21a20.27,20.27,0,0,0-9.08,8c-.12.2.19.59.32.37a23.55,23.55,0,0,1,8.76-8.29S345,233.2,345,233.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,233.21a20.27,20.27,0,0,0-9.08,8c-.12.2.19.59.32.37a23.55,23.55,0,0,1,8.76-8.29S345,233.2,345,233.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.54,242.94c-2.78,2.74.3,6.13,4.81,7.8A16.09,16.09,0,0,0,356,250.2a9.49,9.49,0,0,0,2.63-1.63,28.23,28.23,0,0,0-2.3-5.53A11.59,11.59,0,0,0,345,237.81C339.19,238.55,338.72,241,339.54,242.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,245a28.93,28.93,0,0,0-7.07-2.62c-2.42-.47-5.4-.49-7.36,1.23-.76.67-1.77,2.12-1.15,3.15.06.1.36.29.43.09a9.63,9.63,0,0,1,.63-1.9,3.85,3.85,0,0,1,1.51-1.43,9.06,9.06,0,0,1,5.13-.87,28.52,28.52,0,0,1,7.88,2.41S351.25,245,351.22,245Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,245a28.93,28.93,0,0,0-7.07-2.62c-2.42-.47-5.4-.49-7.36,1.23-.76.67-1.77,2.12-1.15,3.15.06.1.36.29.43.09a9.63,9.63,0,0,1,.63-1.9,3.85,3.85,0,0,1,1.51-1.43,9.06,9.06,0,0,1,5.13-.87,28.52,28.52,0,0,1,7.88,2.41S351.25,245,351.22,245Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,225.72c-.7,2.44,2.42,4.73,6.3,3.42s7.92-2.52,11.23-2.56,5.41-2.22,4.73-3.69-1.49-5-9.92-5.95-12.24,2-14,4.31S338.9,226.13,340.31,225.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,220.58a10.45,10.45,0,0,0-2.73-.25,17.82,17.82,0,0,0-2.63.21,20.91,20.91,0,0,0-4.95,1.54c-3,1.32-5.91,3-7.83,5.71a18.5,18.5,0,0,0-2.48,4.64c-.12.32.49.49.63.21a36,36,0,0,1,2.11-4,12.63,12.63,0,0,1,3.23-3.37,25.81,25.81,0,0,1,8.95-4.09,17.19,17.19,0,0,1,2.85-.42,27.43,27.43,0,0,1,2.87.11C356.12,220.83,356.07,220.6,356,220.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,220.58a10.45,10.45,0,0,0-2.73-.25,17.82,17.82,0,0,0-2.63.21,20.91,20.91,0,0,0-4.95,1.54c-3,1.32-5.91,3-7.83,5.71a18.5,18.5,0,0,0-2.48,4.64c-.12.32.49.49.63.21a36,36,0,0,1,2.11-4,12.63,12.63,0,0,1,3.23-3.37,25.81,25.81,0,0,1,8.95-4.09,17.19,17.19,0,0,1,2.85-.42,27.43,27.43,0,0,1,2.87.11C356.12,220.83,356.07,220.6,356,220.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.39,239.5c-.66-2.51-3.84-3.92-8-4.24A10.92,10.92,0,0,0,315,240.58c-2.18,3.73-3.08,6.7-1.76,7.18a72.79,72.79,0,0,0,10.54,1.59c3.62.32,8.13-.33,11.08-3.08S336.84,240.08,333.39,239.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,239.17a10.84,10.84,0,0,0-4.5-.21,19.42,19.42,0,0,0-4.25,1,26.94,26.94,0,0,0-4.21,1.89c-.7.39-1.4.8-2.08,1.23a14.7,14.7,0,0,0-1.86,1.29s0,.1,0,.08a21.23,21.23,0,0,0,2-1.1c.71-.4,1.42-.79,2.14-1.15a28.83,28.83,0,0,1,4.17-1.77,20.13,20.13,0,0,1,4.42-.95,26.89,26.89,0,0,1,4.21.11C333.89,239.59,333.72,239.23,333.55,239.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,239.17a10.84,10.84,0,0,0-4.5-.21,19.42,19.42,0,0,0-4.25,1,26.94,26.94,0,0,0-4.21,1.89c-.7.39-1.4.8-2.08,1.23a14.7,14.7,0,0,0-1.86,1.29s0,.1,0,.08a21.23,21.23,0,0,0,2-1.1c.71-.4,1.42-.79,2.14-1.15a28.83,28.83,0,0,1,4.17-1.77,20.13,20.13,0,0,1,4.42-.95,26.89,26.89,0,0,1,4.21.11C333.89,239.59,333.72,239.23,333.55,239.17Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "384.52 306.21 409.88 291.57 409.88 212.1 384.52 226.74 384.52 306.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.52 226.74 348.3 205.82 348.3 285.3 384.52 306.21 384.52 226.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.3 205.82 384.52 226.74 409.88 212.1 373.66 191.19 348.3 205.82",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.9 278.25 351.92 261.51 351.92 281.65 351.26 282.04 380.24 298.77 380.9 298.38 380.9 278.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 278.63 351.26 261.9 351.26 282.04 380.24 298.77 380.24 278.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,275.48,364,272.64c-.64-.37-1.16-.2-1.16.38a2.33,2.33,0,0,0,1.16,1.71l4.93,2.85c.64.37,1.15.2,1.15-.38A2.31,2.31,0,0,0,368.88,275.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.9 253.93 351.92 237.19 351.92 257.33 351.26 257.72 380.24 274.45 380.9 274.06 380.9 253.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 254.31 351.26 237.58 351.26 257.72 380.24 274.45 380.24 254.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,251.17,364,248.32c-.64-.37-1.16-.2-1.16.38a2.33,2.33,0,0,0,1.16,1.71l4.93,2.85c.64.37,1.15.2,1.15-.38A2.28,2.28,0,0,0,368.88,251.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.9 229.61 351.92 212.88 351.92 233.02 351.26 233.4 380.24 250.13 380.9 249.75 380.9 229.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.24 229.99 351.26 213.26 351.26 233.4 380.24 250.13 380.24 229.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,226.85,364,224c-.64-.37-1.16-.2-1.16.38a2.31,2.31,0,0,0,1.16,1.71l4.93,2.85c.64.37,1.16.2,1.16-.38A2.31,2.31,0,0,0,368.88,226.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.13,204.73a.42.42,0,0,1-.16-.32V181.16a.37.37,0,0,1,.18-.31l15.63-9.12.32.21v23.67l-15.63,9.13A.39.39,0,0,1,353.13,204.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,171.94l-15.63,9.12a.27.27,0,0,0-.13.13.41.41,0,0,0-.05.18v23.25a.12.12,0,0,0,.19.12l15.63-9.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,171.94l-15.63,9.12a.27.27,0,0,0-.13.13.41.41,0,0,0-.05.18v23.25a.12.12,0,0,0,.19.12l15.63-9.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,171.94l-.32-.21-15.63,9.12a.53.53,0,0,0-.13.13l.32.21a.27.27,0,0,1,.13-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.86 172.06 368.85 195.74 373.07 198.47 373.03 174.76 368.86 172.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.86 172.06 368.85 195.74 373.07 198.47 373.03 174.76 368.86 172.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,206a.52.52,0,0,1-.47,0l-.85-.55A.55.55,0,0,1,354,205V181.86a.46.46,0,0,1,.24-.38L367.88,174l1.32.85v23.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.2,198.55,355.52,206a.16.16,0,0,1-.24-.15V182.71a.45.45,0,0,1,.23-.38l13.68-7.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.19,176.3a.67.67,0,0,1,.17-.37s0,0,.06-.05.23,0,.23.19a.6.6,0,0,1-.06.22.36.36,0,0,1-.17.19h0C368.28,176.53,368.19,176.46,368.19,176.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.36,182.49l-1.32-.85a.47.47,0,0,0-.07.22V205a.55.55,0,0,0,.23.42l.85.55a.56.56,0,0,0,.4.06c-.09,0-.16-.05-.17-.17V182.72A.48.48,0,0,1,355.36,182.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,175.43a.87.87,0,0,1-.53.76,3.26,3.26,0,0,1-2.33,0c0-.1.09-.23.12-.29a2.93,2.93,0,0,0,2.05,0,.73.73,0,0,0,.31-.27.41.41,0,0,0,.06-.23c0-.3-.28-.64-.74-.92a3.39,3.39,0,0,0-2.85-.36.72.72,0,0,0-.34.33l-.34.18v0a.67.67,0,0,1,.1-.39,1,1,0,0,1,.42-.37,3.68,3.68,0,0,1,3.16.37A1.63,1.63,0,0,1,371.26,175.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,206.46a.42.42,0,0,1-.16-.32V182.89a.37.37,0,0,1,.18-.3L373,174.45l.32.2v23.68l-17.15,8.14A.39.39,0,0,1,355.81,206.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.31,174.65l-17.15,8.14a.4.4,0,0,0-.13.13.31.31,0,0,0,0,.18v23.25a.12.12,0,0,0,.19.12l17.15-8.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.31,174.65l-.32-.2-17.15,8.13a.35.35,0,0,0-.13.14l.32.2a.4.4,0,0,1,.13-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.11 171.94 373.3 174.65 373.03 174.76 368.86 172.06 369.11 171.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07,175.19a.31.31,0,0,1,.3,0l.33.21-.2,22.76a.86.86,0,0,1-.43.71l-16.42,8.34V183.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,175.4c.24-.12.43,0,.43.28v22.69a.86.86,0,0,1-.43.71L357,207.41V183.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,175.4c.24-.12.43,0,.43.28v22.69a.86.86,0,0,1-.43.71L357,207.41V183.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,205.66l12.16-6.18a.83.83,0,0,0,.43-.7V177.71l1.59-.8-1.63-1,0,0a.26.26,0,0,0-.36-.07l-13.92,7.07v23.68l1.77,1.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,177c.24-.12.43,0,.43.27v22.7a.85.85,0,0,1-.43.7L361,207.71V184Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.01 184.03 359.24 182.88 359.23 206.56 361 207.71 361.01 184.03",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,184.66a.5.5,0,0,1,0-.16.35.35,0,0,1,.13-.2l.06-.05c.13-.07.23,0,.23.18a.4.4,0,0,1-.06.22.42.42,0,0,1-.17.2h0C361.67,184.9,361.59,184.82,361.59,184.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,185.71a1.09,1.09,0,0,0,.45-.39.75.75,0,0,0,.05-.67.92.92,0,0,0-.23-.35.35.35,0,0,0-.13.2.58.58,0,0,1,.16.36c0,.24-.11.47-.43.63a2.33,2.33,0,0,1-2.1-.14c-.58-.38-.59-.92,0-1.22v-.27l-.11,0a1,1,0,0,0-.45.39h0a.73.73,0,0,0-.06.67,1.22,1.22,0,0,0,.51.58A2.55,2.55,0,0,0,361.48,185.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,186.13,376.2,177l-.23-.15a.45.45,0,0,0-.42,0l-14.76,9.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,177c.24-.12.43,0,.43.27V200a.85.85,0,0,1-.43.71l-15,9.23V186.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.65 183.53 356.64 207.21 360.86 209.94 360.86 186.25 356.65 183.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.49,188.39a.69.69,0,0,1,.56-.35,1.18,1.18,0,0,1,.72.22,2.82,2.82,0,0,1,1.17,2.12,1.2,1.2,0,0,1-.14.59c-.25.41-.76.46-1.28.13a2.8,2.8,0,0,1-1.18-2.12,1.1,1.1,0,0,1,.15-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,188.46c-.58-.37-1.05-.13-1.05.54a2.55,2.55,0,0,0,1.05,1.9c.58.37,1.06.13,1.06-.54A2.56,2.56,0,0,0,358.64,188.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.85,193l-.32-.21c-.64-.41-1.16-.15-1.16.59v11.28a2.78,2.78,0,0,0,1.16,2.08l.32.21c.64.41,1.16.15,1.16-.59V195.09A2.78,2.78,0,0,0,358.85,193Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.9 183.4 361.1 186.11 360.86 186.25 356.65 183.53 356.9 183.4",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.19,210.41a.42.42,0,0,1-.16-.32V186.84a.37.37,0,0,1,.18-.31l15.63-9.12.32.21v23.67l-15.63,9.13A.39.39,0,0,1,362.19,210.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,177.62l-15.63,9.12a.27.27,0,0,0-.13.13.31.31,0,0,0-.05.18V210.3a.12.12,0,0,0,.19.12l15.63-9.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,177.62l-15.63,9.12a.27.27,0,0,0-.13.13.31.31,0,0,0-.05.18V210.3a.12.12,0,0,0,.19.12l15.63-9.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,177.62l-.32-.21-15.63,9.12a.4.4,0,0,0-.13.13l.32.21a.27.27,0,0,1,.13-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.92 177.74 377.91 201.42 382.13 204.15 382.09 180.44 377.92 177.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.92 177.74 377.91 201.42 382.13 204.15 382.09 180.44 377.92 177.74"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,211.69a.52.52,0,0,1-.47,0l-.85-.55a.55.55,0,0,1-.23-.42V187.54a.46.46,0,0,1,.24-.38l13.67-7.46,1.32.85v23.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,204.23l-13.68,7.46a.16.16,0,0,1-.24-.15V188.39a.45.45,0,0,1,.23-.38l13.68-7.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.25,182a.67.67,0,0,1,.17-.37s0,0,.06-.05.23,0,.23.19a.9.9,0,0,1-.06.22.36.36,0,0,1-.17.19s0,0,0,0S377.25,182.14,377.25,182Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,188.17l-1.32-.85a.47.47,0,0,0-.07.22v23.14a.59.59,0,0,0,.24.42l.85.55a.56.56,0,0,0,.4.06c-.09,0-.16-.05-.17-.17V188.4A.48.48,0,0,1,364.42,188.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,181.11a.87.87,0,0,1-.53.76,3.26,3.26,0,0,1-2.33,0c0-.1.09-.23.12-.29a2.93,2.93,0,0,0,2.05,0,.79.79,0,0,0,.31-.27.41.41,0,0,0,.06-.23c0-.3-.28-.64-.74-.92a3.39,3.39,0,0,0-2.85-.36.72.72,0,0,0-.34.33l-.34.18v0a.67.67,0,0,1,.1-.39,1,1,0,0,1,.42-.37,3.68,3.68,0,0,1,3.16.37A1.63,1.63,0,0,1,380.32,181.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,212.14a.42.42,0,0,1-.16-.32V188.57a.37.37,0,0,1,.18-.3l17.15-8.14.32.2V204l-17.15,8.14A.39.39,0,0,1,364.87,212.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,180.33l-17.15,8.14a.4.4,0,0,0-.13.13.43.43,0,0,0-.06.18V212a.12.12,0,0,0,.19.12L382.37,204Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,180.33l-.32-.2-17.15,8.13a.35.35,0,0,0-.13.14l.32.2a.4.4,0,0,1,.13-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.17 177.62 382.36 180.33 382.09 180.44 377.92 177.74 378.17 177.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,180.88a.29.29,0,0,1,.3,0l.33.21-.2,22.76a.86.86,0,0,1-.43.71l-16.43,8.34V189.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,181.08c.24-.12.43,0,.43.28v22.69a.86.86,0,0,1-.43.71L366,213.09V189.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,181.08c.24-.12.43,0,.43.28v22.69a.86.86,0,0,1-.43.71L366,213.09V189.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.06,211.34l12.16-6.18a.83.83,0,0,0,.43-.7V183.39l1.59-.8-1.63-1.05,0,0a.26.26,0,0,0-.36-.07l-13.92,7.07v23.68l1.77,1.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,182.64c.24-.12.43,0,.43.27v22.7a.85.85,0,0,1-.43.7l-13.93,7.08V189.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.07 189.71 368.3 188.56 368.29 212.24 370.06 213.39 370.07 189.71",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.65,190.34a.5.5,0,0,1,0-.16.35.35,0,0,1,.13-.2l.06,0c.13-.07.23,0,.23.18a.4.4,0,0,1-.06.22.42.42,0,0,1-.17.2h0C370.73,190.58,370.65,190.5,370.65,190.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.54,191.39A1.09,1.09,0,0,0,371,191a.75.75,0,0,0,.05-.67.92.92,0,0,0-.23-.35.35.35,0,0,0-.13.2.58.58,0,0,1,.16.36.64.64,0,0,1-.43.63,2.33,2.33,0,0,1-2.1-.14c-.58-.38-.59-.92,0-1.22v-.27l-.11.05a1,1,0,0,0-.45.39h0a.7.7,0,0,0-.06.66,1.22,1.22,0,0,0,.51.58A2.55,2.55,0,0,0,370.54,191.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,191.81l15.09-9.11-.23-.15a.45.45,0,0,0-.42,0l-14.76,9.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,182.71c.24-.12.43,0,.43.27v22.69a.85.85,0,0,1-.43.71l-15,9.23V191.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.71 189.21 365.7 212.89 369.92 215.62 369.92 191.94 365.71 189.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.55,194.07a.69.69,0,0,1,.55-.35,1.19,1.19,0,0,1,.73.22,2.82,2.82,0,0,1,1.17,2.12,1.2,1.2,0,0,1-.14.59c-.25.41-.76.46-1.28.13a2.8,2.8,0,0,1-1.18-2.12,1.1,1.1,0,0,1,.15-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7,194.14c-.58-.37-1.05-.13-1.05.54a2.55,2.55,0,0,0,1.05,1.9c.58.37,1.06.13,1.06-.54A2.59,2.59,0,0,0,367.7,194.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91,198.69l-.32-.21c-.64-.41-1.16-.15-1.16.59v11.28a2.78,2.78,0,0,0,1.16,2.08l.32.21c.64.41,1.16.15,1.16-.59V200.77A2.78,2.78,0,0,0,367.91,198.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.96 189.08 370.16 191.79 369.92 191.94 365.71 189.21 365.96 189.08",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M402,212a3.11,3.11,0,0,1-.49,1.13,5.26,5.26,0,0,1-1.83,1.62,12.61,12.61,0,0,1-11.44,0,5.26,5.26,0,0,1-1.83-1.62,2.93,2.93,0,0,1-.48-1.13h0c-.28-1.37.49-2.8,2.32-3.85a12.61,12.61,0,0,1,11.44,0C401.52,209.2,402.29,210.63,402,212Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.43,205.79H387.51l1.33,5.57h0a2.76,2.76,0,0,0,1.49,1.84,8,8,0,0,0,7.28,0,2.63,2.63,0,0,0,1.5-2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,209.61a5.81,5.81,0,0,0,.77-.54l.73-3a5.05,5.05,0,0,1-1.31,1,11.3,11.3,0,0,1-9.91.13l.32-1.33-.1-.14h-1.85l1.33,5.57h0a2.76,2.76,0,0,0,1.49,1.84,8.08,8.08,0,0,0,5.29.71c-3.22.24-5.43-1.17-5.76-2.47-.13-.52-.36-1.66-.36-1.66A10.81,10.81,0,0,0,398.86,209.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,204.14a2.62,2.62,0,0,1-.43,1,4.82,4.82,0,0,1-1.62,1.44,11.23,11.23,0,0,1-10.16,0,4.82,4.82,0,0,1-1.62-1.44,2.78,2.78,0,0,1-.43-1h0c-.25-1.21.43-2.48,2.05-3.42a11.23,11.23,0,0,1,10.16,0C400.67,201.66,401.35,202.93,401.1,204.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.67,205.15a4.82,4.82,0,0,1-1.62,1.44,11.23,11.23,0,0,1-10.16,0,4.82,4.82,0,0,1-1.62-1.44,2.78,2.78,0,0,1-.43-1h0l.32,2.19a3.6,3.6,0,0,0,2,2.42,10.72,10.72,0,0,0,9.68,0,3.67,3.67,0,0,0,2-2.38l0-.12.3-2.11A2.62,2.62,0,0,1,400.67,205.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,201.21a9.34,9.34,0,0,0-8.46,0c-1.33.77-1.9,1.8-1.73,2.79a3.22,3.22,0,0,0,1.73,2.1,9.34,9.34,0,0,0,8.46,0,3.23,3.23,0,0,0,1.73-2.09C400.1,203,399.53,202,398.2,201.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,204.93a3.87,3.87,0,0,0,1.33,1.17,9.34,9.34,0,0,0,8.46,0,3.87,3.87,0,0,0,1.33-1.17,2.79,2.79,0,0,0-1.63-2.23,8.64,8.64,0,0,0-7.86,0A2.79,2.79,0,0,0,388.41,204.93Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.42,202.42c-1.08-.29-1.26-2.62-.66-5.08s2.46-6,2.86-5.89.9,4,.62,6.54C396.9,201.11,395.49,202.71,394.42,202.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.94,194.89c.19.31.31.82.76.82s.56-.38.88-.47a.88.88,0,0,1,.72.22,2.62,2.62,0,0,0,0-.28,1.06,1.06,0,0,0-.62-.22.93.93,0,0,0-.52.24c-.17.13-.37.32-.61.23s-.33-.44-.47-.66a.78.78,0,0,0-.28-.29l-.09.2A.61.61,0,0,1,394.94,194.89Zm1.28-1c.15-.07.24-.23.36-.34a.51.51,0,0,1,.55-.11h0l0-.24-.1,0a.64.64,0,0,0-.45.1c-.15.11-.23.29-.39.38s-.5-.13-.59-.36-.06-.21-.1-.32a1.3,1.3,0,0,0-.08.17,1.8,1.8,0,0,0,.06.22C395.56,193.71,395.85,194.11,396.22,193.93Zm0,3.11c-.2.12-.36.32-.59.38-.55.16-.68-.69-1-.94a.77.77,0,0,0-.5-.14c0,.07-.05.14-.07.2a.66.66,0,0,1,.28,0,.8.8,0,0,1,.49.43c.17.32.4.77.84.69a1.48,1.48,0,0,0,.52-.29,1,1,0,0,1,.75-.21,1.15,1.15,0,0,1,.42.23c0-.08,0-.17,0-.25a1,1,0,0,0-.51-.23A.93.93,0,0,0,396.18,197Zm.34,1.88a1.11,1.11,0,0,0-.74.09c-.25.13-.44.38-.71.48-.58.22-.67-.63-1.1-.83a.85.85,0,0,0-.44-.09l0,.2h.17a.78.78,0,0,1,.6.47c.21.39.48.7,1,.47.25-.12.43-.36.69-.47a.83.83,0,0,1,.87.08,2.12,2.12,0,0,1,.17.2l.06-.25A.89.89,0,0,0,396.52,198.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.42,202.42c1.07.29,2.48-1.31,2.82-4.43a18,18,0,0,0,.06-2.67,10.27,10.27,0,0,0-1.76,2.19,23.63,23.63,0,0,0-1-2.35,16.53,16.53,0,0,0-.74,2.18C393.16,199.8,393.34,202.13,394.42,202.42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,203.71c-1.41.91-2.73-2.32-3.43-4.76s-.25-8.8.47-9.15c.5-.24,3.17,5.46,3.69,8.24C394.65,200.05,394.67,203,393.54,203.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,194.3a.85.85,0,0,0,1.15-.16c.32-.34.55-.78,1.06-.73l-.15-.33a.66.66,0,0,0-.24,0c-.44.11-.64.57-.95.86-.47.44-1-.14-1.51-.11h-.05c0,.09,0,.19,0,.29A1.35,1.35,0,0,1,390.49,194.3Zm3.89,4.38-.24-.07a.86.86,0,0,0-.66.15c-.43.32-.45,1-1.14.83-.53-.14-.92-.48-1.47-.21a1.92,1.92,0,0,0-.51.39,2.25,2.25,0,0,0,.08.24,1.52,1.52,0,0,1,.69-.43c.59-.15,1,.45,1.63.35s.54-.61.87-.87a.77.77,0,0,1,.79-.05C394.41,198.9,394.39,198.79,394.38,198.68ZM390.52,192c.16.23.39.48.7.32s.35-.57.56-.83a2.26,2.26,0,0,0-.11-.22c-.2.28-.31.87-.7.85s-.43-.47-.68-.6a.42.42,0,0,0-.26,0l0,.19h.06C390.28,191.65,390.4,191.83,390.52,192Zm1.06,4.83c.56.12.83-.54,1.08-.91a1.66,1.66,0,0,1,.78-.66l-.12-.3a1,1,0,0,0-.29.11,2.05,2.05,0,0,0-.6.61,2.41,2.41,0,0,1-.57.76c-.3.2-.65-.11-1-.16a1.59,1.59,0,0,0-.86.07,1.51,1.51,0,0,0-.26.12c0,.14,0,.28,0,.41a1.32,1.32,0,0,1,.91-.3A3.77,3.77,0,0,1,391.58,196.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,195.51a7.83,7.83,0,0,0-1.14,1.88,25.18,25.18,0,0,0-2.61-3,16.82,16.82,0,0,0,.33,4.59c.7,2.44,2,5.67,3.43,4.76,1.13-.72,1.11-3.66.73-5.67A16.83,16.83,0,0,0,393.53,195.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.45,205.37a8.21,8.21,0,0,1-6.57-3.4c-1.57-2-2.79-6.05-2.44-6.3s4.53,2.32,6.09,4.18A16.5,16.5,0,0,1,393.45,205.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.8,198.89a1.21,1.21,0,0,0,0-.8.7.7,0,0,1,.1-.5l-.29-.2a1,1,0,0,0-.11.7c0,.29.12.67-.28.72s-1-.33-1.39.1c-.16.21-.1.48-.11.72a.59.59,0,0,1-.09.31l.14.3a.93.93,0,0,0,.2-.44c0-.3-.08-.69.32-.75a3.37,3.37,0,0,1,.83.1A.63.63,0,0,0,387.8,198.89Zm-1.44-2.16a.68.68,0,0,1,.12-.12l-.24-.14c-.19.25-.19.59-.38.84a.43.43,0,0,1-.49.14.75.75,0,0,0-.53,0,.39.39,0,0,0-.11.06l.06.19a.5.5,0,0,1,.27-.08,5.21,5.21,0,0,0,.57.08.45.45,0,0,0,.34-.17C386.19,197.32,386.2,197,386.36,196.73Zm2.87,3.47a1.34,1.34,0,0,0,.39-.67,4.63,4.63,0,0,0,.06-.55l-.24-.21a2.48,2.48,0,0,1-.18.89.81.81,0,0,1-.81.42.88.88,0,0,0-.69.22,1.24,1.24,0,0,0-.25.7,1.09,1.09,0,0,1-.45.89.91.91,0,0,1-.17.09l.18.22a1,1,0,0,0,.37-.27c.44-.52.08-1.54,1-1.54A1.16,1.16,0,0,0,389.23,200.2Zm1.39.26a1,1,0,0,1,.19-.27c-.07-.1-.15-.19-.22-.28a1.71,1.71,0,0,0-.42.81,2.4,2.4,0,0,1-.34,1c-.22.28-.58.25-.88.42a1.28,1.28,0,0,0-.55.64,2.88,2.88,0,0,0-.13.65l.27.23v0a1.6,1.6,0,0,1,.38-1c.28-.26.65-.22.94-.42C390.43,201.76,390.33,201,390.62,200.46Zm1.12,1.08a1.29,1.29,0,0,0-.21.19c-.45.48-.39,1.11-.55,1.71a1.06,1.06,0,0,1-.55.73c-.25.11-.53,0-.74.2l0,0a2.93,2.93,0,0,0,.39.21.71.71,0,0,1,.21,0,.91.91,0,0,0,.4-.1,1.12,1.12,0,0,0,.49-.54c.27-.55.15-1.23.49-1.75a1.29,1.29,0,0,1,.28-.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.62,197.37c.25,2.14,1.39,7.9,5.83,8a16.5,16.5,0,0,0-2.92-5.52A15.53,15.53,0,0,0,387.62,197.37Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.45,205.37c-2-.3-3.78-1.59-4.68-5.42s-1-5.55-.42-5.94,3.49,3.43,4.38,5.12C395,203.4,393.45,205.37,393.45,205.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,198.29c.51.16,1.17.33,1.55-.17a4.78,4.78,0,0,0,.37-.84l-.28-.39c-.22.36-.21.9-.61,1.1a1.23,1.23,0,0,1-.94,0,2,2,0,0,0-.93-.14,1.19,1.19,0,0,0-.49.17c0,.11.05.23.07.35l.21-.1A1.52,1.52,0,0,1,389.67,198.29Zm-.6-2a.9.9,0,0,0,.48.09c.3-.07.47-.36.62-.61a1.56,1.56,0,0,1,.16-.2,2.11,2.11,0,0,1-.19-.23l0,0c-.19.24-.35.71-.71.72a2.29,2.29,0,0,1-.51-.15,1.3,1.3,0,0,0-.44,0,1.07,1.07,0,0,0-.4.15l0,.28a1,1,0,0,1,1-.08Zm2.22,4.25a3.29,3.29,0,0,1,.62-.81,1.37,1.37,0,0,1,1-.18c-.07-.14-.14-.29-.22-.43a1.67,1.67,0,0,0-.7,0,1.53,1.53,0,0,0-.78.57,4.19,4.19,0,0,1-.52.75c-.41.38-1,0-1.43-.05a2.83,2.83,0,0,0-.41,0c0,.14.07.27.11.39a2.14,2.14,0,0,1,.54.08C390.23,201.11,390.83,201.24,391.29,200.56Zm2.34.75a.38.38,0,0,0-.1,0,1.58,1.58,0,0,0-.69.51c-.2.26-.3.57-.49.83a.63.63,0,0,1-.8.27,1.4,1.4,0,0,0-.9-.07,1.56,1.56,0,0,0-.56.35,3.21,3.21,0,0,0,.21.3,1.18,1.18,0,0,1,.43-.26.94.94,0,0,1,.7.09,1.09,1.09,0,0,0,1.44-.44c.18-.25.28-.55.47-.79a1.21,1.21,0,0,1,.42-.33C393.73,201.64,393.68,201.48,393.63,201.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,199.13c-.16-.3-.38-.68-.65-1.09-.87,2.72-1.16,6.68,1.37,7.33C393.45,205.37,395,203.4,392.73,199.13Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,205.37a8.21,8.21,0,0,0,6.56-3.4c1.57-2,2.79-6.05,2.44-6.3s-4.53,2.32-6.09,4.18A16.59,16.59,0,0,0,394.5,205.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.78,199.15a3.37,3.37,0,0,1,.83-.1c.41.06.29.45.33.75a.91.91,0,0,0,.19.44l.14-.3a.59.59,0,0,1-.09-.31c0-.24.06-.51-.11-.72-.35-.43-.95,0-1.39-.1s-.32-.43-.28-.72a1,1,0,0,0-.11-.7l-.29.2a.76.76,0,0,1,.11.5,1.15,1.15,0,0,0,0,.8A.64.64,0,0,0,400.78,199.15Zm1.19-1.6a.45.45,0,0,0,.34.17,5.21,5.21,0,0,0,.57-.08.46.46,0,0,1,.27.08c0-.07,0-.13.06-.19l-.1-.06a.77.77,0,0,0-.54,0,.43.43,0,0,1-.49-.14c-.19-.25-.19-.59-.38-.84l-.23.14.11.12C401.74,197,401.75,197.32,402,197.55Zm-2.47,2.84c.92,0,.57,1,1,1.54a1,1,0,0,0,.37.27l.19-.22a1.51,1.51,0,0,1-.18-.09,1.05,1.05,0,0,1-.44-.89,1.33,1.33,0,0,0-.26-.7.87.87,0,0,0-.69-.22.81.81,0,0,1-.81-.42,2.71,2.71,0,0,1-.18-.89l-.24.21a4.63,4.63,0,0,0,.06.55,1.29,1.29,0,0,0,.4.67A1.12,1.12,0,0,0,399.5,200.39Zm-1.43,1.77c.29.2.66.16.94.42a1.6,1.6,0,0,1,.38,1v0l.28-.23a3.58,3.58,0,0,0-.14-.65,1.28,1.28,0,0,0-.55-.64c-.3-.17-.66-.14-.88-.42a2.4,2.4,0,0,1-.34-1,1.69,1.69,0,0,0-.41-.81,3.11,3.11,0,0,0-.23.28,1.35,1.35,0,0,1,.2.27C397.61,201,397.51,201.76,398.07,202.16Zm-2.06-.3a1.29,1.29,0,0,1,.28.33c.34.52.22,1.2.49,1.75a1.12,1.12,0,0,0,.49.54,1,1,0,0,0,.4.1.82.82,0,0,1,.22,0,2.82,2.82,0,0,0,.38-.21l0,0c-.21-.19-.49-.09-.74-.2a1.06,1.06,0,0,1-.55-.73c-.16-.6-.1-1.23-.54-1.71l-.21-.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.32,197.37c-.25,2.14-1.39,7.9-5.82,8a16.59,16.59,0,0,1,2.91-5.52A15.86,15.86,0,0,1,400.32,197.37Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,205.37c2-.3,3.77-1.59,4.67-5.42s1-5.55.42-5.94-3.49,3.43-4.38,5.12C393,203.4,394.5,205.37,394.5,205.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,198.24l.2.1c0-.12.05-.24.07-.35a1.19,1.19,0,0,0-.49-.17,2,2,0,0,0-.93.14,1.23,1.23,0,0,1-.94,0c-.39-.2-.39-.74-.61-1.1-.09.13-.19.26-.27.39a4.72,4.72,0,0,0,.36.84c.38.5,1,.33,1.55.17A1.55,1.55,0,0,1,399.33,198.24Zm0-2a1.18,1.18,0,0,1,.54.17c0-.09,0-.19,0-.28a1.19,1.19,0,0,0-.41-.15,1.3,1.3,0,0,0-.44,0,2.29,2.29,0,0,1-.51.15c-.35,0-.52-.48-.71-.72l0,0a2.11,2.11,0,0,1-.19.23,1.56,1.56,0,0,1,.16.2c.16.25.32.54.63.61a.88.88,0,0,0,.47-.09A1.22,1.22,0,0,1,399.33,196.22Zm-.93,4.67a2.14,2.14,0,0,1,.54-.08c0-.12.07-.25.11-.39a2.83,2.83,0,0,0-.41,0c-.46.09-1,.43-1.43.05a4.19,4.19,0,0,1-.52-.75,1.53,1.53,0,0,0-.78-.57,1.67,1.67,0,0,0-.7,0c-.08.14-.15.29-.22.43a1.37,1.37,0,0,1,1,.18,2.87,2.87,0,0,1,.62.81C397.11,201.24,397.71,201.11,398.4,200.89Zm-4.22.91a1.21,1.21,0,0,1,.42.33c.19.24.29.54.47.79a1.09,1.09,0,0,0,1.44.44.94.94,0,0,1,.7-.09,1.18,1.18,0,0,1,.43.26,3.3,3.3,0,0,0,.22-.3,1.69,1.69,0,0,0-.57-.35,1.36,1.36,0,0,0-.89.07.64.64,0,0,1-.81-.27c-.19-.26-.29-.57-.49-.83a1.53,1.53,0,0,0-.69-.51.38.38,0,0,0-.1,0C394.26,201.48,394.22,201.64,394.18,201.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,199.13c.16-.3.39-.68.65-1.09.88,2.72,1.16,6.68-1.36,7.33C394.5,205.37,393,203.4,395.21,199.13Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,205.79c1.72,0,2.29-2.34,2.11-4.21s-1.35-5.46-2.11-5.46-1.94,3.58-2.11,5.46S392.26,205.79,394,205.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,198.57a1.46,1.46,0,0,0,.64-.46,1.12,1.12,0,0,1,.53-.27c-.05-.11-.09-.22-.13-.33a1.62,1.62,0,0,0-.73.45,1,1,0,0,1-.36.27c-.2.07-.33,0-.47-.18a1.12,1.12,0,0,0-.56-.34h0l-.1.27a1.06,1.06,0,0,1,.59.34A.66.66,0,0,0,394,198.57Zm-1.28,2.06c.57.44,1-.19,1.41-.57a.64.64,0,0,1,1-.09,2.38,2.38,0,0,0,.66.48l.19,0c0-.1,0-.21-.07-.32a2,2,0,0,1-.69-.46c-.51-.42-1-.25-1.38.22-.23.26-.61.72-1,.44-.23-.17-.33-.46-.57-.62h0c0,.1-.05.19-.07.28C392.35,200.17,392.47,200.46,392.68,200.63Zm.64,2.05a.73.73,0,0,0,1.17.17c.21-.18.35-.44.59-.59a1.08,1.08,0,0,1,1,0V202a2.67,2.67,0,0,0-.48-.15.93.93,0,0,0-.74.15c-.24.17-.39.44-.62.62a.59.59,0,0,1-.5.16c-.19-.07-.31-.32-.45-.46a1.41,1.41,0,0,0-.67-.38,1.21,1.21,0,0,0-.82.08v.29A1.22,1.22,0,0,1,393.32,202.68Zm1.63,1.75a1.36,1.36,0,0,1-1,.29.81.81,0,0,1-.49-.21c-.09-.1-.16-.22-.26-.32a1.18,1.18,0,0,0-.64-.32,1.38,1.38,0,0,0-.54,0c0,.1.06.21.1.31a.88.88,0,0,1,.85.11c.21.16.31.41.52.55a1.22,1.22,0,0,0,.67.17,1.55,1.55,0,0,0,.71-.17c.25-.13.43-.36.67-.49a.82.82,0,0,1,.19-.09c.05-.13.09-.26.13-.39a1,1,0,0,0-.24.05A2.3,2.3,0,0,0,395,204.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.89,146.44a18.3,18.3,0,0,0-3.59,36.29l2,5.33a1.06,1.06,0,0,0,2,0l2.14-5.27a18.3,18.3,0,0,0-2.51-36.38Zm11.86,30-1.41,1.31a16.85,16.85,0,0,1-23.4-24.11l1.35-1.38a16.85,16.85,0,0,1,23.46,24.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.49,165a16.82,16.82,0,0,1-4.74,11.45l-1.41,1.31a16.85,16.85,0,0,1-23.4-24.11l1.35-1.38A16.86,16.86,0,0,1,455.49,165Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.06,174.48a2.63,2.63,0,0,1-1.93-.84l-6-6.4a2.65,2.65,0,0,1,3.87-3.62l3.89,4.16,9.22-11.67a2.64,2.64,0,1,1,4.15,3.28l-11.12,14.08a2.64,2.64,0,0,1-2,1Z",
    style: {
      fill: "#008C8E"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.22,250.81c1.41,1.15,2.85,2.93,5.24,5s6,5.6,9.49,7.76,5.21,3,9.7-1.42A121.64,121.64,0,0,0,426,248.45l.26-16.83c-3.73,1-5.89,3-8.25,6.44-4.45,6.51-7.46,10.71-10,14.47,0,0-10.26-6.32-11.59-7.32a5.54,5.54,0,0,1-2.06-3,25.84,25.84,0,0,0-1-3c-.4-1-.55-1.43-1-2.72s-.77-3.46-.91-3.94-1.1-.52-1.81.78a5.26,5.26,0,0,0-.37,2.59c0,.79.24,1.75,0,1.87s-1.35-.47-2.47-.77-2.1-.8-3.35-.46a1.47,1.47,0,0,0-1.07,1.92,1.91,1.91,0,0,0,.65.77,1.59,1.59,0,0,0-1.21.34,1.72,1.72,0,0,0-.09,2.18,1,1,0,0,0-1,.83c-.15.74-.09,1.47.64,1.78,0,0-.61.13-.66.48a1.78,1.78,0,0,0,.53,1.64,5.67,5.67,0,0,0,2.1.55s.1.27.8.65a17.14,17.14,0,0,0,2.31,1.33A14.85,14.85,0,0,1,390.22,250.81Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,252.53a8.17,8.17,0,0,1,3.42,5.5,6.25,6.25,0,0,0-2.93-6.22Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.25,231.54a11.78,11.78,0,0,0-5.57,3.09c-1.59,1.53-4.47,5.92-6.18,8.36L411,248s-.21,6.39,7.78,10l7.53-9.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.35,245.41a.63.63,0,0,1-.16.53,4.38,4.38,0,0,1-.54.51,2.09,2.09,0,0,1-.29.23,1.07,1.07,0,0,1-.32.16l-.73.24a3,3,0,0,0,.79,0,1,1,0,0,0,.4-.14,3.43,3.43,0,0,0,.33-.24,3.08,3.08,0,0,0,.53-.6.83.83,0,0,0,.13-.41.73.73,0,0,0-.08-.25,3.42,3.42,0,0,0,.59-.21,1.89,1.89,0,0,0,.84-.55,1.48,1.48,0,0,0,.18-.48.86.86,0,0,0,0-.16l.24-.33a4.25,4.25,0,0,0,1,1.8,5.1,5.1,0,0,0,2.06,1.43,4.46,4.46,0,0,1-2-5.61l0,0a.73.73,0,0,0,.25-.28,1,1,0,0,0,0-.69,2,2,0,0,0-.29-.59,3.69,3.69,0,0,0-2.09-1.27A1.7,1.7,0,0,0,386,238a3,3,0,0,0-.42-.38,2.93,2.93,0,0,1,.37.42,1.47,1.47,0,0,1,.25.48v0h0a3.83,3.83,0,0,1,1.94,1.31,1,1,0,0,1,.21,1c-.1.18-.16.23-.36.19s-.39-.08-.59-.11c-.41-.07-.82-.09-1.22-.15a4.64,4.64,0,0,1-1.14-.33c-.37-.16-.72-.35-1.08-.55a6.85,6.85,0,0,1-1-.63,9.67,9.67,0,0,0,2,1.36,3.81,3.81,0,0,0,1.18.39c.41.07.82.1,1.21.17l.24.05a.73.73,0,0,1,.25.48.84.84,0,0,1-.44.8,4.89,4.89,0,0,1-.9.48,2.63,2.63,0,0,1-1,.2,7,7,0,0,1-1.94-.65c-.65-.27-1.3-.53-2-.76.62.34,1.25.65,1.88.95l1,.45a3.07,3.07,0,0,0,1.06.28,2.85,2.85,0,0,0,.66-.11,1,1,0,0,1,.54.37.45.45,0,0,1,.07.39,1.27,1.27,0,0,1-.18.39,2.09,2.09,0,0,1-.76.44,1.86,1.86,0,0,1-.86.2,3.36,3.36,0,0,1-.87-.28,5.16,5.16,0,0,0-.94-.23c-.63-.11-1.26-.19-1.9-.24l1.86.45a9.21,9.21,0,0,1,.9.25,3.75,3.75,0,0,0,.93.33A1.66,1.66,0,0,0,385.35,245.41Zm2.44-4.12h0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.56,230.11a66.46,66.46,0,0,1,7.32,1.77c2.76.85,5.1,1.62,7,2.33a94.89,94.89,0,0,1-1.64,20.38c-.47,2.19-2.07,8.26-2.35,12.91a74.53,74.53,0,0,0,.39,14.51s-7.16,5.32-22.47,4.17c-12-.91-13.59-5.34-13.59-5.34s.22-20,.53-28.9c.41-11.65,3.94-18.37,6.54-20.4l7.89-1.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.52,230.61l.89.18a56.73,56.73,0,0,1,6.33,1.57c2.69.83,4.87,1.55,6.64,2.2a94.42,94.42,0,0,1-1.64,19.92c-.08.4-.21.92-.35,1.53a75.53,75.53,0,0,0-2,11.46,72.92,72.92,0,0,0,.37,14.29c-1.19.77-7,4.08-17.69,4.08-1.38,0-2.8-.06-4.23-.16-10.65-.81-12.85-4.41-13.12-4.94,0-1.6.24-20.36.53-28.78.43-12,4.08-18.16,6.25-20l7.72-1.28,10.31-.12m0-.5-10.39.12-7.89,1.31c-2.6,2-6.13,8.75-6.54,20.4-.31,8.86-.53,28.9-.53,28.9s1.56,4.43,13.59,5.34c1.49.11,2.91.16,4.26.16,12.38,0,18.21-4.33,18.21-4.33a74.53,74.53,0,0,1-.39-14.51c.28-4.65,1.88-10.72,2.35-12.91a94.89,94.89,0,0,0,1.64-20.38c-1.89-.71-4.23-1.48-7-2.33a66.46,66.46,0,0,0-7.32-1.77Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.92,205a4.29,4.29,0,0,1,3.16,2.54c.62,1.21,1.07,3.41-.64,9.7a25.65,25.65,0,0,1-3,6.95,3.13,3.13,0,0,1-1.81,1.44l.13-4.84.18-3.37s-2.72-2.46-3-4.88a7.8,7.8,0,0,1,.91-4.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.58,205.11c-.47-2.72-3.92-6-10.57-6.32-5.45-.29-8.52,2.57-10.42,5.75a6.36,6.36,0,0,0-.32,6.05l16.68-.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.15,222.16c-2.51,1.22-3.65-.76-3.65-.76l0,10.2c-4.81,6.44-18,3.88-12.78-.94v-2.28a15.42,15.42,0,0,1-2.17-.21,4.7,4.7,0,0,1-4.26-3.79,32.29,32.29,0,0,1-.75-5,17.53,17.53,0,0,1,.46-6.59c.44-1.23-.08-2.86.26-4.39a4.15,4.15,0,0,1,1.83-3c2.67-1.32,5.13.58,8.84,2,1.54.6,5.26.87,6.24.4-1.29,1.43-1.28,5.95.63,7.78a4,4,0,0,0,.95,1.24c.81.71,1.48-1.11,2.16-1.83a2.8,2.8,0,0,1,4.35,1A4.56,4.56,0,0,1,451.15,222.16Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.75,228.38a19.83,19.83,0,0,0,7.21-1.1c1.72-.72,3.24-3.05,3.74-5.35,0,1.85-.81,5.14-3.42,6.51a16.87,16.87,0,0,1-7.54,1.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.34,211.4l2.46,1a1.4,1.4,0,0,0-.74-1.79A1.3,1.3,0,0,0,439.34,211.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.27,211.72l2.5-1a1.29,1.29,0,0,0-1.71-.78A1.4,1.4,0,0,0,429.27,211.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,214.31a1.09,1.09,0,1,1-1.05-1.13A1.09,1.09,0,0,1,440.39,214.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,213.86a1.09,1.09,0,1,1-1.05-1.13A1.1,1.1,0,0,1,432,213.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.7,212.27l-.89,6.93-3.66-1.35A16.24,16.24,0,0,1,435.7,212.27Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.81,220.16l-3.95.68a2,2,0,0,0,2.27,1.7A2.11,2.11,0,0,0,437.81,220.16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.31,220.78a2.57,2.57,0,0,1,.48,0,2.08,2.08,0,0,1-1.66,1.74,2.27,2.27,0,0,1-.64,0A1.83,1.83,0,0,1,437.31,220.78Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.34,363l1-9.34-10.81.7s.16,5.07.31,7.94c.09,1.7-2.22,4.85-2.22,4.85s5.08,2.69,7.8,1.75a7.1,7.1,0,0,0,4.12-5C431.52,363.11,431.34,363,431.34,363Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.29,377.55a2.31,2.31,0,0,0,.46,2.49,12.11,12.11,0,0,0,8.33,1.9,15.23,15.23,0,0,0,8.1-2.83c1.69-1.26,4-3,5.93-3.39a11.75,11.75,0,0,0,4.22-1.51c.56-.49.52-2.71.52-2.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.34,362.94a.67.67,0,0,1,.62.53c.12.62.22,2.39.48,3.4a16.47,16.47,0,0,1,.32,5.39c-.24,1.14-3.1,1.88-4.93,2.49a23.38,23.38,0,0,0-5.94,3.34,17.39,17.39,0,0,1-8.81,2.86c-3.19-.07-6.78-1.09-7.59-2.48-1-1.71-1.7-3.7,3.08-5.65.9-.37,4.08-2.05,5.17-2.65,2.94-1.65,5-3.17,6.4-6.15a1.68,1.68,0,0,1,.69-.9,1.63,1.63,0,0,1,.93-.06,32.65,32.65,0,0,1,4.65.9c.63.29,1.53.63,1.5,1.39a2.3,2.3,0,0,1-.19.76c-.06.15-.11.36,0,.45s.32,0,.44-.11a11.47,11.47,0,0,0,1.31-1.39,4.21,4.21,0,0,1,.76-.7,9.23,9.23,0,0,0,.82-.47C431.38,363.63,431.32,363.3,431.34,362.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,378.09c.84-.62,1.73-1.22,2.62-1.75h0s-5.63,3-7.86,1.58a1.78,1.78,0,0,1-.69-2.4c0-.36-5-3-6.46-3.14h0c-.39.2-.72.35-.93.44-4.78,1.95-4.07,3.94-3.08,5.65.81,1.39,3.4,2.5,7.54,2.57A17.88,17.88,0,0,0,421.89,378.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.37,374.49c-3,1-1.72,1.57-.9,1.69s5.84-2.47,8.9-4.64,5.23-4.75,6.42-5.58c.44-.31.92-.69,1.35-1-.07-.6-.13-1.15-.18-1.44a.67.67,0,0,0-.62-.53c0,.36,0,.69-.25.95a9.23,9.23,0,0,1-.82.47,4.21,4.21,0,0,0-.76.7,11.47,11.47,0,0,1-1.31,1.39A38.25,38.25,0,0,1,416.37,374.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.69,375.78a.24.24,0,0,0,.18,0,.26.26,0,0,0,.05-.38c-.82-1-4.73-3.27-6.9-3.08a.26.26,0,0,0-.26.29.28.28,0,0,0,.31.25c2-.17,5.75,2.11,6.39,2.87A.29.29,0,0,0,415.69,375.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.29,374.36a.3.3,0,0,0,.18-.06.25.25,0,0,0,0-.38c-.82-.95-4.73-3.26-6.9-3.07a.28.28,0,0,0-.27.29.28.28,0,0,0,.32.24c2-.16,5.74,2.12,6.39,2.88A.29.29,0,0,0,418.29,374.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.88,373a.33.33,0,0,0,.19-.06.25.25,0,0,0,.05-.38c-.82-1-4.73-3.26-6.91-3.08a.28.28,0,0,0-.26.3.29.29,0,0,0,.32.24c2-.17,5.74,2.12,6.39,2.88A.3.3,0,0,0,420.88,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,371.47a.32.32,0,0,0,.19-.05.26.26,0,0,0,0-.38c-.82-1-4.74-3.27-6.9-3.08a.27.27,0,0,0-.27.29.29.29,0,0,0,.32.25c2-.17,5.74,2.11,6.39,2.87A.28.28,0,0,0,423.29,371.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,369.93a.3.3,0,0,0,.18-.06.25.25,0,0,0,.05-.38c-1.12-1.35-5.22-3.29-7.4-3.11a.27.27,0,0,0-.26.29.29.29,0,0,0,.32.25c2-.17,5.88,1.7,6.88,2.9A.3.3,0,0,0,425.66,369.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.72,368.05l-2.47-8.85,11-1.68.5,8.56s1.17,3.06.5,4.19-8,2.4-8.68,1.67S452.72,368.05,452.72,368.05Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.85,387.36c.36,2.74,1,4.51,2.19,6s3.37,1.69,5.47.93,4.77-2.4,5.23-4.87a13.46,13.46,0,0,0-.41-6.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.76,366.08c.88-.05.71,3.71,1.45,7.36.8,3.92,2.26,5.38,3,8.59.8,3.66.68,5.36-.67,7.82s-6.48,5.38-9.29,2.5c-2.29-2.35-2.56-5.26-2.61-9a81,81,0,0,0-.41-9.52c-.35-2.77-1.2-5.23-.45-5.65.08.41.17.92.26,1.32s.25,1.8.75,1.75a5.39,5.39,0,0,0-.06-1.06,1.23,1.23,0,0,1,.18-.93,4.09,4.09,0,0,1,1.42-.74c.86-.26,2.39-.6,3.26-.79.44-.1.88-.17,1.32-.23a4.28,4.28,0,0,1,1.13,0,.68.68,0,0,1,.5.32,1.12,1.12,0,0,1,.07.42,2.79,2.79,0,0,0,.16.75c0,.1.13.23.26.18s.13-.15.13-.24c0-.45-.11-.77-.17-1.29,0-.24-.09-.57-.11-.81S461.79,366.32,461.76,366.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.9,381c.12.53.86,4-.2,4.82s-2-1.86-2-1.86a12.43,12.43,0,0,0-6.85,1.75c.24.55-.27,2.54-1.41,2.29s-1.84-4.28-1.85-4.33c0,3.59.38,6.41,2.6,8.69,2.81,2.88,7.94,0,9.29-2.5s1.47-4.16.67-7.82C466.09,381.66,466,381.32,465.9,381Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.4,384.23c.11,1.35,1.6.69,1.54-1.23s-1.53-6.27-1.73-9.56c-.32-4.5-.57-7.41-1.45-7.36a.61.61,0,0,0,0,.14l.24,1.88c0,.27.08.51.1.8.19,2.75.3,8.1.73,10.58A36.12,36.12,0,0,1,463.4,384.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.33,385.6a39.09,39.09,0,0,1-1.14-4.63c-.46-2.45-2-7.36-2.79-10a5.85,5.85,0,0,1-.41-1.49c-.08-.37-.16-.84-.24-1.23l0-.08c-.53.31-.32,2.44,0,3.54s.67,2.28,1.05,3.86c1,3.11,1.12,7.79,1.73,9.58S457.7,386.88,457.33,385.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.78,385.82l.12-.05a12.2,12.2,0,0,1,6.74-1.53A.37.37,0,0,0,464,384a.27.27,0,0,0-.26-.32,12.88,12.88,0,0,0-7.21,1.64.28.28,0,0,0-.11.41A.31.31,0,0,0,456.78,385.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.86,383l.1,0a15.13,15.13,0,0,1,7.56-1.72.36.36,0,0,0,.37-.27.26.26,0,0,0-.26-.31,15.6,15.6,0,0,0-8,1.82.28.28,0,0,0-.13.4A.32.32,0,0,0,455.86,383Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.13,378.48a.36.36,0,0,0,.26-.23.26.26,0,0,0-.23-.34,13.1,13.1,0,0,0-8,1.75.27.27,0,0,0-.11.4.34.34,0,0,0,.45.06s3.71-2.24,7.46-1.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.73,375.88a.36.36,0,0,0,.27-.22.26.26,0,0,0-.22-.34,11.87,11.87,0,0,0-8.14,1.74.27.27,0,0,0-.08.41.34.34,0,0,0,.45,0,11.19,11.19,0,0,1,7.58-1.62A.32.32,0,0,0,462.73,375.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.28,373a.36.36,0,0,0,.26-.22.26.26,0,0,0-.22-.34c-4.15-.79-8,1.72-8.18,1.83a.28.28,0,0,0-.1.41.33.33,0,0,0,.45,0s3.78-2.45,7.64-1.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,274.58c2.51,21,4.6,51,4.6,51,.19,1.65,1.39,4.46,2.31,12.59,1,8.57,1.42,30.93,1.42,30.93-1,3.29-9.05,4.88-11.52,1.72,0,0-7.37-26.8-9.66-37-2.34-10.44-4.86-25.92-4.86-25.92L436,323.47s.47,5.32.36,9.66c-.12,5-3.88,33.74-3.88,33.74s-7.76,1.91-12.81-1.87c0,0-1.41-34.59-1.65-40.65-.49-11.89.74-34.44.9-49.8Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,274.58l-.19-3.5c-3.07-.5-6.35-4.39-5.8-16.42.66-14.85,3.61-22.78,3.61-22.78l-3.21-1.09s-2.36,7-3.73,13l-17.18-.43s1.22-8.72,4.29-13.21l-4.29.78a80,80,0,0,0-4.6,14.42c-1.67,7.85-2,18.28-2.76,21.67s-2.16,3.76-2.16,3.76l-.12,3.81Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.31,308l-2.74-15.42s-5.82-.75-8.85-3.41c0,0,2,3.55,7.49,4.86l2.7,14,0,15.46Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "488.21 316.69 458.57 333.84 458.57 315.66 488.21 298.51 488.21 316.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.02 321.97 458.57 333.84 458.57 315.66 438.02 303.79 438.02 321.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.21 298.51 467.67 286.65 438.02 303.79 458.57 315.66 488.21 298.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.66,287l19.91,11.49-29,16.77-19.9-11.49,29-16.77m0-.37L438,303.79l20.55,11.87,29.64-17.15-20.55-11.86Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "472.77 313.54 458.57 321.74 450.06 316.82 458.57 322.25 472.77 313.54",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.28 313.21 458.57 326.32 441.54 316.49 458.57 326.81 481.28 313.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.36,305.26a15.84,15.84,0,0,1,.23,4,38.33,38.33,0,0,0-10,1.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.36 305.26 475.61 310.89 486.4 307.77 485.36 305.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.77,321l-10.7,9.84a3.87,3.87,0,0,0-2.35-2.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.77 320.97 462.72 329.43 459.72 328.5 472.77 320.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45,311l.09-.13,6.76,3.9-7.61-.62A4.66,4.66,0,0,1,441.45,311Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.3 314.79 441.54 310.89 439.29 312.08 448.3 314.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M483,299.78a.28.28,0,0,0,.23-.13.26.26,0,0,0-.1-.36l-17-9.84a.26.26,0,0,0-.36.1.27.27,0,0,0,.1.36l17,9.83A.33.33,0,0,0,483,299.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480.15,301.41a.26.26,0,0,0,.23-.13.25.25,0,0,0-.1-.35l-17-9.84a.26.26,0,0,0-.26.46l17,9.83A.31.31,0,0,0,480.15,301.41Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.31,303.05a.26.26,0,0,0,.23-.13.27.27,0,0,0-.1-.36l-17-9.83a.26.26,0,0,0-.26.46l17,9.83A.31.31,0,0,0,477.31,303.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.47,304.69a.26.26,0,0,0,.23-.13.27.27,0,0,0-.1-.36l-17-9.83a.27.27,0,0,0-.36.1.25.25,0,0,0,.1.35l17,9.84A.31.31,0,0,0,474.47,304.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M471.63,306.33a.26.26,0,0,0,.23-.13.27.27,0,0,0-.09-.36l-17-9.83a.25.25,0,0,0-.35.1.25.25,0,0,0,.09.35l17,9.84A.31.31,0,0,0,471.63,306.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M468.8,308a.26.26,0,0,0,.13-.49l-17-9.83a.26.26,0,0,0-.26.45l17,9.84A.35.35,0,0,0,468.8,308Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466,309.61a.25.25,0,0,0,.22-.13.26.26,0,0,0-.09-.36l-17-9.83a.26.26,0,1,0-.27.45l17,9.84A.28.28,0,0,0,466,309.61Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M463.12,311.25a.28.28,0,0,0,.23-.13.27.27,0,0,0-.1-.36l-17-9.83a.26.26,0,0,0-.36.09.27.27,0,0,0,.09.36l17,9.83A.2.2,0,0,0,463.12,311.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M460.28,312.89a.28.28,0,0,0,.23-.13.26.26,0,0,0-.1-.36l-17-9.83a.26.26,0,0,0-.36.09.26.26,0,0,0,.1.36l17,9.83A.22.22,0,0,0,460.28,312.89Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M461.64,298.49h-.08l-10.46-2.4a.35.35,0,0,1-.26-.41.34.34,0,0,1,.41-.26l10.47,2.4a.34.34,0,0,1,.25.41A.33.33,0,0,1,461.64,298.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.56,327.24a.34.34,0,0,1-.34-.34V309l.15-.11L462.5,298l14.43-6.72a.33.33,0,0,1,.45.17.34.34,0,0,1-.16.45l-14.38,6.69L446.9,309.39V326.9A.34.34,0,0,1,446.56,327.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.7,300.86c2.39-1.3,4.58-3.38,4.43-4.2a1.25,1.25,0,0,0-1.69-1.14c-.19-1.18-.36-2.15-1.71-2S462.07,299.23,463.7,300.86Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.79,285c1.57-3.86,2.48-19.14,2.48-19.14l-6.16-14.75s-1-12.86,3.65-15.56c6,1.92,6.51,6.37,8.78,12.13,2,5,2.9,8.13,4.85,14.27,1.15,3.6.87,6.17-1.19,12.73-1.68,5.34-3.24,9-3.71,11.51-.66,3.46.58,4.17-.86,6.39s-4,4.09-4.19,5a11.56,11.56,0,0,0,.26,3.25,3.36,3.36,0,0,1-3.39.15c-1.74-1-5.77-2.2-5.93-4.9C454.26,294.29,458.22,288.87,459.79,285Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.87,234.21c3.15,1.13,4.91,2.38,6.15,4.37s6.92,18,6.92,18-2.12,5.1-11.93,6.5c0,0-3.2-8-4.52-11.37S453,237.06,458.87,234.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.37,306.54V325.2a.34.34,0,0,1-.68,0V306.89l-10.25-7.71a7.15,7.15,0,0,1-.06-.9Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.84 104 240.93 115.81 250.9 115.1 249.26 101.98 239.84 104",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,91.79s-2.82,3.33-2.56,3.7a6.52,6.52,0,0,0,1.94.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,82c-2.18.91-6,2.62-7.49,10.24-1.59,7.83-.79,10.67.21,11.8.67.75,5.83,1.6,7.33,1.33a20.48,20.48,0,0,0,10.65-7.07c3.31-4.57,4.43-10.91,1.25-13.69A12.66,12.66,0,0,0,241.21,82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,105.49l-.12-1.23a9.72,9.72,0,0,1-3.2.09,7,7,0,0,1-3-.68,3,3,0,0,0,.29.39C234.49,104.69,237.91,105.45,240,105.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9,106a7.08,7.08,0,0,1-2.81-2,10.6,10.6,0,0,1-1.69-5.57s1.25,1.18,3.28-.31,2.53-4.74.16-5.75c-1.68-.73-3.09.47-4,1.77-.14.21-.31.44-.56.47s-.61-.43-.71-.81a3.3,3.3,0,0,0-.44-1.28,3.25,3.25,0,0,1-.73-2.16,7.66,7.66,0,0,1,.43-1.94,6.64,6.64,0,0,0-2.13,2.31,4.14,4.14,0,0,1,.54-3.69,7.2,7.2,0,0,0-2.14,3.1,3.79,3.79,0,0,1-.87-2.52,8.13,8.13,0,0,1,3.12-6.25A14.07,14.07,0,0,1,243,78.59a18.89,18.89,0,0,1,6.95.13c4.87,1,7.21,3.71,7.84,4.71a7.13,7.13,0,0,1,.79,3.5c2.74,1.89,2.32,5.59,1.27,8.32a17.08,17.08,0,0,1-4.72,6.09c-1,.89-2,1.75-2.91,2.67a13.22,13.22,0,0,0-1.3,1.4c-.59.79-1,1.47-1,1.47A15.34,15.34,0,0,1,244.9,106Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,109.41c4.17-.49,7.18,1,10.13,6.62,2.79,5.35,6.72,13.07,8.24,17,.75,1.91,2,3.59-1.42,7.28A58.31,58.31,0,0,1,261.67,149l-4.21-7.58,4.66-6.18-2.21-4.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.12,135.27a10.21,10.21,0,0,0,4.27,2.92c-1.58.5-4.41-.95-5-1.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43,113.79c-.77-3-1.77-5-7.48-4.71l-.8,0c-2,.29-4.87.46-10.1.86-.65.12-6.89,1.18-7.93,1.32,0,0-4.66,2.78-7,12.63-.66,2.79-.33,5.72,3.12,8.4-.09,2.83.54,5.28.19,8a114.11,114.11,0,0,0-1.11,13.33s7.13,3.5,18.91,2.35c7.26-.7,14.18-4.72,15.55-6a65.21,65.21,0,0,0-3.4-8.77,13.32,13.32,0,0,1-.91-8.14C260.82,126.42,262.6,122.31,260.43,113.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.92,109.56c4.57,0,5.35,1.72,6,4.36,1.78,6.94.89,10.86-.24,15.82-.23,1-.47,2.09-.7,3.24a13.76,13.76,0,0,0,.94,8.43,68.77,68.77,0,0,1,3.29,8.41,33.27,33.27,0,0,1-15,5.7c-1.55.15-3.11.22-4.62.22a36,36,0,0,1-13.73-2.41,123.88,123.88,0,0,1,1.09-12.94,21.19,21.19,0,0,0,0-4.65,29.17,29.17,0,0,1-.14-3.41v-.25l-.2-.16c-2.76-2.14-3.7-4.65-2.93-7.89,2.07-8.79,6.07-11.84,6.67-12.26,1.32-.19,7.07-1.17,7.82-1.31l3.2-.24c3.3-.24,5.3-.39,6.88-.62l.77,0c.33,0,.65,0,.95,0m0-.5-1,0-.8,0c-2,.29-4.87.46-10.1.86-.65.12-6.89,1.18-7.93,1.32,0,0-4.66,2.78-7,12.63-.66,2.79-.33,5.72,3.12,8.4-.09,2.83.54,5.28.19,8a114.11,114.11,0,0,0-1.11,13.33s5.27,2.58,14.24,2.58c1.46,0,3-.07,4.67-.23,7.26-.7,14.18-4.72,15.55-6a65.21,65.21,0,0,0-3.4-8.77,13.3,13.3,0,0,1-.91-8.13c1.33-6.66,3.11-10.77.94-19.29-.72-2.83-1.65-4.73-6.51-4.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,106.55c-.45,1.84-1.82,3.15-2.47,4.9-.87,2.33,0,5-.62,7.39a7.87,7.87,0,0,1-1.67,3,3.44,3.44,0,0,0-.65.91c-.92,2.11,3.45,4,4.86,4.67a23.61,23.61,0,0,0,8.16,1.82,4.76,4.76,0,0,0,2.65-.41c1.62-.93,1.45-3.54,1.47-5.11,0-2.19-.13-4.46.69-6.54.68-1.76,2-3.21,2.71-4.94a14.88,14.88,0,0,0,.9-4.48,7.51,7.51,0,0,0-.16-3c-1-2.94-5.6-3.3-8.12-3.78a21.09,21.09,0,0,0-7.75-.44.58.58,0,0,0-.38.17.61.61,0,0,0-.06.33c0,1.85.88,3.54.45,5.38Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,106.55c-.45,1.84-1.82,3.15-2.47,4.9-.87,2.33,0,5-.62,7.39a7.87,7.87,0,0,1-1.67,3,3.44,3.44,0,0,0-.65.91c-.92,2.11,3.45,4,4.86,4.67a23.61,23.61,0,0,0,8.16,1.82,4.76,4.76,0,0,0,2.65-.41c1.62-.93,1.45-3.54,1.47-5.11,0-2.19-.13-4.46.69-6.54.68-1.76,2-3.21,2.71-4.94a14.88,14.88,0,0,0,.9-4.48,7.51,7.51,0,0,0-.16-3c-1-2.94-5.6-3.3-8.12-3.78a21.09,21.09,0,0,0-7.75-.44.58.58,0,0,0-.38.17.61.61,0,0,0-.06.33c0,1.85.88,3.54.45,5.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.55,104.11a25.57,25.57,0,0,1,7.56,2.35,5.34,5.34,0,0,0-.18-1.43,32.6,32.6,0,0,0-16.25-2.72c.07.45.16.89.25,1.34A59.15,59.15,0,0,1,200.55,104.11Zm-10.86,18.38c-.66-.4-1.3-.81-1.93-1.25-.16.22-.33.44-.51.65l-.18.22a21.09,21.09,0,0,0,2.61,1.64,26.52,26.52,0,0,0,4.79,2.11,23.37,23.37,0,0,0,9,1.41,5.71,5.71,0,0,0,.2-1,31.52,31.52,0,0,1-9.2-1.55A27.66,27.66,0,0,1,189.69,122.49Z",
    style: {
      fill: "#008C8E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.45,126.15a52.81,52.81,0,0,1-4.54-4.12,3.87,3.87,0,0,1-.54-2.27c-.05-2.11-1.13-3.67-1.75-5.64-.15-.5-.41-1.37-1-1.27a1.14,1.14,0,0,0-.67.34,1.62,1.62,0,0,0-.35.69,3.66,3.66,0,0,0,.08,1.8c.06.24.58,1.4.31,1.56a.3.3,0,0,1-.32-.07,10.47,10.47,0,0,1-1.39-1.07c-.42-.39-.88-.84-1.28-1.26a20.54,20.54,0,0,1-2.6-3.14c-.71-.89-1.25-1-1.77-.75s.13,1.56.13,1.56a5.7,5.7,0,0,0-1.41-1.49c-.74-.35-1.57-.21-1.52.42a6.56,6.56,0,0,0,.2.75,1.49,1.49,0,0,0-.42,2.16s-.91.15-.14,2.11a19.92,19.92,0,0,0,6.76,8.75,20,20,0,0,1,3.54,3.33c2.84,3.27,5.67,6.68,8.64,10Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.82,112.57a12.94,12.94,0,0,0,3.35,4.84C198,115.84,196.86,114.25,195.82,112.57Zm-2.75-.38a16.57,16.57,0,0,0,4.8,7.24A30.59,30.59,0,0,1,193.07,112.19Zm3,7.86a26.53,26.53,0,0,1-3.46-5.7A11.75,11.75,0,0,0,196.11,120.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,111.29c-3.75.62-6.41,3.89-7.47,5.37-3.44,4.75-9.55,12.6-9.55,12.6l-7.17-4.65s-1.21.19-2.79,2.4a9.8,9.8,0,0,0-1.34,5.53s5.36,5.93,6.43,7c4.89,4.87,7.57,3.28,9.08,2.05,4.87-4,11.62-12.6,12.93-14C236.76,125,237.7,115.55,234.12,111.29Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.94,245.56c-.41-.09-.5,1.16-.42,1.71s1.6,2.52,4.55,3.48,7.2.86,9,1,4.44,1.29,6.17,1.86c4,1.3,6.48.07,7.65-.82a1.89,1.89,0,0,0,.61-1.43c.09-1.19,0-1.45-.13-1.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,246a24.57,24.57,0,0,1,.39,2.53c.09,1,.14,2.34-.62,3.06a5.67,5.67,0,0,1-4.25,1.42,12.64,12.64,0,0,1-5.19-1.14,11.62,11.62,0,0,0-4.41-1.36,43.9,43.9,0,0,1-6.28-.45,14.81,14.81,0,0,1-4.47-1.49,5.77,5.77,0,0,1-2.49-2.81,4.2,4.2,0,0,1,2.82-3.89,9.37,9.37,0,0,1,4.76-.43c1.75.21,3,.59,4.61.66a7.52,7.52,0,0,0,3.16-.38,3.09,3.09,0,0,0,1.14-1.26c.31-.52.46-1,1-1,0,0,8.18.91,8.91,1s.61,1.27.58,1.89,0,.54,0,1.07a7.72,7.72,0,0,0,.25,1.78C241.13,245.51,241.19,245.77,241.24,246Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.79,241.67a1,1,0,0,0-.37-.19c-.69-.19-1.32.45-1.68,1a4.2,4.2,0,0,0-.5,1,2.6,2.6,0,0,0-.18,1.38c0,.12.09.26.21.24s.16-.14.18-.25a5.38,5.38,0,0,1,.75-1.8,2.39,2.39,0,0,1,.51-.63,2,2,0,0,1,.76-.36c.11,0,.59,0,.5-.19a.31.31,0,0,0-.09-.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.84,241.91a1.37,1.37,0,0,0-1,.15,2,2,0,0,0-.67.87,3,3,0,0,0-.33,2.38c.11.23.31.14.41-.05a2.91,2.91,0,0,0,.17-.72,6.82,6.82,0,0,1,.62-1.53,2.42,2.42,0,0,1,.36-.54,1.1,1.1,0,0,1,.35-.26.66.66,0,0,1,.2-.06h.2c0-.1-.1-.17-.19-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,241.56a1.26,1.26,0,0,0-.65.33,1.75,1.75,0,0,0-.36.6,6.75,6.75,0,0,0-.46,1.53,1.93,1.93,0,0,0,.14,1.09c.07.14.2.28.34.23s.16-.28.19-.42.06-.5.09-.75a4.49,4.49,0,0,1,1.14-2.46s.07-.07.06-.12-.1-.08-.17-.08A1.64,1.64,0,0,0,229,241.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,241.61c-.72-.09-2.36.72-3.35,2.86a12.71,12.71,0,0,0-.89,5,7.21,7.21,0,0,1-3.8-2.35,3,3,0,0,1,.28-4.68c1.19-1.14,2.9-1.78,5.47-1.62,2.89.17,3,1,3,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,227.9s-1.58,11.4-1.81,13.74c-.11,1-2.31,2.09-5.36,1.79-2.14-.21-3.47-1.51-3.67-2.61s-.81-14.55-.81-14.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.83,228.48l-3.47-11-10.27,1.91s6.26,11.86,7.08,13C268.52,234.12,273.83,228.48,273.83,228.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.84,231.73a8.2,8.2,0,0,1-.14,3.08c-.14,1-.29,2-.36,3.05a11.57,11.57,0,0,1-.26,1.86A11.83,11.83,0,0,0,277,242c0,.79,0,1.57,0,2.35a3.79,3.79,0,0,0,0,1c.08.32-5,3.21-7,4.33l-.37.17a3.2,3.2,0,0,1-3.3-.77,5.62,5.62,0,0,1,1.37-6.18s.26,0,.21-2c0-1.41,0-2.85-.16-4.26A8.83,8.83,0,0,0,267,234a6.37,6.37,0,0,1-.86-2.39A3.54,3.54,0,0,1,267,230a8.47,8.47,0,0,1,3.69-2.91,3.27,3.27,0,0,1,2.74-.24c.41.25.61.74.9,1.12a5.38,5.38,0,0,0,1.33,1.09,5.25,5.25,0,0,1,2.16,2.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.65,242.86a8.12,8.12,0,0,0-.66.95h0a7.12,7.12,0,0,0-.71,5.23c-3.56-.32-4.5-2.38-4.5-2.38a3.43,3.43,0,0,1,1.85-3.07,5.85,5.85,0,0,1,.78-.41l0,0A5.21,5.21,0,0,1,267.65,242.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,232.29c.94.36.7,2.94.11,5.41s-.92,3.34-.62,5.4.48,3-.36,3.74-7.52,3.87-7.52,3.87a24.39,24.39,0,0,0,1.49-7.73c.18-4.57.48-7.51,2.6-9.58A4,4,0,0,1,278.67,232.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,246.66a12.45,12.45,0,0,0,5.57,2.43c3,.34,3.13-.81,3.45-4.34s.43-8.42,1.82-10.57,3.73-3.1,4.65-2.88c.19-.1,1.11.58,1.4,1a5.1,5.1,0,0,0-3.9,1.57c-1.86,1.82-2.2,5.66-2.29,9.15s-.23,7.54-3,8a10.15,10.15,0,0,1-7.58-2.31A1.4,1.4,0,0,1,261.78,246.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.86,241.56a1,1,0,0,0-.41.65,2,2,0,0,0,1,1.83c.38.22.7.13.09-.6A3.91,3.91,0,0,1,267.86,241.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,239.1a.9.9,0,0,0-.25.54,3,3,0,0,0,1.23,1.92c.65.29.3-.43,0-.76A12.63,12.63,0,0,1,267.8,239.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,236.4a.6.6,0,0,0-.31.43,3.08,3.08,0,0,0,1.75,1.26c.42,0,.52-.17,0-.52S267.64,236.4,267.64,236.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55,205.4c-1.54-6.52-3-9.23-4.62-11.89,0,0,1.29-22.69,1.9-33a28.64,28.64,0,0,0-.84-9.16h0l0-.09a19.44,19.44,0,0,0-1-2.9,49,49,0,0,0-3.3-7.24,4.27,4.27,0,0,1-4.57-2.37c-1.48-2.77-2.25-8-2.25-13.83s.79-16,.79-16l-3.69.37L248.48,124a74.31,74.31,0,0,0-7.62-14l-3.8.86s6.66,10,7.39,20.46c.56,8.22-3.21,10.56-6.79,11.17-5.7,1-7.56-.41-7.56-.41s-1,7-1.15,11.72-.6,11.11-.86,24.65c-.31,15.87-.23,21.63,1.07,35.23.38,4,1.49,21.35,1.49,21.35s2,2,6.24,1.78c1.81-.08,3.62-.19,4.33-.72,0,0,.71-2.43,2.32-12.29,1.11-6.83,1.62-10.49,1.46-13.62a51.14,51.14,0,0,0-1.18-8.27l2.61-14.94s1.93,7,2.42,9.61,1.24,4,2.86,7.34c4.73,9.7,12.64,24.07,12.64,24.07a9.17,9.17,0,0,1,8.08-4.42C271.19,217.48,269.44,209.22,268.55,205.4Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.43,186.93l3.83-21.16s4.11-.48,9.54-5.24c0,0-.36,3.71-7.58,6.89l-4.12,18.8.75,10.32Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mop--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.47,269.81a32.21,32.21,0,0,1,3.39-.79c.87-.16,1.38.18,3.47,1.32s2.55,1.74,2.74,2.4a1.42,1.42,0,0,1-.56,1.58,1.26,1.26,0,0,1-.35,2.13,1.14,1.14,0,0,1-.45,1.85,1.55,1.55,0,0,1-1.1,2.13,22.48,22.48,0,0,1-3.38.45Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "146.2 382.08 133.68 389.31 91.02 364.64 103.54 357.41 146.2 382.08",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.2 382.08 133.68 389.31 91.02 364.64 103.54 357.41 146.2 382.08",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.2 382.08 133.68 389.31 133.68 390.63 146.2 383.4 146.2 382.08",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.02 364.64 91.02 365.96 133.68 390.63 133.68 389.31 91.02 364.64",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.02 364.64 91.02 365.96 133.68 390.63 133.68 389.31 91.02 364.64",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-64",
    d: "M121.48,372.77a1.89,1.89,0,0,1-1.11,1.55,5.93,5.93,0,0,1-5.35,0,1.89,1.89,0,0,1-1.11-1.55,3.79,3.79,0,0,1,7.57,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68,370.8a2,2,0,0,1-1.81.09c-.26-.14-.4-.32-.4-.51L109,228.25l2.57-.12L119,370.25A.62.62,0,0,1,118.68,370.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42,228.75c-.52-.26-.54-.73,0-1.05a2,2,0,0,1,1.82-.09c.51.27.54.74,0,1A2,2,0,0,1,109.42,228.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.23,280.88c-.41,0-1-.66-1.34-1.09s-.88-1-.85-1.35c.06-.54.81-.54.81-.54a2.55,2.55,0,0,1-.38-.33c-.47-.46.38-1.08,1.14-.8,0,0-.32-.19-.33-.41a1,1,0,0,1,1-.95c-.54-.26-.36-1,0-1.61a3.68,3.68,0,0,1,1.19.15,13.2,13.2,0,0,1-.19,6.84S113.54,280.88,113.23,280.88Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71,278.3a11.3,11.3,0,0,1-1.51.43,13.51,13.51,0,0,1-1.54.3,2.26,2.26,0,0,1-1.45-.35c-.47-.24-.92-.5-1.36-.78a9.07,9.07,0,0,0,1.29.91,2.39,2.39,0,0,0,1.55.41,12,12,0,0,0,1.55-.35A7.1,7.1,0,0,0,117.71,278.3Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61,276.77a11.15,11.15,0,0,0,1.33.58,2,2,0,0,0,.74.13,5.08,5.08,0,0,0,.72-.15,26.06,26.06,0,0,0,2.76-.88c-1,.2-1.87.46-2.8.7-.23.06-.47.12-.69.16a2,2,0,0,1-.68-.1C113.53,277.08,113.07,276.91,112.61,276.77Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,275.41a2.75,2.75,0,0,0,1.33.29,8,8,0,0,0,1.32-.37,25.15,25.15,0,0,0,2.53-1c-.88.24-1.73.55-2.59.83a10,10,0,0,1-1.28.41A3.29,3.29,0,0,1,113.33,275.41Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.18,251.46c3.79,8.12,5.69,11.32,5.69,11.32s14.52,6.64,14.92,6.76a5.15,5.15,0,0,0,2.89.24,5.62,5.62,0,0,1,3.18.11c.87.36,3.65,1.49,4.16,2.18a15.35,15.35,0,0,1,1.37,2.73c.47,1,.47,1.45-.5,1.45a2.91,2.91,0,0,1-2.36-1.85,4,4,0,0,0-2.2-.6,3.26,3.26,0,0,1-.25.54h0a6.39,6.39,0,0,1-.94,1.23l-.09,1.13c-.54.08-.93.51-.58.86a2.25,2.25,0,0,0,.37.32s-.74,0-.79.55a.84.84,0,0,0,.16.5l.47.61.08,1.33s-3.42-.5-4.4-1.53-.92-1.31-3.59-2.42c-.83-.34-8.63-2.88-14.6-4.59-4.57-1.31-4.71-1.78-6.88-4.94-3.37-4.92-7.24-11.69-7.24-11.69l.3-15.1C81.23,242.1,82,242.51,86.18,251.46Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,240.34c7.16,1.51,7.06,2.4,8.88,5.44s6.18,12.35,6.18,12.35S88.73,264,80,264.6l-5.49-9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13,275.58c-.85,1.14-2.83,1.68-4.35,1.6a6.87,6.87,0,0,0,4.26-.35Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.36,282.64c1.26-5.75,2.85-12.19,3-13.45,1-7.31-.32-11-.8-14.22-1-7,1-12.82,2.58-14.19l3.7-.87a31.47,31.47,0,0,1,3.48-.62,41.37,41.37,0,0,1,9.31-.25c.75.07,4.33.69,4.33.69,1.09.25,3.07.61,3.07.61a23.15,23.15,0,0,1,4.79,6.17c1.77,3.16,2.77,5.8,3.09,12.56.39,8.62.56,19,.56,25C76.35,288.46,55.33,290.3,46.36,282.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,238.89v.5c1.72,0,2.91.1,3.34.14.73.08,4.27.69,4.28.69.91.21,2.44.49,2.94.59h0a23.28,23.28,0,0,1,4.57,5.94c1.82,3.24,2.73,5.91,3,12.35.38,8.22.55,18.26.56,24.69-3.7,2.15-10.77,3.58-17.74,3.58-4.63,0-13.1-.64-18.33-4.92.52-2.38,1.1-4.86,1.6-7.05.7-3,1.25-5.4,1.35-6.14a34,34,0,0,0-.45-12.44c-.13-.67-.25-1.32-.34-1.93-1-6.77.9-12.3,2.32-13.65L55,240.4a28.45,28.45,0,0,1,3.43-.61,41.09,41.09,0,0,1,5.84-.4v-.5m0,0a42.32,42.32,0,0,0-5.91.4,31.47,31.47,0,0,0-3.48.62l-3.7.87c-1.62,1.37-3.62,7.22-2.58,14.19.48,3.2,1.78,6.91.8,14.22-.17,1.26-1.76,7.7-3,13.45,4.41,3.77,11.73,5.23,18.89,5.23,7.39,0,14.61-1.57,18.24-3.8,0-6-.17-16.38-.56-25-.32-6.76-1.32-9.4-3.09-12.56a23.15,23.15,0,0,0-4.79-6.17s-2-.36-3.07-.61c0,0-3.58-.62-4.33-.69a33,33,0,0,0-3.4-.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.78,232.81A1.2,1.2,0,0,0,59,233a3.3,3.3,0,0,0,3,.13,11.8,11.8,0,0,0,3.57-2.06c1.62-1.29,3-2.79,4.54-4.23a57.19,57.19,0,0,0,4.24-4.29c.63-.75,3.13-3,4-4.67,1.63-3-1.24-7-3.62-8.68a13.43,13.43,0,0,0-5.33-2.26c-3.56-.71-8-.26-11.09,1.79a11.79,11.79,0,0,0-4.7,5.29,11.27,11.27,0,0,0-.61,2.5,16.82,16.82,0,0,0,1.46,10.16,27.46,27.46,0,0,0,2.31,3.53c.43.6.87,1.19,1.3,1.78A4.78,4.78,0,0,0,58.78,232.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.35,208.15l-.47.08A9.37,9.37,0,0,0,50,209.32a6,6,0,0,0-2.37,2.2,6.08,6.08,0,0,0-.38,4.29,5.62,5.62,0,0,1,.23,3.13,6.16,6.16,0,0,1-1.66,2A6.09,6.09,0,0,0,44,224.49a7.33,7.33,0,0,0,.92,4c.61,1.25,1.39,2.41,1.92,3.7a3.61,3.61,0,0,1,.29,2.49,1.59,1.59,0,0,1-2,1.08,2.23,2.23,0,0,0,1.42,1.32,8.27,8.27,0,0,0,6.93-.06,6.54,6.54,0,0,0,3.44-4.44,7.82,7.82,0,0,0,.13-2.85,8.43,8.43,0,0,1,0-3.74c.17-.53.43-1,.6-1.57.94-3-1.23-6.19-.53-9.22a15.48,15.48,0,0,1,1.29-3.26c.34-.7,1.1-1.72.58-2.5s-1.7-.93-2.42-1.1A8.74,8.74,0,0,0,53.35,208.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.69,237.16c0-1.14-.14-6.87-.14-6.87,0,.43-2.13,1.59-4-.62s-2-4.56-.86-6C55,222,58.17,222,58.47,224.8c1.61-.06,1.81-.68,2-3.39.13-1.87.81-.92,2-3.31.81-1.63.49-3.55,2.47-4.42a5.25,5.25,0,0,1,5,.37,4.68,4.68,0,0,1,2.84-1.15c3.26,0,4.29,3,4.33,4.52.05,1.94.68,4.77.51,8.6-.23,5.13-1.6,7.22-3.55,8.24a11,11,0,0,1-5.2,1.09l.1,1.91c0,1,0,1.66.89,2,.62.2,2.1.49,2.1.49s2.16,3.74-3.8,4.07c-9.51.54-13.32-3.89-13.32-3.89l2.11-.64C58.52,238.78,58.68,238.31,58.69,237.16Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,228.15l3.59,1.15a1.86,1.86,0,0,1-2.34,1.29A2,2,0,0,1,67,228.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.24,229a2.07,2.07,0,0,1,2.07,1.62,1.84,1.84,0,0,1-1,0A2,2,0,0,1,67,229Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,219.36l-2.25-1.25a1.24,1.24,0,0,1,1.72-.53A1.34,1.34,0,0,1,75.65,219.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.83,219.54l2.49-.78a1.25,1.25,0,0,0-1.59-.88A1.37,1.37,0,0,0,64.83,219.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3,221.59a1.11,1.11,0,0,0,1,1.17,1,1,0,0,0,1.15-.95,1.1,1.1,0,0,0-1-1.17A1,1,0,0,0,73.3,221.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,221.76a1.11,1.11,0,0,0,1,1.17,1,1,0,0,0,1.15-.94,1.11,1.11,0,0,0-1-1.18A1.05,1.05,0,0,0,65.3,221.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.95 225 70.55 226.61 69.87 220.07 73.95 225",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,235.35c-4.08-.42-8-1.77-8.9-3.64a4.86,4.86,0,0,0,1.63,3C64.35,237,69,236.79,69,236.79Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75,339.71c-.19,2.89-.3,6.12-.36,9.14h0c-.64,12.06.29,20.55-.27,28.27-.11,1.46-1.17,11.26-.93,14.3.37,4.57,6.16,4.5,6.71,1.84s1.89-14.24,2-15.42c.45-4.94,3-14.54,4.77-24.42.88-4.11,2-9,3-13.71Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,372.14c-1.2-1.29-1.46-2.49-1.26-5.55,0-.53,1.08-14.42,1.91-26.88H69.13c1.05,9,4,27.49,4,29a3,3,0,0,1,.09.52c0,2.91,3.35,4.45,5.93,6.36a48.1,48.1,0,0,0,7,4.46c1.87.91,5.66,1,6.12-.25C89.1,377.4,85.46,374.84,82.94,372.14Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,382.83a2.5,2.5,0,0,1-.44,2.52,10.7,10.7,0,0,1-7.82,1.87,13.66,13.66,0,0,1-7.59-2.93c-1.57-1.29-3.78-3.1-5.54-3.47a10.75,10.75,0,0,1-3.95-1.57c-.53-.5-.48-2.75-.48-2.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,367.83s-.29,0-.39.54-.22,2.42-.47,3.44a18.16,18.16,0,0,0-.32,5.47c.22,1.14,2.9,1.92,4.61,2.55A21.68,21.68,0,0,1,82,383.25a16,16,0,0,0,8.24,3c3.88,0,6.38-1.06,7.13-2.46.94-1.73.18-2.72-4.29-4.74-.85-.38-3.83-2.1-4.84-2.72a22.84,22.84,0,0,1-3-2.22c-.48-.42-.94-.86-1.38-1.33a6,6,0,0,1-1.14-1.43c0-.12-.09-.25-.13-.37a5.82,5.82,0,0,1-.3-1c-.08-.37-.13-.91-.49-1.13a3,3,0,0,0-1.59-.17,12.39,12.39,0,0,0-1.71.26c-.66.15-1.41.22-1.79.84a3.1,3.1,0,0,0-.35,1.62c0,.26,0,.52,0,.78s0,.31-.11.26-.32-.43-.38-.56c-.12-.29-.2-.6-.34-.88a4.71,4.71,0,0,0-.57-.94,4,4,0,0,0-.71-.71,7.62,7.62,0,0,1-.77-.48A1.88,1.88,0,0,1,73,367.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.83,379.36c-5.6.44-7.33,3.92-7.55,6.07a13,13,0,0,0,4,.79c3.88,0,6.53-1.06,7.29-2.46C98.45,382.13,97.82,380.82,93.83,379.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,379.5a.21.21,0,0,1-.18-.06.27.27,0,0,1,0-.38A6.61,6.61,0,0,1,90.26,377a.26.26,0,0,1,.24.3.26.26,0,0,1-.29.24,6.12,6.12,0,0,0-4.57,1.85A.26.26,0,0,1,85.43,379.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,378.12a.3.3,0,0,1-.18-.06.27.27,0,0,1,0-.38,6.58,6.58,0,0,1,5-2.06.28.28,0,0,1,0,.55A6.12,6.12,0,0,0,83.21,378,.26.26,0,0,1,83,378.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,376.54a.28.28,0,0,1-.22-.44,6.61,6.61,0,0,1,5-2.06.29.29,0,0,1,.25.3.27.27,0,0,1-.3.25A6.07,6.07,0,0,0,81,376.44.28.28,0,0,1,80.74,376.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.53,375a.28.28,0,0,1-.22-.44,6.73,6.73,0,0,1,5.52-2.09.27.27,0,0,1-.06.54,6.23,6.23,0,0,0-5,1.88A.29.29,0,0,1,78.53,375Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72,395.33a12.32,12.32,0,0,1-1.51,5.95,3.89,3.89,0,0,1-4.5,1.58c-1.79-.45-4.09-1.67-4.6-3.95a14.28,14.28,0,0,1-.41-6.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.18,376.18c-.74.06-1,3.61-1.38,7.16-.46,3.81-1.6,5.39-2,8.52a9.79,9.79,0,0,0,1.38,7.32c1.25,2.16,5.68,4.27,7.86,1.18,1.78-2.52,1.85-5.31,1.69-8.88a78.89,78.89,0,0,1,.24-9c.14-2.67.73-5.37.09-5.67,0,.4-.09.9-.15,1.28a5.78,5.78,0,0,1-.24,1.43c-.07.19-.24.4-.3.08a1.89,1.89,0,0,1,0-.67c.11-1-.39-1.06-.66-1.14-.58-.16-2.87-.44-3.42-.48s-2.52-.13-2.77.2a2.15,2.15,0,0,0-.25,1c-.06.54-.19.93-.2.76,0-.38,0-1.38,0-1.63s0-.54,0-.78S43.16,376.41,43.18,376.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59,393.92A8.89,8.89,0,0,0,41,399.35c1.25,2.16,6,4.28,8.22,1.19a10.11,10.11,0,0,0,1.52-5.21C49.41,393,41.65,391.9,39.59,393.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1,391.45l-.09,0a12.59,12.59,0,0,0-6.77-.66.26.26,0,0,1-.33-.2.27.27,0,0,1,.2-.33,12.93,12.93,0,0,1,7.14.7.27.27,0,0,1,.13.36A.28.28,0,0,1,49.1,391.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,388.1a.28.28,0,0,1-.23-.18.28.28,0,0,1,.17-.35c3.31-1.12,7,.56,7.13.64a.27.27,0,0,1,.11.36.27.27,0,0,1-.37.12s-3.61-1.65-6.69-.6A.25.25,0,0,1,42.4,388.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52,385.59a.27.27,0,0,1-.23-.18.27.27,0,0,1,.16-.35,9.67,9.67,0,0,1,7.26.62.27.27,0,0,1,.1.37.29.29,0,0,1-.38.1,9.32,9.32,0,0,0-6.79-.57A.25.25,0,0,1,42.52,385.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7,383.12a.27.27,0,0,1-.07-.52c3.41-1.28,7.17.6,7.31.69a.27.27,0,1,1-.27.47s-3.68-1.84-6.85-.65A.25.25,0,0,1,42.7,383.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.06,282.57,83.67,269a4,4,0,0,1-1.67-2c-.5-1.33-.33-6.83-1.7-14.17a30.54,30.54,0,0,0-5.79-12.64l-3.09-.61c2.5,3.75,3.63,9.42,3.63,9.42L60,249.47a56.77,56.77,0,0,0-3-10.2l-2.79.81c2.17,6,2.66,16.55,1.49,22.57s-6.17,5.55-6.17,5.55-.64,2.23-1.7,7S45.63,283,45.3,301s-.3,24.82-.37,27-1.33,6-2.44,16.75A148.49,148.49,0,0,0,42.4,368s1.06,1.94,5.15,2.3c3.77.34,5.64-1.07,5.64-1.07s5.17-20.84,6.61-27.28,6.07-31.2,6.07-31.2l2.47,17.19a53.66,53.66,0,0,0,0,15.28c1.15,9.38,3.18,19,3.18,19a17,17,0,0,0,5.79.95,9.82,9.82,0,0,0,5.09-1.33s3.21-27.91,3.21-38.54C85.61,315,84.64,295.77,84.06,282.57Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.24,290.26,65.87,310.7l2.47,17.19L68,311.2l2.29-12.68.39-2.17.65-3.6c2.57-.61,8.21-3.59,9-7.13C76.35,289.75,69.24,290.26,69.24,290.26Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.22,292.47c-1.72.49-3.92-1.65-4.53-2.4s.18-2.51.54-4,0-4,1.85-3.32S47.81,288.45,44.22,292.47Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.05,241.39c-4.79.71-6.75,1.62-10.21,7.9-3.33,6-6.9,12.37-8.64,16.24-1.06,2.36-2,4.37.77,8.16,2.5,3.47,10.34,12.56,11.49,13.9,1,1.18.46,4.56-3.05,4.05,0,0,2.67,2.37,4.14,2.1,1.26-.22,3.25-1.33,5.08-5.17,1.15-2.42.19-4.32-1.57-7-2.09-3.22-6.61-12.2-6.61-12.2L50.54,255S55.13,245.65,51.05,241.39Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.16,240.78C45,242,43.83,243.07,40.55,249s-5.08,9.22-5.08,9.22-.23,1.86,3.78,4.12,6.39,2.09,6.39,2.09,3.11-5,5.15-8.42S54.7,244.09,51.16,240.78Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--waste-bin--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--waste-bin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.28,377.89c0-5.14-3.54-11.41-8-14-2.32-1.36-4.42-1.43-5.9-.46h0l-3,1.71,11.44,19.72,3-1.7v0C393.3,382.32,394.26,380.52,394.28,377.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,365.74c4.44,2.59,8,8.87,8,14s-3.65,7.2-8.09,4.6-8-8.87-8-14S378.63,363.14,383.06,365.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,369.36a10.87,10.87,0,0,1,4.87,8.56c0,3.14-2.23,4.4-4.94,2.81a10.89,10.89,0,0,1-4.87-8.56C378.12,369,380.33,367.77,383,369.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.37,368.71a4,4,0,0,1,2.67.65,10.87,10.87,0,0,1,4.87,8.56,4.41,4.41,0,0,1-.59,2.33,4.08,4.08,0,0,1-2.67-.65,10.89,10.89,0,0,1-4.87-8.56A4.41,4.41,0,0,1,380.37,368.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.18,376.28a5.87,5.87,0,0,0-2.62-4.61,1.82,1.82,0,0,0-1.95-.15h0l-1,.57,3.76,6.48,1-.56h0A1.85,1.85,0,0,0,386.18,376.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.49,372.28a5.87,5.87,0,0,1,2.62,4.62c0,1.69-1.2,2.37-2.66,1.51a5.87,5.87,0,0,1-2.62-4.61C379.84,372.11,381,371.43,382.49,372.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.48,373.93a2.74,2.74,0,0,1,1.21,2.13c0,.78-.56,1.09-1.23.7a2.74,2.74,0,0,1-1.21-2.13C381.26,373.85,381.81,373.54,382.48,373.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.81,323.37l70.94,2-6,68.38h0a1.55,1.55,0,0,1-.87,1.15l-28.91,16.68a4.7,4.7,0,0,1-4.29,0l-23.9-13.79a1.55,1.55,0,0,1-.87-1.15h0Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,323.38l38,2-6,68.38h0a1.55,1.55,0,0,1-.87,1.15l-28.91,16.68a4.31,4.31,0,0,1-2.15.52Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,323.38l38,2-6,68.38h0a1.55,1.55,0,0,1-.87,1.15l-28.91,16.68a4.31,4.31,0,0,1-2.15.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.79 400.09 384.67 406.5 384.67 386.66 397.22 379.42 395.79 400.09",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.79 400.09 384.67 406.5 384.67 386.66 397.22 379.42 395.79 400.09",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394 399.05 384.67 404.44 384.67 386.66 395.28 380.54 394 399.05",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.79 400.09 394 399.05 384.67 404.44 384.67 406.5 395.79 400.09",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.79 400.09 394 399.05 384.67 404.44 384.67 406.5 395.79 400.09",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,346.8l34.94-20.17a1.3,1.3,0,0,0,0-2.47L380.93,302a4.77,4.77,0,0,0-4.29,0L341.7,322.19a1.31,1.31,0,0,0,0,2.48l29.93,22.13A4.7,4.7,0,0,0,375.92,346.8Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,346.8l34.94-20.17a1.3,1.3,0,0,0,0-2.47L380.93,302a4.77,4.77,0,0,0-4.29,0L341.7,322.19a1.31,1.31,0,0,0,0,2.48l29.93,22.13A4.7,4.7,0,0,0,375.92,346.8Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,345.83a2.9,2.9,0,0,0,1.4-.32L410,325.39l-29.85-22.08a3.32,3.32,0,0,0-2.8,0l-34.87,20.12,29.85,22.08A2.9,2.9,0,0,0,373.77,345.83Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,345.83a2.9,2.9,0,0,0,1.4-.32L410,325.39l-29.85-22.08a3.32,3.32,0,0,0-2.8,0l-34.87,20.12,29.85,22.08A2.9,2.9,0,0,0,373.77,345.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,303.37l.05-.37a2.9,2.9,0,0,1,1.4.31L410,325.39l-31.3,17.95Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29,279.84l3.51,35.53c.11,1.13,1,1.55,2.06,1l30.25-21.74a3.56,3.56,0,0,0,1.65-3.11L367.62,260c-.11-1.12-1-1.55-2.06-1l-30.62,17.67A3.53,3.53,0,0,0,333.29,279.84Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.69,320l-4-40.52a.21.21,0,0,1,0-.08v-.09a3.88,3.88,0,0,1,1.82-3.41l.13-.08h0l35.58-20.54a1.58,1.58,0,0,1,2,.06h0l2.71,2.84h0a1.66,1.66,0,0,1,.4,1l3.9,39.46a4,4,0,0,1-1.88,3.53l-34.22,19.75a1.91,1.91,0,0,1-1.21.29l-4.09-.75A1.44,1.44,0,0,1,335.69,320Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.69,320l-4-40.52a.21.21,0,0,1,0-.08v-.09a3.88,3.88,0,0,1,1.82-3.41l.13-.08h0l35.58-20.54a1.58,1.58,0,0,1,2,.06h0l2.71,2.84h0a1.66,1.66,0,0,1,.4,1l3.9,39.46a4,4,0,0,1-1.88,3.53l-34.22,19.75a1.91,1.91,0,0,1-1.21.29l-4.09-.75A1.44,1.44,0,0,1,335.69,320Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,281.31l3.9,39.46c.13,1.28,1.18,1.76,2.34,1.09l34.22-19.75a4,4,0,0,0,1.88-3.53l-3.9-39.46c-.13-1.27-1.18-1.76-2.35-1.09l-34.21,19.75A4,4,0,0,0,335.87,281.31Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.87,281.31l3.9,39.46c.13,1.28,1.18,1.76,2.34,1.09l34.22-19.75a4,4,0,0,0,1.88-3.53l-3.9-39.46c-.13-1.27-1.18-1.76-2.35-1.09l-34.21,19.75A4,4,0,0,0,335.87,281.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,281.1a1.94,1.94,0,0,1,.83-1.47l33.46-19.32,3.81,38.48a1.94,1.94,0,0,1-.83,1.47L341.8,319.58Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,281.1a1.94,1.94,0,0,1,.83-1.47l33.46-19.32,3.81,38.48a1.94,1.94,0,0,1-.83,1.47L341.8,319.58Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,279.63a1.94,1.94,0,0,0-.83,1.47l3.43,34.71,30.22-17.44a1.91,1.91,0,0,0,.83-1.47L369,262.19Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,279.63a1.94,1.94,0,0,0-.83,1.47l3.43,34.71,30.22-17.44a1.91,1.91,0,0,0,.83-1.47L369,262.19Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.24,398.76c0-5.14-3.53-11.42-8-14-2.33-1.36-4.42-1.43-5.9-.45h0l-3,1.71,11.43,19.71,3-1.7v0C357.27,403.19,358.23,401.38,358.24,398.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,386.6c4.44,2.6,8,8.87,8,14s-3.65,7.2-8.09,4.6-8-8.87-8-14S342.6,384,347,386.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,390.22a10.89,10.89,0,0,1,4.87,8.56c0,3.14-2.23,4.4-4.94,2.81a10.89,10.89,0,0,1-4.87-8.56C342.09,389.89,344.3,388.63,347,390.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,389.57a4.07,4.07,0,0,1,2.67.65,10.89,10.89,0,0,1,4.87,8.56,4.41,4.41,0,0,1-.59,2.33,4,4,0,0,1-2.67-.65,10.87,10.87,0,0,1-4.87-8.56A4.41,4.41,0,0,1,344.34,389.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,397.15a5.86,5.86,0,0,0-2.63-4.61,1.79,1.79,0,0,0-1.94-.15h0l-1,.56,3.77,6.49,1-.56h0A1.83,1.83,0,0,0,350.15,397.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,393.15a5.85,5.85,0,0,1,2.62,4.61c0,1.69-1.2,2.37-2.66,1.51a5.83,5.83,0,0,1-2.62-4.61C343.81,393,345,392.29,346.46,393.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,394.8a2.71,2.71,0,0,1,1.21,2.12c0,.78-.56,1.1-1.23.7a2.68,2.68,0,0,1-1.21-2.12C345.22,394.72,345.77,394.4,346.45,394.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,359.63l1.74-1.26c1.28-6.83,4.5-10.09,8.31-11.77-1.88,1.52-4.43,5.89-5,9.35l1.75-1.26c.34-.25.55.13.34.62l-3.12,7.28c-.14.33-.42.53-.59.42L383,360.68C382.74,360.53,382.88,359.88,383.23,359.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.29,351.87a16.22,16.22,0,0,1,3.77-5.53s3.7-1,4.71,3.72C398.77,350.06,395.65,347.09,390.29,351.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.11,351.12l-.76,2.55c3.33,2.42,2.55,7.21.19,12.68.71-2.76.15-6.73-1.64-7.78l-.75,2.55c-.15.5-.6.76-.73.42l-1.94-5a1,1,0,0,1,.25-.86l4.9-5C400,350.35,400.25,350.62,400.11,351.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8,361.69a10.65,10.65,0,0,1,.21,5.77s-2.68,5.25-6.72,6.23A23.11,23.11,0,0,0,398.8,361.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.39,375.45l-1-1.29c-4.6,4.41-7,2.89-8.5-.92,1.17,1.25,4.28.84,6.6-1.56l-1-1.29c-.19-.25,0-.9.38-1.05L392,367.1c.23-.1.39.1.33.43l-1.18,7.3C391,375.32,390.58,375.7,390.39,375.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.63,372.64c-1.64.68-3.22.57-4-.24,0,0-1-4.23,2-9.95C382.65,362.45,381,369.5,384.63,372.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trash--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.41,328.65,375.1,345.56a2.84,2.84,0,0,1-1.35.3,2.8,2.8,0,0,1-1.34-.3L348.27,327.7l.37-.13c.22-.07.45-.12.68-.17a14.13,14.13,0,0,1,3.38-.18,14.45,14.45,0,0,1,1.14-2.25,6.51,6.51,0,0,1,2.06-1.66,5,5,0,0,1,5.07.08c.23-3.76,4.19-6.68,7.62-7.41a7.79,7.79,0,0,1,6.2,1.2,6.81,6.81,0,0,1,6.81-2.67,7.85,7.85,0,0,1,5.6,4.88,7,7,0,0,1,6.84.86,8.92,8.92,0,0,1,3.4,6.14c0-.42,2.39-.43,2.66-.41a5.84,5.84,0,0,1,3,1.2A5.1,5.1,0,0,1,404.41,328.65Z",
    style: {
      fill: "#f5f5f5"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-can--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bucket--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.13,236.37,182.86,236l-.24,23.09h0c0,2.09,1.33,4.19,4.08,5.82,5.48,3.24,14.43,3.34,20,.21,2.8-1.58,4.2-3.67,4.2-5.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.07,230.27c-5.55,3.13-5.61,8.3-.12,11.54s14.43,3.35,20,.22,5.61-8.3.12-11.55S192.62,227.14,187.07,230.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.92,236.28a3.61,3.61,0,0,1-.2,1.11,6.86,6.86,0,0,1-3.38,3.57,20.95,20.95,0,0,1-18.77-.2,6.88,6.88,0,0,1-3.28-3.57,3.4,3.4,0,0,1-.2-1.18c0-1.73,1.3-3.39,3.59-4.67a20.93,20.93,0,0,1,18.76.2C208.7,232.88,209.93,234.56,209.92,236.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,237.39a6.86,6.86,0,0,1-3.38,3.57,20.95,20.95,0,0,1-18.77-.2,6.88,6.88,0,0,1-3.28-3.57,6.78,6.78,0,0,1,3.39-3.55,20.76,20.76,0,0,1,18.76.2A6.93,6.93,0,0,1,209.72,237.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34,241a10.53,10.53,0,0,0,1.28-.85c-5.16,2.77-14,1.61-16.8-.57s-3.14-5.89,1.36-7.55a15.78,15.78,0,0,0-4.5,1.65,6.78,6.78,0,0,0-3.39,3.55,6.88,6.88,0,0,0,3.28,3.57,20.95,20.95,0,0,0,18.77.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,245c.62-.34,1.11-.05,1.1.66A2.44,2.44,0,0,1,203,247.6c-.62.35-1.12.06-1.11-.65A2.48,2.48,0,0,1,203,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,246.22a.59.59,0,0,1-1.18,0c0-.69,0-1.52,0-2.49a81.68,81.68,0,0,0-1.4-15.38c-.93-4.31-2.48-8-5-9.65a2.82,2.82,0,0,0-3-.33c-2.34,1.29-3.69,6.27-4.32,11.15a8.49,8.49,0,0,0-1.26.59c.59-5.24,2-11.12,5-12.77a4,4,0,0,1,4.21.35c3,1.84,4.68,6,5.68,10.92a84.44,84.44,0,0,1,1.3,14.81C203.6,244.38,203.6,245.31,203.6,246.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,374l-5.25-43.81-4.29-.22,7.38,44h0a.58.58,0,0,0,.28.38,1.69,1.69,0,0,0,1.53.08A.54.54,0,0,0,239,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.73,330.16l-4.29-.22,1.27,8.31a16.57,16.57,0,0,0,2.54-1.17,2.65,2.65,0,0,0,1.13-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,323.73h-4.3l-6.25,41.38h0a.49.49,0,0,0,.31.47,1.72,1.72,0,0,0,1.53,0,.55.55,0,0,0,.3-.37h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.42,323.73l-1.74,11.55a17.37,17.37,0,0,0,3.29,2l2.75-13.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.28,388.66l-4-44.55-4.29-.22,6.17,44.77h0a.6.6,0,0,0,.29.38,1.69,1.69,0,0,0,1.53.08.51.51,0,0,0,.33-.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.77,350.52l-.53-6.41-4.29-.22.87,6.92A7.93,7.93,0,0,0,206.77,350.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,310.1h-4.3l-6.25,41.37h0a.53.53,0,0,0,.32.48,1.72,1.72,0,0,0,1.53,0,.6.6,0,0,0,.3-.37h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.43,273.63a24.28,24.28,0,0,0-1.71,7.54c-.49,5.78,1.38,27.16,2.56,35.53h0c1.7,14,3.79,14,6.82,16.36,5.21,4,20.21,11.92,25.16,13.87,9,3.54,16.31-1.91,21.78-4.61a127.11,127.11,0,0,0,14.49-8.58c1.37-1,2.08-2,2.06-3.07,0-.41,0-2.13,0-2.58,0-1.35-1.19-2.8-3.7-4.42-4.64-3-21.39-12.78-27.89-16.38a.05.05,0,0,0-.05,0c-5-3-7.92-26.3-11.38-37.26-.07-.24-.14-.47-.22-.68l-.18-.51c-.22-.6-.44-1.15-.68-1.65",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59,328.08c0-1.35-1.19-2.8-3.7-4.42-4.64-3-21.39-12.78-27.89-16.38a.05.05,0,0,0-.05,0c-5-3-7.92-26.3-11.38-37.26a18.14,18.14,0,0,0-.72-2l-.06-.15c-.07-.14-.13-.29-.2-.44s-.07-.16-.1-.23h0a10.48,10.48,0,0,0-2.31-3.33,6,6,0,0,0-1.13-.8l-2-1.14c-3.39-2-7.85.4-13.39,3.44-3.45,1.89-6.39,4.14-8.19,8.33h0a24.28,24.28,0,0,0-1.71,7.54c-.49,5.78,1.38,27.16,2.56,35.53h0c1.7,14,3.79,14,6.82,16.36,5.21,4,20.21,11.92,25.16,13.87,9,3.54,16.31-1.91,21.78-4.61a127.11,127.11,0,0,0,14.49-8.58c1.37-1,2.08-2,2.06-3.07C235.58,330.25,235.59,328.53,235.59,328.08Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59,328.08c0-1.35-1.19-2.8-3.7-4.42-4.64-3-21.39-12.78-27.89-16.38a.05.05,0,0,0-.05,0c-5-3-7.92-26.3-11.38-37.26a18.14,18.14,0,0,0-.72-2l-.06-.15c-.07-.14-.13-.29-.2-.44s-.07-.16-.1-.23h0a10.48,10.48,0,0,0-2.31-3.33,6,6,0,0,0-1.13-.8l-2-1.14c-3.39-2-7.85.4-13.39,3.44-3.45,1.89-6.39,4.14-8.19,8.33h0a24.28,24.28,0,0,0-1.71,7.54c-.49,5.78,1.38,27.16,2.56,35.53h0c1.7,14,3.79,14,6.82,16.36,5.21,4,20.21,11.92,25.16,13.87,9,3.54,16.31-1.91,21.78-4.61a127.11,127.11,0,0,0,14.49-8.58c1.37-1,2.08-2,2.06-3.07C235.58,330.25,235.59,328.53,235.59,328.08Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,339.71a126.9,126.9,0,0,0,14.49-8.59c3.11-2.26,2.83-4.57-1.63-7.46-6.2-4-31.45-18.35-31.45-18.35s-31.92,18.84-30.55,22.32,21.13,14.24,27.36,16.69C206.23,347.85,213.56,342.41,219,339.71Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,339.71a126.9,126.9,0,0,0,14.49-8.59c3.11-2.26,2.83-4.57-1.63-7.46-6.2-4-31.45-18.35-31.45-18.35s-31.92,18.84-30.55,22.32,21.13,14.24,27.36,16.69C206.23,347.85,213.56,342.41,219,339.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,263c-3.36-1.76-7.73.64-13.13,3.6-3.46,1.9-6.41,4.14-8.2,8.35l-2.29-1.32c1.8-4.19,4.74-6.44,8.19-8.33,5.54-3,10-5.47,13.39-3.44Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,263c-3.36-1.76-7.73.64-13.13,3.6-3.46,1.9-6.41,4.14-8.2,8.35l-2.29-1.32c1.8-4.19,4.74-6.44,8.19-8.33,5.54-3,10-5.47,13.39-3.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,270c-.07-.24-1.23-4.26-3.39-6.17a5.49,5.49,0,0,0-3.68-1.4c-2.93,0-6.45,1.94-10.58,4.2-.35.19-.69.38-1,.58-.14.07-.26.15-.39.23l-.46.29-.33.22a19.88,19.88,0,0,0-2.08,1.57l-.31.29a13.77,13.77,0,0,0-1.18,1.23,2.2,2.2,0,0,0-.2.23c-.08.1-.16.19-.23.29l-.23.3a3.46,3.46,0,0,0-.22.31,15.59,15.59,0,0,0-.83,1.32l-.1.17-.19.38-.27.55a24,24,0,0,0-1.87,7.91c-.8,9.5,2.37,43.54,5.64,46.25,0,0-.5-3.08,6.07-7.21,4.46-2.81,7.6-5.17,12.36-7.51,11.62-5.7,14.87-6.77,14.87-6.77C199,304.2,196,280.93,192.57,270Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,270c-.07-.24-1.23-4.26-3.39-6.17a5.49,5.49,0,0,0-3.68-1.4c-2.93,0-6.45,1.94-10.58,4.2-.35.19-.69.38-1,.58-.14.07-.26.15-.39.23l-.46.29-.33.22a19.88,19.88,0,0,0-2.08,1.57l-.31.29a13.77,13.77,0,0,0-1.18,1.23,2.2,2.2,0,0,0-.2.23c-.08.1-.16.19-.23.29l-.23.3a3.46,3.46,0,0,0-.22.31,15.59,15.59,0,0,0-.83,1.32l-.1.17-.19.38-.27.55a24,24,0,0,0-1.87,7.91c-.8,9.5,2.37,43.54,5.64,46.25,0,0-.5-3.08,6.07-7.21,4.46-2.81,7.6-5.17,12.36-7.51,11.62-5.7,14.87-6.77,14.87-6.77C199,304.2,196,280.93,192.57,270Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk-legs--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.91,310.73V380a.73.73,0,0,1-.34.58l-.72.42a.74.74,0,0,1-.68,0l-.72-.42a.75.75,0,0,1-.34-.58V310.73c0-.22.16-.3.34-.19l.72.41a.74.74,0,0,0,.68,0l.72-.41C274.76,310.43,274.91,310.51,274.91,310.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,381l-.72-.42a.75.75,0,0,1-.34-.58V310.73c0-.22.16-.3.34-.19l.72.41a.75.75,0,0,1,.34.59V380.8C273.51,381,273.36,381.11,273.17,381Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,357.32l-44.71-25.81v-1.62l1.4-.8,44.71,25.81c.19.11.19.28,0,.39l-.72.41a.76.76,0,0,0-.34.59v.83C318.56,357.34,318.41,357.43,318.22,357.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,329.89l1.4-.8h0l44.71,25.81c.19.11.19.28,0,.39l-.72.41a.74.74,0,0,1-.68,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.62,337.12v69.27a.77.77,0,0,1-.34.58l-.72.42a.74.74,0,0,1-.68,0l-.72-.42a.77.77,0,0,1-.34-.58V337.12c0-.22.16-.31.34-.2l.72.42a.74.74,0,0,0,.68,0l.72-.42C320.46,336.81,320.62,336.9,320.62,337.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.88,407.39l-.72-.42a.77.77,0,0,1-.34-.58V337.12c0-.22.16-.31.34-.2l.72.42a.74.74,0,0,1,.34.58v69.27C319.22,407.41,319.07,407.5,318.88,407.39Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom-chait--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.4,422.79l-5.39-45-4.4-.22,7.57,45.18h0a.6.6,0,0,0,.29.4,1.77,1.77,0,0,0,1.57.08.52.52,0,0,0,.34-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05,373.74h-4.41l-6.41,42.47h0a.53.53,0,0,0,.32.48,1.74,1.74,0,0,0,1.57,0,.6.6,0,0,0,.32-.38h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,373.74l-1.79,11.85a17.29,17.29,0,0,0,3.38,2.07l2.82-13.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,437.86l-4.15-45.72-4.4-.23,6.33,45.95h0a.56.56,0,0,0,.29.39,1.74,1.74,0,0,0,1.57.08.51.51,0,0,0,.34-.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,398.82l-.61-6.68-4.4-.23,1,7.23A8,8,0,0,0,282.4,398.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.12,359.75h-4.41l-6.42,42.46h0a.52.52,0,0,0,.32.49,1.74,1.74,0,0,0,1.57,0,.61.61,0,0,0,.31-.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.93,372.87c-.62-3.48,2.21-6.2,7.54-9.79a124.85,124.85,0,0,1,15.45-8.68c4.46-2,9-1.86,14.73,1.08,7.93,4.07,31.8,18.55,31.8,18.55s-35.69,20.14-42.55,19.24-24-12.06-25.39-16S247.93,372.87,247.93,372.87Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.93,372.87c-.62-3.48,2.21-6.2,7.54-9.79a124.85,124.85,0,0,1,15.45-8.68c4.46-2,9-1.86,14.73,1.08,7.93,4.07,31.8,18.55,31.8,18.55s-35.69,20.14-42.55,19.24-24-12.06-25.39-16S247.93,372.87,247.93,372.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,389c-5.12,4.64-10.47.65-18.95-4.85-9.58-6.22-11.46-11.31-11.46-11.31a20.9,20.9,0,0,0,.71,5.6c.72,1.79,2.27,3.81,9.18,8.58s11.92,7.15,16.57,8l3.67-.51",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,384.18c-9.58-6.22-11.46-11.31-11.46-11.31a20.9,20.9,0,0,0,.71,5.6c.72,1.79,2.27,3.81,9.18,8.58s11.92,7.15,16.57,8l3.67-.51.28-5.55C273.22,393.67,267.87,389.68,259.39,384.18Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.05,369.88v70.63a.73.73,0,0,1-.34.58l-.72.42a.72.72,0,0,1-.67,0l-.72-.42a.73.73,0,0,1-.34-.58V369.88c0-.21.15-.3.34-.19l.72.41a.72.72,0,0,0,.67,0l.72-.41C261.9,369.58,262.05,369.67,262.05,369.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,441.51l-.72-.42a.73.73,0,0,1-.34-.58V369.88c0-.21.15-.3.34-.19l.72.41a.77.77,0,0,1,.34.59v70.62C260.66,441.53,260.5,441.62,260.32,441.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 431.16 230.49 448.54 230.48 387.4 260.66 370 260.66 431.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 373.11 260.66 374.66 230.49 392.06 230.49 390.51 260.66 373.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 391.95 260.66 393.5 230.49 410.88 230.49 409.35 260.66 391.95",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.45 380.34 254.46 381.74 238.76 390.78 238.76 389.38 254.45 380.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.46 381.75 252.97 381.2 254.45 380.35 254.46 381.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.45 399.79 254.46 401.19 238.76 410.24 238.76 408.83 254.45 399.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 410.77 260.66 412.32 230.49 429.72 230.49 428.17 260.66 410.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 429.61 260.66 431.16 230.49 448.54 230.49 447.01 260.66 429.61",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.45 418 254.46 419.4 238.76 428.44 238.76 427.04 254.45 418",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.46 401.19 252.97 400.65 254.45 399.79 254.46 401.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.46 419.4 252.97 418.85 254.45 418 254.46 419.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.48 448.55 184.78 422.16 184.77 361.02 230.48 387.4 230.48 448.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.46,334.21v70.63a.73.73,0,0,1-.34.58l-.72.42a.72.72,0,0,1-.67,0l-.72-.42a.73.73,0,0,1-.34-.58V334.21c0-.21.15-.3.34-.19l.72.41a.72.72,0,0,0,.67,0l.72-.41C140.31,333.91,140.46,334,140.46,334.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,405.84l-.72-.42a.73.73,0,0,1-.34-.58V334.21c0-.21.15-.3.34-.19l.72.41a.77.77,0,0,1,.34.59v70.62C139.07,405.86,138.91,406,138.73,405.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,382.17l-44.71-25.81v-1.61l1.39-.81,44.72,25.81a.21.21,0,0,1,0,.39l-.72.42a.73.73,0,0,0-.34.58V382C184.12,382.19,184,382.28,183.78,382.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07,354.75l1.39-.81h0l44.72,25.81a.21.21,0,0,1,0,.39l-.72.42a.81.81,0,0,1-.68,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17,360.61v70.62a.75.75,0,0,1-.34.59l-.72.41a.72.72,0,0,1-.67,0l-.72-.41a.75.75,0,0,1-.34-.59V360.61c0-.22.15-.31.34-.2l.72.41a.72.72,0,0,0,.67,0l.72-.41C186,360.3,186.17,360.39,186.17,360.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.44,432.23l-.72-.41a.75.75,0,0,1-.34-.59V360.61c0-.22.15-.31.34-.2l.72.41a.79.79,0,0,1,.34.59V432A.21.21,0,0,1,184.44,432.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,408.55l-44.71-25.81v-1.61l1.39-.81,44.71,25.81c.19.11.19.28,0,.39l-.72.42a.74.74,0,0,0-.33.58v.83C229.83,408.57,229.67,408.66,229.49,408.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.78,381.13l1.39-.81h0l44.71,25.81c.19.11.19.28,0,.39l-.72.42a.79.79,0,0,1-.67,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,387v70.63a.73.73,0,0,1-.34.58l-.72.42a.72.72,0,0,1-.67,0l-.72-.42a.73.73,0,0,1-.34-.58V387c0-.21.15-.3.34-.19l.72.41a.72.72,0,0,0,.67,0l.72-.41C231.73,386.69,231.88,386.78,231.88,387Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.15,458.62l-.72-.42a.73.73,0,0,1-.34-.58V387c0-.21.15-.3.34-.19l.72.41a.76.76,0,0,1,.33.59v70.62C230.48,458.64,230.33,458.73,230.15,458.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.83,335.9v-.25a1.34,1.34,0,0,0-.61-1.06l-94.11-54.35a1.34,1.34,0,0,0-1.23,0l-92.13,53.19a1.34,1.34,0,0,0-.61,1.06v.25a1.37,1.37,0,0,0,.61,1.07l94.11,54.35a1.42,1.42,0,0,0,1.24,0L323.22,337A1.34,1.34,0,0,0,323.83,335.9Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.83,335.9v-.25a1.34,1.34,0,0,0-.61-1.06l-94.11-54.35a1.34,1.34,0,0,0-1.23,0l-92.13,53.19a1.34,1.34,0,0,0-.61,1.06v.25a1.37,1.37,0,0,0,.61,1.07l94.11,54.35a1.42,1.42,0,0,0,1.24,0L323.22,337A1.34,1.34,0,0,0,323.83,335.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,388.64v1.66a1.38,1.38,0,0,0,.62-.14L323.22,337a1.37,1.37,0,0,0,.61-1.07v-.25a1.35,1.35,0,0,0-.5-1c.22.19.19.45-.11.63L231.1,388.49A1.26,1.26,0,0,1,230.48,388.64Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.48,388.64v1.66a1.38,1.38,0,0,0,.62-.14L323.22,337a1.37,1.37,0,0,0,.61-1.07v-.25a1.35,1.35,0,0,0-.5-1c.22.19.19.45-.11.63L231.1,388.49A1.26,1.26,0,0,1,230.48,388.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,335.3,231.1,388.49a1.42,1.42,0,0,1-1.24,0l-94.11-54.35c-.34-.2-.34-.52,0-.71l92.13-53.19a1.34,1.34,0,0,1,1.23,0l94.11,54.35C323.56,334.78,323.56,335.1,323.22,335.3Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.22,335.3,231.1,388.49a1.42,1.42,0,0,1-1.24,0l-94.11-54.35c-.34-.2-.34-.52,0-.71l92.13-53.19a1.34,1.34,0,0,1,1.23,0l94.11,54.35C323.56,334.78,323.56,335.1,323.22,335.3Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.37,345a1.68,1.68,0,0,0,.86-.23l13.13-7.57L157.6,326.34l-11.95,6.9a1.35,1.35,0,0,0-.71,1.17,1.38,1.38,0,0,0,.71,1.18l15.85,9.15A1.74,1.74,0,0,0,162.37,345Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.13,327.69l-12,6.33-.25.39v.32a.44.44,0,0,0,.25.38L162,344.27a.89.89,0,0,0,.82,0l11.77-6.79v-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,344.06a.89.89,0,0,1-.41-.1L146.1,334.8a.45.45,0,0,1-.25-.39.46.46,0,0,1,.25-.39l11.5-6.64,17,9.79L162.78,344A.89.89,0,0,1,162.37,344.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,326.46,146.23,333l-.12.16v1.22h0a.21.21,0,0,0,.12.17l15.86,9.15a.61.61,0,0,0,.56,0L174,337.17v-1.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,336l-.15.08L172,337.1l-.34.2-9,5.21a.61.61,0,0,1-.56,0l-15.86-9.16c-.16-.09-.16-.23,0-.32l.15-.09,11.22-6.48,16.28,9.4,0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,342.58v1.22a.51.51,0,0,1-.28-.07l-15.86-9.15a.21.21,0,0,1-.12-.17v-1.22a.19.19,0,0,0,.12.16l15.86,9.16A.51.51,0,0,0,162.37,342.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,335.78,172,337l-.32.19-9,5.2a.61.61,0,0,1-.56,0l-14.2-8.2-.36-.21a3.37,3.37,0,0,1-1.15-1l0,0a.16.16,0,0,1,0-.09.24.24,0,0,1,.2-.28,5.16,5.16,0,0,0,1.07-.45h0l10-5.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91,335.64c-.15.08-.15.22,0,.31a.59.59,0,0,0,.52,0c.15-.09.15-.23,0-.31A.59.59,0,0,0,171.91,335.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6,334.65a.68.68,0,0,0-.71.05A2.19,2.19,0,0,0,172,336a.63.63,0,0,0,.19,0,2,2,0,0,1,.8-1.14.6.6,0,0,1,.32-.1.38.38,0,0,1,.19.05.73.73,0,0,1,.27.65.81.81,0,0,1,0,.16l.19.11a2.45,2.45,0,0,0,0-.27A.9.9,0,0,0,173.6,334.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.93,335.84s0,0,0,0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.32,334.72c-.15.09-.15.22,0,.31a.59.59,0,0,0,.52,0c.15-.09.15-.22,0-.31A.59.59,0,0,0,170.32,334.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,333.73a.73.73,0,0,0-.71,0,2.21,2.21,0,0,0-.89,1.29.62.62,0,0,0,.19,0,2,2,0,0,1,.8-1.14.7.7,0,0,1,.32-.1.38.38,0,0,1,.19,0,.74.74,0,0,1,.27.66.76.76,0,0,1,0,.15l.19.11a2.46,2.46,0,0,0,0-.26A.93.93,0,0,0,172,333.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.73,333.8c-.15.09-.15.23,0,.31a.59.59,0,0,0,.52,0c.15-.08.15-.22,0-.31A.59.59,0,0,0,168.73,333.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.42,332.82a.7.7,0,0,0-.71,0,2.24,2.24,0,0,0-.89,1.29.41.41,0,0,0,.19,0,2,2,0,0,1,.8-1.14.7.7,0,0,1,.32-.1.38.38,0,0,1,.19.05.74.74,0,0,1,.27.66.76.76,0,0,1,0,.15l.19.11a2.46,2.46,0,0,0,0-.26A.9.9,0,0,0,170.42,332.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,332.89c-.15.08-.15.22,0,.3a.55.55,0,0,0,.53,0,.16.16,0,0,0,0-.3A.55.55,0,0,0,167.14,332.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.83,331.9a.68.68,0,0,0-.71.05,2.23,2.23,0,0,0-.89,1.28.44.44,0,0,0,.2,0,1.92,1.92,0,0,1,.79-1.13.62.62,0,0,1,.32-.1.3.3,0,0,1,.19.05.72.72,0,0,1,.27.65.92.92,0,0,1,0,.16l.19.1a2.11,2.11,0,0,0,0-.26A.9.9,0,0,0,168.83,331.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,332c-.15.08-.15.22,0,.3a.55.55,0,0,0,.53,0,.16.16,0,0,0,0-.3A.55.55,0,0,0,165.55,332Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,331a.68.68,0,0,0-.71,0,2.23,2.23,0,0,0-.89,1.28.64.64,0,0,0,.2,0,1.94,1.94,0,0,1,.79-1.14.65.65,0,0,1,.32-.1.46.46,0,0,1,.2,0,.75.75,0,0,1,.26.65.81.81,0,0,1,0,.16l.19.11a2.45,2.45,0,0,0,0-.27A.88.88,0,0,0,167.24,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,331.05c-.15.09-.15.22,0,.31a.62.62,0,0,0,.53,0,.17.17,0,0,0,0-.31A.62.62,0,0,0,164,331.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,330.06a.71.71,0,0,0-.71.05,2.25,2.25,0,0,0-.89,1.29l.2,0a2,2,0,0,1,.79-1.14.77.77,0,0,1,.33-.1.45.45,0,0,1,.19.05.73.73,0,0,1,.26.66.76.76,0,0,1,0,.15l.19.11a2.46,2.46,0,0,0,0-.26A.91.91,0,0,0,165.65,330.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,330.13c-.15.09-.15.23,0,.31a.62.62,0,0,0,.53,0,.17.17,0,0,0,0-.31A.62.62,0,0,0,162.37,330.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,329.14a.73.73,0,0,0-.71.05,2.29,2.29,0,0,0-.89,1.29.44.44,0,0,0,.2,0,2,2,0,0,1,.79-1.14.77.77,0,0,1,.33-.1.41.41,0,0,1,.19.05.73.73,0,0,1,.26.66.76.76,0,0,1,0,.15l.19.11a2.46,2.46,0,0,0,0-.26A.91.91,0,0,0,164.06,329.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,329.22a.16.16,0,0,0,0,.3.55.55,0,0,0,.53,0,.16.16,0,0,0,0-.3A.55.55,0,0,0,160.78,329.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.47,328.23a.66.66,0,0,0-.7,0,2.2,2.2,0,0,0-.9,1.28.44.44,0,0,0,.2,0,2,2,0,0,1,.79-1.13.65.65,0,0,1,.33-.1.32.32,0,0,1,.19,0,.7.7,0,0,1,.26.65.92.92,0,0,1,0,.16l.19.1a2.11,2.11,0,0,0,0-.26A.88.88,0,0,0,162.47,328.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.19,328.3a.16.16,0,0,0,0,.3.55.55,0,0,0,.53,0,.16.16,0,0,0,0-.3A.55.55,0,0,0,159.19,328.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,327.31a.68.68,0,0,0-.71.05,2.2,2.2,0,0,0-.9,1.28.64.64,0,0,0,.2,0,2,2,0,0,1,.79-1.14.65.65,0,0,1,.33-.1.41.41,0,0,1,.19.05.72.72,0,0,1,.26.65v.16l.18.11a2.45,2.45,0,0,0,0-.27A.9.9,0,0,0,160.89,327.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,327.38a.17.17,0,0,0,0,.31.62.62,0,0,0,.53,0,.17.17,0,0,0,0-.31A.62.62,0,0,0,157.6,327.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,326.39a.71.71,0,0,0-.71.05,2.23,2.23,0,0,0-.9,1.28.64.64,0,0,0,.2,0,2,2,0,0,1,.79-1.14.77.77,0,0,1,.33-.1.41.41,0,0,1,.19.05.73.73,0,0,1,.27.65c0,.06,0,.11,0,.16l.18.11a2.45,2.45,0,0,0,0-.27A.92.92,0,0,0,159.3,326.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,340.72a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.18.18,0,0,1,.25.07.19.19,0,0,1-.07.26l-8.74,5.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,340.11a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.18.18,0,0,1,.25.06.18.18,0,0,1-.07.26l-8.74,5.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.66,339.5a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.25l8.75-5.06a.19.19,0,0,1,.19.33l-8.75,5.05A.19.19,0,0,1,158.66,339.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,338.89a.19.19,0,0,1-.16-.1.2.2,0,0,1,.07-.26l8.75-5a.19.19,0,0,1,.19.33l-8.75,5.05A.19.19,0,0,1,157.6,338.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,338.27a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.26l8.75-5.05a.18.18,0,0,1,.25.07.18.18,0,0,1-.06.26l-8.75,5.05A.18.18,0,0,1,156.54,338.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,337.66a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.19.19,0,0,1,.19.33l-8.75,5.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,337.05a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.2.2,0,0,1,.26.07.18.18,0,0,1-.07.25L154.52,337Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,336.44a.2.2,0,0,1-.16-.09.19.19,0,0,1,.07-.26L162,331a.21.21,0,0,1,.26.07.19.19,0,0,1-.07.26l-8.75,5.05A.17.17,0,0,1,153.36,336.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,335.83a.19.19,0,0,1-.16-.1.2.2,0,0,1,.07-.26l8.75-5.05a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-8.75,5.05A.17.17,0,0,1,152.3,335.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.24,335.21a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.26l8.75-5.05a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-8.75,5.05A.16.16,0,0,1,151.24,335.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,334.6a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-8.75,5.05A.16.16,0,0,1,150.18,334.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,334a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l8.75-5.05a.19.19,0,0,1,.19.33L149.22,334Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06,333.38A.19.19,0,0,1,148,333l8.75-5a.2.2,0,0,1,.26.07.18.18,0,0,1-.07.25l-8.75,5.05A.17.17,0,0,1,148.06,333.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,341.33a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l9.26-5.35a.18.18,0,0,1,.25.07.18.18,0,0,1-.06.26L162,341.31A.15.15,0,0,1,161.86,341.33Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.48,334.67a.8.8,0,0,0-.36-.23l-.17-.08c-.08-.13-.19-.34,0-.37s.24.07.34.1,0-.06,0-.07-.45-.26-.52,0a.36.36,0,0,0,0,.24.49.49,0,0,0-.23,0c-.08,0-.14,0-.16.09s0,.07,0,.11a.09.09,0,0,0,.08.07h-.08c-.11,0-.42-.07-.49.06s0,.14,0,.16-.22.08-.26.11,0,.07,0,.07a1.7,1.7,0,0,1-.32,0c-.17,0-.61-.05-.55.22,0,0,0,0,0,.08s0,.05,0,.06l0,0s-.08,0-.1,0,0,.14-.06.2-.45-.09-.6,0,0,.36-.19.36c-.05,0,0,.08,0,.08.21,0,.19,0,.23-.2s.5-.09.75-.16c0,0,0,0,0-.06s0-.16.11-.2,0,0,0-.07-.12-.19-.06-.26l.25,0a5.42,5.42,0,0,1,.57,0s0,0,0-.05.21-.1.27-.11,0,0,0-.05c-.11-.3.32-.19.49-.16s.06,0,.05-.05-.24-.2,0-.24a.54.54,0,0,1,.19.05,1.41,1.41,0,0,0,.45.46C166.44,334.93,166.61,334.87,166.48,334.67Zm-.08.06c.06.07-.11,0-.13,0a.59.59,0,0,1-.23-.24l.14.07A.46.46,0,0,1,166.4,334.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,336.52c0-.13,0-.27.08-.28s0-.09,0-.09-.21.13-.19.3l-.19-.07c-.1,0-.17,0-.21.08s0,.11,0,.16.08.05,0,.09l-.14,0c-.13,0-.14,0-.21.07s.11.09-.12.06a.57.57,0,0,0-.18,0c-.08,0-.13,0-.11.14s.09.1.09.12c0,.2-.21,0-.3,0a0,0,0,0,0-.05,0c0,.1.07.14-.08.15a.77.77,0,0,0-.15-.06c-.09,0-.17.12-.29.11s0,0,0,.06.08.14-.1.22l-.21,0s0,.08,0,.08.37.13.45,0-.06-.18,0-.24.16,0,.18,0l.14,0s.05,0,.08,0,.07,0,.1,0,0-.06.06-.07,0,0,0-.07.08,0,.13.05.17.07.23,0-.07-.16-.06-.22.24,0,.33-.1a0,0,0,0,0,0,0c-.06-.2.3-.05.41-.07a0,0,0,0,0,0,0,.73.73,0,0,0-.05-.12c0-.12.2-.11.27-.09.07.24.27.48.47.42,0,0,0,0,0,0S162.3,336.63,162.11,336.52Zm.07.19,0,0a.52.52,0,0,1,.15.14C162.34,336.92,162.2,336.75,162.18,336.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.29,337.81a.86.86,0,0,0-.36-.23l-.18-.09c-.08-.13-.18-.34,0-.37a1.62,1.62,0,0,1,.34.1s0-.06,0-.07-.45-.25-.52,0a.42.42,0,0,0,0,.24.66.66,0,0,0-.23,0c-.07,0-.14,0-.16.1s0,.06,0,.1.06.07.07.08h-.08c-.11,0-.41-.08-.48.06s0,.14,0,.16l-.25.1s0,.07,0,.08-.25,0-.32,0-.6,0-.55.22c0,0,0,0,0,.07a.35.35,0,0,0,0,.07s0,0,0,0-.08,0-.1,0,0,.15-.06.21-.45-.09-.6,0,0,.35-.19.36c0,0,0,.07,0,.08.22,0,.19,0,.23-.2s.51-.09.75-.16a0,0,0,0,0,0-.06c-.07-.11,0-.16.1-.21s0,0,0-.06-.12-.19-.06-.26a1,1,0,0,1,.26,0,5.23,5.23,0,0,1,.56,0,0,0,0,0,0,0-.06c0-.06.22-.1.27-.11s0,0,0,0c-.12-.29.31-.18.49-.15a.05.05,0,0,0,0-.06c0-.1-.25-.2,0-.23a.34.34,0,0,1,.2,0,1.4,1.4,0,0,0,.44.46C165.24,338.07,165.42,338,165.29,337.81Zm-.08.05c0,.07-.12,0-.14,0a.72.72,0,0,1-.22-.24l.13.07A.6.6,0,0,1,165.21,337.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,335.59c0-.13,0-.27.09-.28s0-.09,0-.09-.21.13-.19.3a.64.64,0,0,0-.19-.07c-.11,0-.17,0-.21.08s0,.11,0,.16.08.05-.05.08a.66.66,0,0,1-.14,0,.21.21,0,0,0-.22.07c-.07.06.12.09-.11.06a.57.57,0,0,0-.18,0c-.08,0-.13,0-.11.14s.09.09.09.12c0,.2-.22,0-.3,0a0,0,0,0,0,0,0c0,.1.07.14-.08.15s-.11-.06-.15-.06-.17.12-.3.11,0,0,0,.06.08.14-.1.22l-.21,0c-.05,0,0,.09,0,.09s.37.13.45,0-.06-.18,0-.23.16-.05.18-.05a.57.57,0,0,1,.14,0s.05,0,.08,0h.1s0-.06.05-.07,0-.05,0-.07.08,0,.12,0,.18.08.23,0-.06-.16-.05-.22.24,0,.33-.1,0,0,0-.05c-.05-.19.31,0,.42-.06a0,0,0,0,0,0,0s-.05-.12-.05-.13.19-.1.27-.08c.07.24.26.48.47.42,0,0,0,0,0,0S168.17,335.7,168,335.59Zm.08.19,0,0a.52.52,0,0,1,.15.14C168.21,336,168.07,335.82,168.05,335.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,331.1a.8.8,0,0,0-.36-.23l-.17-.09c-.08-.13-.19-.34-.05-.36s.25.07.34.1,0-.06,0-.08-.46-.25-.52,0a.44.44,0,0,0,0,.25.59.59,0,0,0-.23-.05c-.07,0-.13,0-.16.1s0,.07,0,.1a.09.09,0,0,0,.08.08h-.09c-.11,0-.41-.07-.48.06s0,.14,0,.16l-.26.1s0,.07,0,.08a1.71,1.71,0,0,1-.32,0c-.18,0-.61-.05-.55.22,0,0,0,0,0,.07a.26.26,0,0,1,0,.07s0,0,0,0-.07,0-.09,0,0,.14-.06.2-.45-.09-.6,0,0,.35-.2.36c-.05,0,0,.08,0,.08.22,0,.2,0,.24-.2s.5-.09.74-.16a0,0,0,0,0,0-.06c-.06-.1,0-.16.11-.21a0,0,0,0,0,0-.06c0-.05-.12-.19-.07-.26a1.09,1.09,0,0,1,.26,0,5.42,5.42,0,0,1,.57,0,0,0,0,0,0,0-.05c0-.06.22-.1.28-.12s0,0,0-.05c-.12-.29.31-.18.49-.15s.06,0,.05-.06-.24-.19,0-.23a.34.34,0,0,1,.2.05,1.41,1.41,0,0,0,.45.46C160,331.36,160.15,331.3,160,331.1Zm-.08,0c.05.08-.12,0-.14,0a.72.72,0,0,1-.22-.24l.13.07A.53.53,0,0,1,159.94,331.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64,332.94c0-.12,0-.26.08-.28s0-.08,0-.08-.21.13-.19.3a.6.6,0,0,0-.2-.07c-.1,0-.16,0-.2.08s0,.11,0,.16.07.05,0,.08a.66.66,0,0,1-.14,0,.23.23,0,0,0-.22.06c-.08.07.12.1-.11.06a1.1,1.1,0,0,0-.18,0c-.08,0-.13,0-.11.14s.09.09.09.12c0,.2-.22,0-.3,0a0,0,0,0,0-.05,0c0,.1.07.14-.08.15s-.12-.06-.15-.06-.18.12-.3.11,0,0,0,.06.08.14-.1.22l-.21,0c-.06,0,0,.09,0,.09s.36.13.45,0-.06-.18,0-.23.16-.05.18-.06a.32.32,0,0,1,.14,0s0,0,.07,0,.08,0,.11,0,0,0,.05-.06,0,0,0-.07.09,0,.13,0,.17.07.23,0-.06-.16,0-.22.24,0,.33-.1a0,0,0,0,0,0-.05c-.05-.19.3,0,.42-.06a0,0,0,0,0,0,0l0-.13c0-.11.19-.1.27-.08.07.24.26.48.47.42,0,0,0,0,0,0S155.84,333.06,155.64,332.94Zm.08.2,0-.05a.52.52,0,0,1,.15.14C155.88,333.35,155.74,333.18,155.72,333.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,334.24a.66.66,0,0,0-.36-.23l-.17-.09c-.08-.13-.19-.34,0-.37a1.28,1.28,0,0,1,.34.1s0-.06,0-.07-.45-.26-.52,0a.36.36,0,0,0,0,.24.49.49,0,0,0-.23,0c-.08,0-.14,0-.16.09s0,.07,0,.11a.07.07,0,0,0,.07.07h-.08c-.11,0-.42-.08-.49.06s0,.13,0,.15l-.26.11s0,.07,0,.07a3,3,0,0,1-.32,0c-.17,0-.61,0-.55.22,0,0,0,0,0,.07s0,.06,0,.06l0,0s-.08,0-.1,0,0,.14-.06.21-.45-.1-.6,0,0,.35-.19.35c-.05,0,0,.08,0,.08.21,0,.19,0,.23-.2s.5-.09.75-.15a0,0,0,0,0,0-.07c-.06-.1,0-.16.11-.2a0,0,0,0,0,0-.06c0-.05-.12-.2-.06-.26a1,1,0,0,1,.25,0,3.62,3.62,0,0,1,.57,0,0,0,0,0,0,0-.06c0-.06.21-.1.27-.11a0,0,0,0,0,0-.05c-.11-.29.32-.19.5-.16,0,0,.05,0,0-.05s-.24-.2,0-.23a.36.36,0,0,1,.19,0,1.41,1.41,0,0,0,.45.46C158.78,334.49,159,334.43,158.82,334.24Zm-.08.05c.06.07-.11,0-.13,0a.59.59,0,0,1-.23-.24l.14.07A.52.52,0,0,1,158.74,334.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,332c0-.12,0-.26.08-.28s0-.08,0-.08-.21.13-.19.29l-.2-.06c-.1,0-.17,0-.2.08s0,.1,0,.16.07.05,0,.08a.81.81,0,0,1-.15,0,.22.22,0,0,0-.21.06c-.08.07.12.1-.11.06a.37.37,0,0,0-.18,0c-.09,0-.13,0-.12.13s.1.1.1.13c0,.2-.22,0-.3,0a0,0,0,0,0-.05,0c0,.1.06.14-.08.14s-.12-.05-.15-.05-.18.12-.3.11a0,0,0,0,0,0,.05c0,.09.08.15-.1.23l-.21,0c-.06,0,0,.09,0,.09s.36.12.45,0-.06-.18,0-.23.16,0,.18-.06a.57.57,0,0,1,.14,0s0,.05.07.05.08,0,.11,0,0-.06.05-.06,0,0,0-.07.09,0,.13,0,.17.07.23,0-.06-.16-.05-.23.23,0,.33-.09a0,0,0,0,0,0-.05c-.06-.2.3,0,.42-.06s0,0,0,0a1,1,0,0,0,0-.13c0-.12.19-.1.27-.08.07.24.26.48.47.42,0,0,0,0,0,0S161.71,332.13,161.51,332Zm.08.2a.16.16,0,0,1,0-.06l.15.15C161.75,332.42,161.61,332.24,161.59,332.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,336.39a.8.8,0,0,0-.36-.23l-.17-.08c-.08-.13-.19-.34-.05-.37s.25.07.34.1,0-.06,0-.07-.45-.26-.51,0a.42.42,0,0,0,0,.24.47.47,0,0,0-.23,0c-.07,0-.13,0-.16.09s0,.07,0,.11.06.07.07.07h-.08c-.11,0-.41-.07-.48.06s0,.14,0,.16-.22.08-.26.11,0,.07,0,.07a1.6,1.6,0,0,1-.31,0c-.18,0-.61-.05-.56.22,0,0,0,0,0,.08a.35.35,0,0,0,0,.06l0,0s-.07,0-.1,0,.05.14-.06.21-.45-.1-.59,0,0,.36-.2.36c-.05,0,0,.08,0,.08.22,0,.19,0,.24-.2s.5-.09.74-.16c0,0,0,0,0-.06s0-.16.11-.2a0,0,0,0,0,0-.07s-.12-.19-.06-.26l.26,0a5.42,5.42,0,0,1,.57,0,0,0,0,0,0,0,0c0-.06.22-.1.27-.11a.07.07,0,0,0,0-.05c-.12-.29.31-.19.49-.16a0,0,0,0,0,.05,0c0-.1-.24-.2,0-.24a.64.64,0,0,1,.2.05,1.32,1.32,0,0,0,.45.46C159.44,336.65,159.62,336.59,159.49,336.39Zm-.08.06c.05.07-.12,0-.14,0s-.16-.15-.22-.24l.13.07A.48.48,0,0,1,159.41,336.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,334.37c0-.13,0-.27.08-.28s0-.09,0-.09-.21.13-.18.3l-.2-.07c-.1,0-.17,0-.2.09s0,.1,0,.15.08,0-.05.09l-.14,0c-.13,0-.14,0-.21.07s.11.09-.12.06a.57.57,0,0,0-.18,0c-.08,0-.12.05-.11.14s.1.1.1.12c0,.2-.22,0-.31,0s-.05,0-.05,0,.07.13-.08.14a1,1,0,0,0-.14-.06c-.1,0-.18.12-.3.11s-.05,0,0,.06.08.14-.1.22l-.21,0s0,.08,0,.08.37.13.45,0-.06-.18,0-.24.16-.05.18-.05a.66.66,0,0,1,.15,0s0,0,.07,0,.07,0,.1,0,0-.06.06-.07,0-.05,0-.07.08,0,.13.05.17.07.23,0-.07-.16-.05-.22.23,0,.32-.1a0,0,0,0,0,0,0c-.06-.2.3-.05.41-.07a0,0,0,0,0,0,0,.83.83,0,0,0,0-.12c0-.12.19-.11.26-.09.08.24.27.49.48.42,0,0,0,0,0,0S161.81,334.48,161.62,334.37Zm.07.2s0,0,0-.06a.52.52,0,0,1,.15.14C161.85,334.77,161.71,334.6,161.69,334.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,332.73v-.05c0-.13-.18,0-.21,0s0,.11,0,.16.08.05,0,.08a.71.71,0,0,1-.14,0c-.13,0-.14,0-.21.06s.11.1-.12.06a1.1,1.1,0,0,0-.18,0c-.08,0-.13,0-.11.14s.09.09.09.12c0,.2-.21,0-.3,0a0,0,0,0,0-.05,0c0,.1.07.14-.08.15a.77.77,0,0,0-.15-.06c-.09,0-.17.12-.3.11s0,0,0,.06.08.14-.1.22l-.21,0c-.05,0,0,.09,0,.09s.37.13.45,0-.06-.18,0-.23.16-.05.18-.06a.35.35,0,0,1,.14,0s.05,0,.08,0h.1s0-.06.05-.07,0-.05,0-.07.08,0,.13,0,.17.08.23,0-.07-.16-.06-.22.24,0,.33-.1,0,0,0-.05c-.06-.19.3,0,.41-.06a0,0,0,0,0,0,0,.74.74,0,0,1,0-.26Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M166.62,328l10.46,6.1a1.26,1.26,0,0,0,1.12,0l29.42-17a.34.34,0,0,0,0-.64l-10.46-6.09a1.23,1.23,0,0,0-1.12,0l-29.42,17C166.31,327.53,166.31,327.82,166.62,328Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.81,315.23a.37.37,0,0,0-.23-.32l-9.31-5.37a1.21,1.21,0,0,0-1.11,0L167.75,326a.41.41,0,0,0-.23.33v1a.39.39,0,0,0,.23.32l9.31,5.38a1.27,1.27,0,0,0,1.11,0l28.41-16.41a.37.37,0,0,0,.23-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,332l-9.31-5.35a.35.35,0,0,1,0-.65l28.41-16.42a1.21,1.21,0,0,1,1.11,0l9.31,5.37c.31.18.31.46,0,.64L178.17,332A1.24,1.24,0,0,1,177.06,332Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,332.09v1a1.21,1.21,0,0,1-.52-.13l-9.31-5.38a.39.39,0,0,1-.23-.32v-1a.39.39,0,0,0,.23.32l9.31,5.36A1.21,1.21,0,0,0,177.58,332.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,326.2l1.25-.72.93.55-1.25.72-.93-.53h0Zm1.44.84,1-.57.93.55-1,.57-.92-.53v0Zm.31-1.84,1-.57.92.55-1,.57-.92-.54h0Zm1.13,2.67,1.59-.92.93.55-1.59.92-.92-.53h0Zm0-1.69.78-.45.93.55-.78.45-.92-.53h0Zm.3-1.84,1-.56.93.55-1,.56-.92-.53h0Zm1,1.11.78-.45.92.55-.78.45-.92-.53s0,0,0,0Zm.13,3.25,1.25-.72.92.55-1.25.72-.92-.53h0Zm.37-5.21,7.09-4.1.93.55-7.09,4.1-.92-.53h0Zm.27,3.18.78-.45.92.55-.78.45-.92-.53v0Zm.5-2,.78-.45.93.55-.78.45-.92-.53h0Zm.3,4.83.78-.45.93.55-.78.45-.93-.54Zm.3-1.85.78-.45.93.55-.78.45-.92-.53h0Zm.17-1.76.78-.45.93.55-.78.45-.92-.53h0Zm.51-2,.78-.45.92.55-.77.45L176,324h0Zm.3,4.83.78-.45.92.55-.78.45-.92-.53h0Zm.3-1.84.78-.45.93.55-.78.45-.92-.53s0,0,0,0Zm.17-1.77.78-.45.93.55-.78.45-.92-.53h0Zm0,5.36,1-.57.93.55-1,.57-.92-.53v0Zm.51-7.31.77-.45.93.55-.78.45-.92-.53v0Zm.29,4.82.78-.45.93.55-.78.45-.92-.53h0Zm.31-1.84.78-.45.92.55-.78.45-.92-.53h0Zm.17-1.76.77-.45.93.55-.78.45-.92-.53s0,0,0,0Zm.5-2,.78-.45.93.55-.78.45-.92-.53h0Zm.25,6.87.78-.45.93.55-.78.45-.92-.53h0Zm0-2.05.78-.44.92.55-.77.45-.93-.54h0Zm.3-1.84.78-.45.93.55-.78.45-.92-.53h0Zm.17-1.76.78-.45.93.55-.78.45-.92-.53h0Zm.51-2,.78-.45.92.55-.78.45-.92-.53h0Zm.25,6.88.78-.45.93.55-.78.45-.93-.54Zm0-2.05.77-.45.93.55-.78.45-.92-.53h0Zm.3-1.84.78-.45.93.55-.78.45-.93-.53v0Zm.17-1.77.78-.45.92.55-.77.45-.93-.53h0Zm.5-2,.78-.45.93.55-.78.45-.92-.54a0,0,0,0,1,0,0Zm.26,6.87.77-.45.93.55-.78.45-.92-.53h0Zm0-2,.78-.45.93.55-.78.45-.92-.53h0Zm.14-6.74,1-.57.93.55-1,.57-.92-.53v0Zm.17,4.9.77-.45.93.55-.78.45-.92-.53h0Zm.17-1.76.77-.45.93.55-.78.45-.92-.54h0Zm.5-2,.78-.45.93.55-.78.45-.92-.53h0Zm.25,6.87.78-.45.93.55-.78.45-.92-.53h0Zm.05-2.05.78-.45.92.55-.78.45-.92-.53h0Zm.3-1.84.78-.45.93.55-.78.45-.92-.53s0,0,0,0Zm0-5,1-.56.93.55-1,.56-.92-.53h0Zm.13,3.26.78-.45.93.55-.78.45-.92-.53h0Zm.51-2,.78-.45.92.55-.78.45-.92-.53h0Zm.29,4.83.78-.45.93.55-.78.45-.92-.53v0Zm.31-1.84.78-.45.92.55-.78.45-.92-.54Zm.17-1.77.78-.45.92.55-.78.45-.92-.53h0Zm0,5.33.78-.45.93.55-.78.46-.92-.54h0Zm0-8.7,1-.57.93.55-1,.57-.92-.53h0Zm.43,1.42.78-.45.93.55-.78.45-.92-.54Zm.3,4.82.78-.45.93.55-.78.45-.92-.53a0,0,0,0,1,0,0Zm.3-1.84.78-.45.93.55-.78.45-.92-.53h0Zm.17-1.76.78-.45.93.55-.78.45-.92-.54Zm0,5.33.78-.45.93.55-.78.45-.92-.53v0Zm.24-8.82,1.24-.72.93.55-1.25.72-.92-.53v0Zm.23,1.53,2.46-1.42.93.55-2.46,1.42-.93-.53v0Zm.3,4.82.78-.45.92.55-.78.45-.92-.53h0Zm.3-1.84.78-.45.93.55-.78.45-.92-.53h0Zm.17-1.76.78-.45.93.55-.78.45-.93-.53h0Zm0,5.33.78-.45.92.55-.78.45-.92-.53h0Zm.76-2.46.78-.45.93.55-.78.45-.92-.53v0Zm.21-6.79.78-.45.93.55-.78.45-.92-.53h0Zm.1,4.95.78-.45.92.55-.78.45-.92-.54Zm.17-1.77,1.85-1.07,2.37,1.38-.91.53-1.21-.7a.54.54,0,0,0-.24-.05.45.45,0,0,0-.22.05l-.72.41-.92-.53h0Zm0,5.33.78-.45.93.55-.78.45-.92-.53a0,0,0,0,1,0,0Zm.77-2.46.78-.45.93.55L190,322l-.92-.53h0Zm.21-6.78.78-.45.92.55-.78.45-.92-.53v0Zm.09,4.94.78-.45.93.55-.78.45-.92-.53h0Zm.76,3.25.78-.45.93.55-.78.45-.92-.54a0,0,0,0,1,0,0Zm.22-2.15.77-.45.93.55-.78.45-.92-.53h0Zm.2-6.78.78-.45.93.55-.78.45-.92-.53h0Zm.17,1.57.78-.45.93.55-.78.45-.93-.53h0Zm.69,6.62.78-.45.93.55-.78.45-.92-.53h0Zm.21-2.14,1.38-.8.93.55-1.38.8-.92-.53s0,0,0,0Zm.48-6.94,2.05-1.19.93.55-2,1.19-.93-.53v0Zm.23,4.86.78-.45.93.55-.79.45-.92-.53h0Zm.36,3.48.78-.45.92.55-.78.45-.92-.53h0Zm.85-7.51.78-.45.93.55-.78.45-.92-.53h0Zm.07,3.3.77-.45.93.55-.78.45-.92-.54a0,0,0,0,1,0,0Zm.16,1.56.78-.44.93.55-.78.45-.92-.54h0Zm.19,1.92.78-.45.93.55-.78.45-.92-.54Zm.69-9.09.78-.45.93.55-.78.45-.92-.53h0Zm.17,1.57.78-.45.92.55-.78.45-.92-.53h0Zm.06,3.3.78-.45.93.55-.78.45-.92-.53h0Zm.1-1.73.78-.45.93.55-.78.45-.92-.53h0ZM195,318l.78-.45.92.55-.78.45L195,318v0Zm.47,1.75.78-.45.93.55-.78.45-.92-.54Zm.41-8.92.78-.45,2.37,1.38-.78.45-2.37-1.36v0Zm.16,1.57.78-.45.93.55-.78.45-.92-.53v0Zm.17,1.57.78-.45.93.55-.78.45-.92-.53v0Zm.06,3.29.78-.45.93.55-.78.45-.92-.53h0Zm.11-1.72.77-.45.93.55-.78.45-.92-.54h0Zm.37,3.47.78-.45.92.55-.78.45-.92-.53h0Zm.74-5.78.78-.45.92.55-.78.45-.92-.53h0Zm.16,1.57.78-.45.93.55-.78.45-.92-.53h0Zm.17,1.57.78-.45.93.55-.79.45-.92-.53h0Zm.2,1.9.78-.45.93.55-.78.45-.92-.53h0Zm.74-5.78.78-.45,2.37,1.39-.78.45-2.36-1.37h0Zm.17,1.57.78-.45.93.55-.78.45-.93-.53h0Zm.17,1.57.77-.45.93.55-.78.45-.92-.53h0Zm.84,2,.78-.44.4.24-.78.45-.39-.23h0Zm.43-2.69.78-.45.93.55-.78.45-.92-.54Zm.85,2,.77-.45.4.25-.78.45-.39-.23v0Zm.43-2.7.78-.45.92.55-.78.45-.92-.53h0Zm.84,2,.78-.45.4.25-.78.45-.39-.23h0Zm1.28-.74.78-.44.4.24-.78.45-.4-.23h0Z",
    style: {
      fill: "#008C8E"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.51,346.49a1.68,1.68,0,0,0,1.54,0l43-24.85a1.75,1.75,0,0,0,.8-1.37V285.6a1.72,1.72,0,0,0-.75-1.35,1.69,1.69,0,0,0-1.53,0l-43.05,24.85a1.76,1.76,0,0,0-.79,1.38v34.64A1.71,1.71,0,0,0,188.51,346.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.05,346.46l43-24.85a1.75,1.75,0,0,0,.8-1.37V285.59c0-.5-.36-.71-.8-.45l-43,24.85a1.75,1.75,0,0,0-.8,1.37V346C189.25,346.51,189.61,346.72,190.05,346.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,309.72l1.49.86a1.68,1.68,0,0,0-.24.78V346.1c0,.46.29.67.68.52a1.49,1.49,0,0,1-2.17-1.38V310.51A1.68,1.68,0,0,1,188,309.72Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,308.47l1.71-15.79-1.71-1L188,342c-2.72,1.57-5.19,5.35-5.19,8.48v11.44l1.7,1v-2Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,308.47l1.71-15.79-1.71-1L188,342c-2.72,1.57-5.19,5.35-5.19,8.48v11.44l1.7,1v-2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.61,309.49V292.68L189.74,343c-2.71,1.57-5.19,5.34-5.19,8.48v11.41Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.61,309.49V292.68L189.74,343c-2.71,1.57-5.19,5.34-5.19,8.48v11.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--green-post--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.77 326.74 222.77 336.55 230.9 331.86 230.9 322.05 222.77 326.74",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,332.34l-5.4,3c-.61.34-1-.63-1-1.22-.6.39-1.83.63-1.9-.14l-.43-5.59,8.13-4.69Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,332.34l-5.4,3c-.61.34-1-.63-1-1.22-.6.39-1.83.63-1.9-.14l-.43-5.59,8.13-4.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.23 323.72 223.1 328.41 223.1 326.9 231.23 322.21 231.23 323.72",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.23 323.72 223.1 328.41 223.1 326.9 231.23 322.21 231.23 323.72",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.79 334.41 226.01 335.39 225.32 333.58 223.79 334.41",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.79 334.41 226.01 335.39 225.32 333.58 223.79 334.41",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28,327.66a11.24,11.24,0,0,1-.55,1.35c-.07.18-.34.82,0,.89.11,0,.48-1.06.55-1.23a1.39,1.39,0,0,0,.09-1c0-.08-.11-.09-.13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.12,327.91a7.06,7.06,0,0,1-.33,1,1.54,1.54,0,0,0-.25.87c0,.09.18.26.27.14a5.24,5.24,0,0,0,.44-1,1.44,1.44,0,0,0,.13-.84c0-.08-.2-.3-.26-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,328.82c.15,0,.07-.28-.06-.28s-.07.28.06.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44,330.18c.15,0,.06-.29-.08-.29s-.07.29.08.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19,328.61c-.53.2-1.23.87-1.19,1.48s.69.67,1.1.41a1.71,1.71,0,0,0,.74-1.19.69.69,0,0,0-.73-.8c-.15,0-.08.25,0,.26.41.06.37.34.24.66a1.67,1.67,0,0,1-.47.65.62.62,0,0,1-.31.16c-.26.06-.25-.1-.18-.3a2,2,0,0,1,.94-1c.15-.07,0-.35-.18-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,329.25c-.39,0-.81.53-.94.87a.78.78,0,0,0,.44,1,.85.85,0,0,0,1.14-.57,1.36,1.36,0,0,0-.33-1.46c-.08-.07-.18,0-.16.1.07.34.28.61.2,1s-.47.88-.88.56.47-1,.63-1.34c0-.06,0-.18-.1-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,331.37c-.56,1.05,1.25.53,1.64.33l-.18-.24c-.62,1.13.36,1.59,1.2.73a2,2,0,0,0-.25-.14,1.09,1.09,0,0,0,2.05.19c0-.05,0-.23-.11-.16-.33.26-1.53.92-1.66,0,0-.1-.15-.24-.25-.14s-.57.61-.81.25-.08-.29.05-.54c.05-.09-.06-.29-.18-.23s-1.48.59-1.35.11c0-.07-.08-.28-.15-.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M236.24,381.73a1.69,1.69,0,0,1-.86-.21L221,373.25a.72.72,0,0,1,0-1.32l2.56-1.47-1.23-.71a.71.71,0,0,1,0-1.31l21.1-12.18a1.69,1.69,0,0,1,.86-.21,1.71,1.71,0,0,1,.86.21l14.33,8.27a.71.71,0,0,1,0,1.32L257,367.32l1.23.71a.71.71,0,0,1,0,1.31l-21.1,12.18A1.65,1.65,0,0,1,236.24,381.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,367.58a.51.51,0,0,0-.3-.42l-14.33-8.28a1.59,1.59,0,0,0-1.44,0l-21.1,12.18a.52.52,0,0,0-.3.42v.65a.52.52,0,0,0,.3.42l14.33,8.27a1.61,1.61,0,0,0,1.45,0l21.09-12.18a.49.49,0,0,0,.3-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18,371.06l21.1-12.18a1.59,1.59,0,0,1,1.44,0l14.33,8.28a.44.44,0,0,1,0,.83L237,380.17a1.61,1.61,0,0,1-1.45,0l-14.33-8.27A.44.44,0,0,1,221.18,371.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,380.34V381a1.42,1.42,0,0,1-.72-.17l-14.33-8.27a.52.52,0,0,1-.3-.42v-.65a.49.49,0,0,0,.3.41l14.33,8.28A1.42,1.42,0,0,0,236.23,380.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,364.08a.52.52,0,0,0-.3-.42l-14.33-8.27a1.59,1.59,0,0,0-1.44,0l-21.1,12.18a.48.48,0,0,0-.29.41v.66a.5.5,0,0,0,.29.41l14.34,8.27a1.59,1.59,0,0,0,1.44,0l21.09-12.17a.52.52,0,0,0,.3-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.51,367.57l21.1-12.18a1.59,1.59,0,0,1,1.44,0l14.33,8.27a.44.44,0,0,1,0,.84l-21.09,12.17a1.59,1.59,0,0,1-1.44,0l-14.34-8.27A.44.44,0,0,1,222.51,367.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,376.85v.65a1.43,1.43,0,0,1-.72-.18l-14.33-8.27a.49.49,0,0,1-.3-.41V368a.51.51,0,0,0,.3.42l14.33,8.27A1.43,1.43,0,0,0,237.57,376.85Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-pencil--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-64",
    points: "251.56 350.82 264.66 358.38 263.09 359.28 250.07 351.68 248.78 349.87 251.56 350.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.28,351.19l-1.56-1.85a.07.07,0,0,1,.07-.12l2.38.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,349.22h0l2.38.53-.47.76-.26-.15-1.66-1.05Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,349.22a.07.07,0,0,0-.07.12l.3.36h0a.42.42,0,0,1,.24-.35h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,356.24l-.19-.11-.23-.14-10.34-6.24a1.23,1.23,0,0,0-.89,1.44l10.33,6.24.44.27C260.78,357.51,261.65,356.06,261.93,356.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,356.24l-.19-.11-.23-.14-10.34-6.24a1.14,1.14,0,0,0-.76.59l10.79,6.58s0,0,0,0C261.43,356.55,261.77,356.14,261.93,356.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,355.8l-.43-.26c-.12-.08-.36.14-.57.43s-.46.92-.3,1l.32.19.11.07c-.16-.11,0-.65.3-1s.43-.48.56-.43h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,355.73c-.28-.18-1.15,1.28-.87,1.46l.43.26c-.28-.18.59-1.64.87-1.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,356.24l-.42-.25c-.28-.19-1.13,1.21-.9,1.44h0l.42.26C260.78,357.51,261.65,356.06,261.93,356.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,349.25a.09.09,0,0,1,.07,0A.09.09,0,0,0,248.71,349.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,357.33l-1.79-1.09c-.12-.08-.36.14-.57.42s-.47.93-.31,1h0l1.8,1.09c.36.21.88-.46,1-1A.41.41,0,0,0,263.72,357.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,357.51a1.31,1.31,0,0,0-.43,1.08.29.29,0,0,0,.17.22c.35.12.83-.51.93-1a.4.4,0,0,0-.12-.46C263.6,357.25,263.39,357.31,263.18,357.51Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M258.66,346.77l10.46,6.09a1.23,1.23,0,0,0,1.12,0l29.42-17c.31-.17.31-.46,0-.64l-10.46-6.09a1.21,1.21,0,0,0-1.11,0l-29.43,17A.35.35,0,0,0,258.66,346.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.86,334a.41.41,0,0,0-.23-.32l-9.31-5.37a1.21,1.21,0,0,0-1.11,0L259.8,344.74a.36.36,0,0,0-.23.32v1a.37.37,0,0,0,.23.32l9.3,5.38a1.27,1.27,0,0,0,1.11,0l28.42-16.41a.39.39,0,0,0,.23-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,350.73l-9.3-5.35c-.31-.18-.31-.47,0-.64l28.41-16.43a1.21,1.21,0,0,1,1.11,0l9.31,5.37a.34.34,0,0,1,0,.64l-28.42,16.4A1.24,1.24,0,0,1,269.1,350.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,350.86v1a1.25,1.25,0,0,1-.52-.13l-9.3-5.38a.37.37,0,0,1-.23-.32v-1a.39.39,0,0,0,.23.33l9.3,5.35A1.25,1.25,0,0,0,269.62,350.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,349.88h0l-.93-.54,1.25-.72,1,.54-1.25.72Zm-1.45-.83h0l-.92-.53,1-.57,1,.54-1,.57Zm3.19-.18h0l-.92-.53,1-.57,1,.53-1,.57Zm-4.63-.66h0l-.92-.53,1.59-.92,1,.54-1.59.91Zm2.92,0h0l-.92-.53.78-.45.95.53-.78.45Zm3.19-.17h0l-.92-.53,1-.56,1,.53-1,.57Zm-1.91-.56h0l-.92-.53.78-.45.95.54-.78.45Zm-5.64-.08h0l-.92-.53,1.25-.73.95.54-1.25.72Zm9-.22h0l-.92-.53,7.09-4.1.95.54-7.09,4.09Zm-5.51-.15h0l-.92-.53.78-.45.95.53-.77.45Zm3.39-.29h0l-.92-.54.78-.45,1,.54-.78.45Zm-8.35-.17h0L263,346l.78-.45,1,.54-.78.45Zm3.19-.18h0l-.93-.53.78-.45,1,.53-.78.45Zm3.05-.1h0l-.92-.53.78-.45.95.53-.78.45Zm3.39-.29h0l-.92-.53.78-.45,1,.53-.78.45Zm-8.36-.17h0l-.92-.53.78-.45.95.53-.78.45Zm3.19-.17h0l-.92-.53.78-.45.95.54-.78.44Zm3.06-.1h0l-.93-.53.78-.45,1,.54-.78.45Zm-9.27,0h0l-.93-.53,1-.57.95.54-1,.57Zm12.66-.29h0l-.92-.53.78-.45.95.54-.78.44Zm-8.36-.18h0l-.92-.53.78-.45.95.53-.78.45Zm3.19-.17h0l-.92-.53.78-.45.95.54-.78.45Zm3.05-.1h0l-.92-.53.78-.46.95.54-.78.45Zm3.39-.29h0l-.92-.53.78-.45.95.54-.77.45Zm-11.9-.15h0l-.92-.53.78-.45.95.53-.78.45Zm3.55,0h0l-.92-.53.78-.45,1,.54-.78.45Zm3.18-.18h0l-.92-.53.78-.45,1,.53-.78.45Zm3.06-.1h0l-.92-.53.78-.45,1,.53-.78.45Zm3.39-.29h0l-.92-.53.78-.45.95.53-.78.45Zm-11.9-.14h0l-.92-.53.78-.45,1,.54-.78.45Zm3.54,0h0l-.92-.54.78-.45.95.54-.78.45Zm3.19-.18h0l-.92-.53.78-.45.95.53-.78.45Zm3.06-.09h0l-.93-.53.78-.45,1,.54-.78.45Zm3.39-.3h0l-.93-.53.78-.45,1,.53-.78.45Zm-11.91-.14h0l-.92-.54.78-.45.95.54-.78.45Zm3.55,0h0l-.92-.53.78-.45,1,.53-.78.45Zm11.68-.08h0l-.92-.53,1-.57,1,.54-1,.56Zm-8.49-.09h0l-.93-.53.79-.45,1,.54-.78.45Zm3.05-.1h0l-.92-.54.78-.45.95.54-.78.45Zm3.39-.29h0l-.92-.53.78-.45,1,.54-.78.45Zm-11.9-.15h0l-.92-.53.78-.45.95.53-.78.45Zm3.54,0h0l-.92-.53.78-.45,1,.54-.78.45Zm3.19-.18h0l-.92-.53.78-.45.95.53-.77.45Zm8.7,0h0l-.92-.53,1-.56.95.53-1,.57Zm-5.64-.08h0l-.92-.53.78-.45.95.53-.78.45Zm3.39-.29h0l-.92-.53.78-.45.95.53-.78.45Zm-8.36-.17h0l-.92-.54.78-.45.95.54-.78.45Zm3.19-.18h0l-.92-.53.78-.45.95.53-.78.45Zm3.05-.09h0l-.92-.53.78-.45,1,.54-.78.45Zm-9.23,0h0l-.92-.53.78-.45,1,.53-.78.45Zm15.08,0h0l-.92-.53,1-.57,1,.54-1,.56Zm-2.46-.26h0l-.92-.53.78-.45,1,.53-.78.45Zm-8.35-.17h0l-.92-.53.77-.45,1,.53-.78.45Zm3.19-.17h0l-.93-.53.78-.45,1,.54-.78.45Zm3.05-.1h0l-.92-.54.78-.45.95.54-.78.45Zm-9.23,0h0l-.93-.53.78-.45,1,.54-.78.45Zm15.27-.14h0l-.92-.53,1.25-.73.95.54-1.25.72Zm-2.65-.13h0l-.92-.53,2.46-1.42.95.54-2.46,1.42Zm-8.36-.17h0l-.92-.53.78-.45.95.54-.77.44Zm3.19-.18h0l-.92-.54.78-.45.95.54-.78.45Zm3.06-.1h0l-.93-.53.79-.45.95.53-.78.45Zm-9.24,0h0l-.92-.53.78-.45.95.53-.78.45Zm4.27-.44h0l-.92-.54.78-.45,1,.54-.78.45Zm11.75-.12h0l-.92-.54.78-.45,1,.54-.78.45Zm-8.56-.06h0l-.92-.53.78-.45.95.53-.78.45Zm3.05-.09h0l-.92-.53.71-.41a.16.16,0,0,0,.08-.13.16.16,0,0,0-.08-.14l-1.21-.7.91-.52,2.4,1.36L283,338.9Zm-9.23,0h0l-.92-.53.78-.45.95.53-.78.45Zm4.27-.44h0l-.93-.53.78-.45,1,.53-.78.45Zm11.74-.12h0l-.92-.53.78-.45,1,.53-.78.45Zm-8.55-.05h0l-.92-.53.78-.45,1,.54-.78.45Zm-5.63-.44h0l-.92-.53.78-.45.95.54-.78.45Zm3.71-.12h0l-.92-.53.78-.45.95.54-.78.44Zm11.75-.12h0l-.92-.53.78-.45.95.53-.78.45Zm-2.72-.1h0l-.92-.54.78-.45.95.54-.78.45Zm-11.46-.4h0l-.93-.54.78-.45,1,.54-.78.45Zm3.71-.12h0l-.92-.54,1.38-.8,1,.54-1.38.8Zm12-.28h0l-.93-.53,2.06-1.19,1,.54-2.05,1.18Zm-8.43-.13h0l-.92-.54.78-.45.95.54-.78.45Zm-6-.21h0l-.92-.53.78-.45.95.53-.78.45Zm13-.49h0l-.92-.54.78-.45.95.54-.77.45Zm-5.7,0h0l-.92-.53.77-.45,1,.53-.78.45Zm-2.72-.09h0l-.92-.53.78-.45.95.54-.78.45Zm-3.31-.11h0l-.92-.53.78-.45.95.54-.78.45Zm15.73-.4h0l-.92-.54.78-.45.95.54-.78.45Zm-2.72-.1h0l-.92-.53.78-.45,1,.53-.78.45Zm-5.71,0h0l-.92-.53.78-.45.95.54-.77.45Zm3-.06h0l-.92-.53.78-.45.95.54-.78.45Zm-5.71,0h0l-.92-.54.78-.45,1,.54L284,335Zm-3-.27h0l-.92-.53.78-.45.95.54-.78.45Zm15.44-.24h0L294,333.11l.78-.45,2.4,1.37-.78.45Zm-2.71-.09h0l-.92-.53.78-.45,1,.54-.78.45Zm-2.72-.1h0l-.93-.54.78-.45,1,.54-.78.45Zm-5.71,0h0l-.92-.53.78-.45.95.53-.78.45Zm3-.06h0l-.92-.53.78-.45.95.53-.78.45Zm-6-.21h0l-.92-.54L282,333l1,.54-.77.45Zm10-.43h0l-.92-.53.78-.45.95.53-.77.45Zm-2.72-.09h0l-.92-.53.78-.45,1,.54-.78.45Zm-2.71-.1h0l-.93-.53.78-.45,1,.53-.78.45Zm-3.3-.12h0l-.92-.53.78-.45.95.53-.78.45Zm10-.42h0l-2.37-1.36.78-.45,2.4,1.37-.78.45Zm-2.72-.1h0l-.92-.54.78-.45.95.54-.78.45Zm-2.72-.1h0l-.92-.53.78-.45.95.53-.78.45Zm-3.4-.48h0l-.4-.22.78-.45.43.23-.77.45Zm4.68-.25h0l-.92-.53.78-.45.95.54-.78.45Zm-3.4-.49h0l-.4-.23.78-.45.43.23-.78.45Zm4.67-.25h0l-.92-.53.78-.45,1,.53-.78.45Zm-3.39-.49h0l-.4-.23.78-.45.42.23-.77.45Zm1.27-.73h0l-.4-.22.78-.45.43.23-.77.45Z",
    style: {
      fill: "#008C8E"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-64",
    d: "M240.23,344.6l-5.78-3.34a1,1,0,0,1,0-1.81l41.49-24a3.5,3.5,0,0,1,3.15,0l5.78,3.34a1,1,0,0,1,0,1.82l-41.49,24A3.5,3.5,0,0,1,240.23,344.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.08,337.12l6.38-3.69a1.66,1.66,0,0,0,1-1.37v-.89l-6-3.4a1.4,1.4,0,0,1-.64-1.1v-7.86l-11.13,6.44v7.85a1.37,1.37,0,0,0,.64,1.1l5,2.92A5.25,5.25,0,0,0,267.08,337.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,334.5v.88l-2-1.18a1.42,1.42,0,0,1-.63-1.1v-7.85L258.8,324c0,.54.09,1.1.14,1.64l-1.49.86v6.14a1.39,1.39,0,0,0,.63,1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,332.66a1.39,1.39,0,0,0,.63,1.1l4.24,2.47a5.25,5.25,0,0,0,4.76,0l6.38-3.68c1.31-.76,1.31-2,0-2.75l-4.25-2.47a1.4,1.4,0,0,1-.63-1.1v-6.14l-11.13,6.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.51,328.08h0l-1.3-.74a1.4,1.4,0,0,1-.63-1.1v-6.14l-11.13,6.43v6.14a1.39,1.39,0,0,0,.63,1.1l1.27.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.58,341.14a1.69,1.69,0,0,0,1.53,0l43.05-24.85a1.76,1.76,0,0,0,.79-1.38V280.24a1.69,1.69,0,0,0-.74-1.34,1.71,1.71,0,0,0-1.54,0l-43,24.86a1.75,1.75,0,0,0-.8,1.37v34.64A1.69,1.69,0,0,0,239.58,341.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.11,341.11l43.05-24.85a1.76,1.76,0,0,0,.79-1.38V280.24c0-.51-.35-.71-.79-.46l-43.05,24.86a1.75,1.75,0,0,0-.79,1.37v34.64C240.32,341.16,240.67,341.36,241.11,341.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.07,304.37l1.48.86a1.63,1.63,0,0,0-.23.78v34.74c0,.46.29.67.68.52a1.77,1.77,0,0,1-1.43,0,1.71,1.71,0,0,1-.74-1.35V305.15A1.57,1.57,0,0,1,239.07,304.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.81,336V306.5a1,1,0,0,1,.47-.82L283,282.18c.26-.15.48,0,.48.27V312a1.06,1.06,0,0,1-.48.82l-40.71,23.5C242,336.43,241.81,336.31,241.81,336Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.14,287.62l-33,19.06a1,1,0,0,0-.43.75v24c0,.27.19.38.43.24l33-19a1,1,0,0,0,.44-.75v-24A.27.27,0,0,0,279.14,287.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,308.63v15.11a.32.32,0,0,1-.14.25l-2.43,1.4c-.08,0-.14,0-.14-.08V310.19a.32.32,0,0,1,.14-.25l2.43-1.39C249.49,308.5,249.55,308.54,249.55,308.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,309.38l-.8.46a.21.21,0,0,0-.1.18V311c0,.07,0,.09.1.06l.8-.46a.25.25,0,0,0,.11-.19v-.92C249.32,309.37,249.27,309.34,249.21,309.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,310.09l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.06l.8-.46a.22.22,0,0,0,.1-.18v-.93C248.08,310.08,248,310.05,248,310.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,310.78l-.8.46a.22.22,0,0,0-.1.18v.93c0,.07,0,.09.1.06l.8-.46a.25.25,0,0,0,.11-.19v-.92C249.32,310.77,249.27,310.74,249.21,310.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,311.49l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.06l.8-.46a.22.22,0,0,0,.1-.18v-.93C248.08,311.48,248,311.46,248,311.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,312.18l-.8.46a.22.22,0,0,0-.1.18v.93c0,.07,0,.1.1.06l.8-.46a.25.25,0,0,0,.11-.19v-.92C249.32,312.17,249.27,312.14,249.21,312.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,312.89l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.07l.8-.47a.21.21,0,0,0,.1-.18V313C248.08,312.88,248,312.86,248,312.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,313.58l-.8.46a.23.23,0,0,0-.1.19v.92c0,.07,0,.1.1.06l.8-.46a.24.24,0,0,0,.11-.19v-.92C249.32,313.57,249.27,313.54,249.21,313.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,314.29l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.07l.8-.47a.21.21,0,0,0,.1-.18v-.93C248.08,314.28,248,314.26,248,314.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,315l-.8.46a.23.23,0,0,0-.1.19v.92c0,.07,0,.1.1.06l.8-.46a.24.24,0,0,0,.11-.19V315C249.32,315,249.27,314.94,249.21,315Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,315.69l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.07l.8-.47a.21.21,0,0,0,.1-.18v-.93C248.08,315.68,248,315.66,248,315.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,316.38l-.8.46a.23.23,0,0,0-.1.19V318c0,.07,0,.1.1.06l.8-.46a.24.24,0,0,0,.11-.19v-.92C249.32,316.37,249.27,316.34,249.21,316.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,317.09l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.07l.8-.46a.24.24,0,0,0,.1-.19v-.93C248.08,317.09,248,317.06,248,317.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,317.78l-.8.46a.23.23,0,0,0-.1.19v.92c0,.07,0,.1.1.06l.8-.46a.24.24,0,0,0,.11-.19v-.92C249.32,317.77,249.27,317.74,249.21,317.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,318.49l-.8.46a.25.25,0,0,0-.11.19v.92c0,.07.05.1.11.07l.8-.46a.24.24,0,0,0,.1-.19v-.93C248.08,318.49,248,318.46,248,318.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,319.18l-.8.46a.23.23,0,0,0-.1.19v.92c0,.07,0,.1.1.06l.8-.46a.24.24,0,0,0,.11-.19v-.92C249.32,319.17,249.27,319.14,249.21,319.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,319.89l-.8.46a.25.25,0,0,0-.11.19v.93c0,.06.05.09.11.06l.8-.46a.24.24,0,0,0,.1-.19V320C248.08,319.89,248,319.86,248,319.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,321l-1.19.69a.36.36,0,0,0-.16.28v1.38c0,.1.07.15.16.09l1.19-.68a.37.37,0,0,0,.16-.28v-1.38C249.32,321,249.25,320.94,249.16,321Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.3,323.38l1-.57a0,0,0,0,1,0,0V324l-1,.56s0,0,0,0v-1.13m-.16-.18a.33.33,0,0,0-.09.22v1.38c0,.1.07.14.16.09l1.19-.69a.13.13,0,0,0,.07-.06.31.31,0,0,0,.09-.22v-1.37c0-.11-.07-.15-.16-.1l-1.19.69-.07.06Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.63,295.33l-21.48,12.4a1.82,1.82,0,0,0-.82,1.43v15.91c0,.52.37.73.82.47l21.48-12.41a1.82,1.82,0,0,0,.82-1.42v-15.9C275.45,295.28,275.08,295.07,274.63,295.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,310.88a.18.18,0,0,1-.16-.1.18.18,0,0,1,.06-.26l7.72-4.45a.19.19,0,0,1,.19.33l-7.72,4.45A.14.14,0,0,1,253.49,310.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,312.66a.18.18,0,0,1-.16-.1.18.18,0,0,1,.06-.26l7.72-4.45a.19.19,0,0,1,.19.33l-7.72,4.45A.14.14,0,0,1,253.49,312.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,314.44a.17.17,0,0,1-.16-.09.18.18,0,0,1,.06-.26l7.72-4.46a.19.19,0,0,1,.19.33l-7.72,4.45A.14.14,0,0,1,253.49,314.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,316.22a.17.17,0,0,1-.16-.09.18.18,0,0,1,.06-.26l7.72-4.46a.19.19,0,0,1,.19.33l-7.72,4.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.75 305.34 273.55 299.11 273.55 306.23 262.75 312.47 262.75 305.34",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.75 305.34 273.55 299.11 273.55 306.23 262.75 312.47 262.75 305.34",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.52 311.13 272.79 305.8 270.75 304.37 268.72 306.78 266.49 304.72 263.52 311.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.24,303.05c.25-.15.45,0,.45.25a1,1,0,0,1-.45.78c-.24.14-.44,0-.44-.26A1,1,0,0,1,269.24,303.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.49 319.6 273.55 308.01 273.55 309.8 253.49 321.38 253.49 319.6",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,318a.17.17,0,0,1-.16-.09.18.18,0,0,1,.06-.26l7.72-4.45a.18.18,0,0,1,.26.06.19.19,0,0,1-.07.26L253.58,318Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,323.35a.18.18,0,0,1-.16-.1.18.18,0,0,1,.06-.26l20.09-11.56a.19.19,0,0,1,.19.33l-20.09,11.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.7,307.43a1,1,0,0,1,.43-.75l33-19.06a.27.27,0,0,1,.44.25v1.85L245.7,309.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,325.23a1.66,1.66,0,0,0-.74,1.29c0,.48.33.67.74.43a1.65,1.65,0,0,0,.75-1.29C264.27,325.19,263.93,325,263.52,325.23Z",
    style: {
      fill: "#008C8E"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,327.42l-2.89,1.67a3.18,3.18,0,0,1-3.18-.17l-4.76-3.48a1.15,1.15,0,0,1,.1-2.07l1.45-.84a3.93,3.93,0,0,1,3.35-.1l5.88,3.19C300.89,326.09,300.91,326.9,300,327.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.09,323.93l3.29,2.58,2.43,1.9a2.29,2.29,0,0,0,.78.19,2.1,2.1,0,0,0,1.15-.25l2.59-1.49h0a1.83,1.83,0,0,0,.52-2.61l-.08-.11a3.46,3.46,0,0,0-2.08-1.32l-1.31-.26a14.66,14.66,0,0,0-4.06-.5l-3.23,1.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,325.37l-.19-.14,2.91-1.68-2.54-.79.25-.14,2.55.78,1.73-1,.33.06Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.53,328.26l0,0h0l-2.31-1.67-3.13-2.26V324l0,0h0a11.41,11.41,0,0,1,3.22,1l1.08.43a3.62,3.62,0,0,1,.93.55,3.44,3.44,0,0,1,1.25,2.66v.06a2.29,2.29,0,0,1-.78-.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.49,364.08l-15,8.68a1.93,1.93,0,0,1-1.72,0l-17.1-9.88a.52.52,0,0,1,0-1l15-8.68a1.93,1.93,0,0,1,1.72,0l17.1,9.88C227,363.36,227,363.8,226.49,364.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.91,329.36a.32.32,0,0,0-.33,0l-.36.21.23,23.06a1,1,0,0,0,.46.81L225,363.82V339.77Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.91,329.36a.32.32,0,0,0-.33,0l-.36.21.23,23.06a1,1,0,0,0,.46.81L225,363.82V339.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,329.56c-.26-.15-.46,0-.46.27v23a1,1,0,0,0,.46.8L224.61,364V340Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,329.56c-.26-.15-.46,0-.46.27v23a1,1,0,0,0,.46.8L224.61,364V340Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,361.79l-13.36-7.72a1,1,0,0,1-.47-.81V332.08l-1.75-1,1.79-1,0,0c.08-.11.22-.14.4,0l15.3,8.83v24.06L220.18,364Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,331.15c-.26-.15-.47,0-.47.27v23a1,1,0,0,0,.47.81L220.18,364V340Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.17 339.99 222.12 338.86 222.13 362.92 220.18 364.04 220.17 339.99",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,340.64a.57.57,0,0,0,0-.18.53.53,0,0,0-.14-.23.19.19,0,0,0-.07-.06c-.14-.09-.25,0-.25.19a.57.57,0,0,0,.06.24.48.48,0,0,0,.19.23h0C219.44,340.89,219.54,340.82,219.53,340.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24,341.81a1.26,1.26,0,0,0,.55-.6.81.81,0,0,0-.06-.74h0a1.31,1.31,0,0,0-.49-.47l-.12-.06v.3c.63.37.62,1,0,1.33a2.54,2.54,0,0,1-2.31,0,.77.77,0,0,1-.47-.73.64.64,0,0,1,.18-.38.53.53,0,0,0-.14-.23,1,1,0,0,0-.26.37.88.88,0,0,0,.06.74,1.42,1.42,0,0,0,.5.47A2.86,2.86,0,0,0,222.24,341.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.06,342.29l-16.58-11.17.25-.15a.55.55,0,0,1,.47,0l16.21,11.11Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.06,342.29l-16.58-11.17.25-.15a.55.55,0,0,1,.47,0l16.21,11.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.8,331.15c-.25-.15-.46,0-.46.27v23a1,1,0,0,0,.46.81l16.54,11.3V342.45Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.96 339.77 224.97 363.82 220.33 366.5 220.33 342.45 224.96 339.77",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.96 339.77 224.97 363.82 220.33 366.5 220.33 342.45 224.96 339.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,345.05a.83.83,0,0,0-.61-.42,1.22,1.22,0,0,0-.8.18,2.83,2.83,0,0,0-1.29,2.24,1.34,1.34,0,0,0,.16.66,1,1,0,0,0,1.41.24,2.83,2.83,0,0,0,1.29-2.24,1.34,1.34,0,0,0-.16-.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.77,345c.64-.37,1.16-.07,1.16.67a2.57,2.57,0,0,1-1.16,2c-.64.36-1.16.07-1.16-.67A2.57,2.57,0,0,1,222.77,345Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.54,350l.35-.2c.71-.4,1.27-.08,1.27.73V361a2.79,2.79,0,0,1-1.27,2.2l-.35.2c-.7.41-1.27.08-1.27-.73V352.22A2.82,2.82,0,0,1,222.54,350Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.68 339.61 220.07 342.27 220.33 342.45 224.96 339.77 224.68 339.61",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.68 339.61 220.07 342.27 220.33 342.45 224.96 339.77 224.68 339.61",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.24,366.91a.45.45,0,0,0,.17-.34V343a.45.45,0,0,0-.21-.35L202,331.41l-.35.21v24l17.18,11.23A.43.43,0,0,0,219.24,366.91Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,343l.35-.2a.6.6,0,0,1,.07.2v23.58a.45.45,0,0,1-.17.34.43.43,0,0,1-.38,0c.11.07.2,0,.2-.12V343.19A.44.44,0,0,0,219,343Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,331.62l17.17,11.22a.34.34,0,0,1,.14.15.44.44,0,0,1,.07.2v23.58c0,.13-.09.19-.2.12l-17.18-11.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,331.62l.35-.21,17.17,11.23a.34.34,0,0,1,.14.15l-.35.2a.34.34,0,0,0-.14-.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.96 331.78 201.97 355.83 197.33 358.5 197.38 334.42 201.96 331.78",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.96 331.78 201.97 355.83 197.33 358.5 197.38 334.42 201.96 331.78",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,368.13a.57.57,0,0,0,.51,0l.93-.54a.57.57,0,0,0,.26-.44V343.68a.56.56,0,0,0-.25-.44L203,334l-1.45.84v24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,358.88l15,9.25c.14.08.25,0,.25-.15V344.52a.56.56,0,0,0-.25-.44l-15-9.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,336.48a1.16,1.16,0,0,0,0-.18.53.53,0,0,0-.14-.23.13.13,0,0,0-.07-.06c-.14-.09-.25,0-.25.18a.57.57,0,0,0,.06.25.55.55,0,0,0,.19.23h0C202.6,336.73,202.69,336.65,202.69,336.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,344.27l1.45-.84a.5.5,0,0,1,.08.26v23.46a.59.59,0,0,1-.25.44l-.95.54a.53.53,0,0,1-.43,0c.1,0,.18,0,.18-.18V344.52A.41.41,0,0,0,216.78,344.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.32,335.28a1,1,0,0,0,.58.89,3.71,3.71,0,0,0,2.56.18,3.26,3.26,0,0,0-.13-.33,3.33,3.33,0,0,1-2.26-.15,1,1,0,0,1-.33-.31.5.5,0,0,1-.07-.27c0-.32.31-.68.82-1a3.57,3.57,0,0,1,3.12-.17.82.82,0,0,1,.38.38l.37.22v0a.83.83,0,0,0-.12-.44,1.22,1.22,0,0,0-.46-.44,4,4,0,0,0-3.47.16A1.62,1.62,0,0,0,199.32,335.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.29,368.61a.43.43,0,0,0,.18-.34V344.69a.44.44,0,0,0-.2-.35l-18.84-10.26-.36.2v24.05l18.85,10.26A.43.43,0,0,0,216.29,368.61Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,344.69l.35-.2a.41.41,0,0,1,.06.2v23.58a.36.36,0,0,1-.56.32c.11.07.2,0,.2-.12V344.89A.41.41,0,0,0,216.05,344.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,334.28l18.85,10.26a.41.41,0,0,1,.14.15.41.41,0,0,1,.06.2v23.58c0,.13-.09.19-.2.12l-18.85-10.27Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,334.28l.36-.2,18.84,10.25a.43.43,0,0,1,.14.16l-.35.2a.41.41,0,0,0-.14-.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.68 331.62 197.07 334.27 197.38 334.42 201.96 331.78 201.68 331.62",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.68 331.62 197.07 334.27 197.38 334.42 201.96 331.78 201.68 331.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,334.89a.33.33,0,0,0-.33,0l-.36.21.23,23.06a1,1,0,0,0,.47.81l18,10.42V345.31Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,334.89a.33.33,0,0,0-.33,0l-.36.21.23,23.06a1,1,0,0,0,.47.81l18,10.42V345.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,335.1c-.25-.15-.46,0-.46.26v23a1,1,0,0,0,.46.81L215,369.56V345.51Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,335.1c-.25-.15-.46,0-.46.26v23a1,1,0,0,0,.46.81L215,369.56V345.51Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.59,367.33l-13.36-7.72a1,1,0,0,1-.47-.81V337.62l-1.74-1,1.78-1,0,0a.28.28,0,0,1,.4-.05l15.3,8.84v24.05l-1.95,1.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,336.69c-.26-.15-.47,0-.47.27v23a1,1,0,0,0,.47.81l15.31,8.85V345.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.58 345.52 212.53 344.4 212.54 368.45 210.59 369.58 210.58 345.52",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,346.18a1.16,1.16,0,0,0,0-.18.63.63,0,0,0-.14-.24l-.07-.06c-.14-.08-.25,0-.25.19a.57.57,0,0,0,.06.25.42.42,0,0,0,.19.22l0,0C209.85,346.43,210,346.35,210,346.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,347.34a1.24,1.24,0,0,0,.55-.59.81.81,0,0,0-.06-.74h0a1.37,1.37,0,0,0-.49-.46l-.12-.07v.31c.63.37.62,1,0,1.33a2.57,2.57,0,0,1-2.31,0,.79.79,0,0,1-.47-.73.64.64,0,0,1,.18-.38.63.63,0,0,0-.14-.24,1,1,0,0,0-.26.38.86.86,0,0,0,.06.73,1.27,1.27,0,0,0,.5.47A2.8,2.8,0,0,0,212.65,347.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.47,347.82l-16.58-11.17.25-.14a.49.49,0,0,1,.47,0l16.22,11.11Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.47,347.82l-16.58-11.17.25-.14a.49.49,0,0,1,.47,0l16.22,11.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.21,336.69c-.25-.15-.46,0-.46.27v23a1,1,0,0,0,.47.81L210.75,372V348Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.37 345.31 215.38 369.36 210.74 372.04 210.74 347.98 215.37 345.31",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.37 345.31 215.38 369.36 210.74 372.04 210.74 347.98 215.37 345.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,350.59a.84.84,0,0,0-.61-.43,1.19,1.19,0,0,0-.79.19,2.8,2.8,0,0,0-1.3,2.23,1.41,1.41,0,0,0,.16.67,1,1,0,0,0,1.41.24,2.84,2.84,0,0,0,1.29-2.24,1.34,1.34,0,0,0-.16-.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,350.58c.64-.37,1.16-.07,1.16.67a2.55,2.55,0,0,1-1.16,2c-.64.37-1.16.07-1.16-.67A2.56,2.56,0,0,1,213.18,350.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,355.56l.35-.2c.71-.41,1.28-.08,1.28.73v10.42a2.81,2.81,0,0,1-1.28,2.21l-.35.2c-.7.4-1.27.07-1.27-.74V357.76A2.8,2.8,0,0,1,213,355.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.09 345.15 210.48 347.81 210.74 347.98 215.37 345.31 215.09 345.15",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.09 345.15 210.48 347.81 210.74 347.98 215.37 345.31 215.09 345.15",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top-chair--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.06,394.58c2.92-.14,5.2-2.29,12.14-5.18,12.8-5.33,22.41-9.6,26.07-16.31s6.25-36.79,5.33-45.18a11,11,0,0,0-.62-2.77l.9-.14-2.34-2h0c-2.39-1.95-6.28-.21-9.22,1.39-8.38,4.56-14.94,9-20.12,25-3.9,12-6.47,33.75-11.86,39.62",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,325.14l.9-.14-2.34-2h0c-2.39-1.95-6.28-.21-9.22,1.39-8.38,4.56-14.94,9-20.12,25-3.9,12-6.47,33.75-11.86,39.62l-.28,5.55c2.92-.14,5.2-2.29,12.14-5.18,12.8-5.33,22.41-9.6,26.07-16.31s6.25-36.79,5.33-45.18A11,11,0,0,0,321,325.14Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54,325.49c-8.38,4.56-16.26,9.55-20.7,26-4.4,16.24-7.23,40.9-17.45,43.64,0,0,4.62,1.84,18.77-4.15,4.51-1.91,10-5.38,13.56-7.39,7-3.95,11.3-7.19,12-8.4,3.72-6.67,6.25-36.79,5.33-45.17S316.74,323.2,312.54,325.49Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.54,325.49c-8.38,4.56-16.26,9.55-20.7,26-4.4,16.24-7.23,40.9-17.45,43.64,0,0,4.62,1.84,18.77-4.15,4.51-1.91,10-5.38,13.56-7.39,7-3.95,11.3-7.19,12-8.4,3.72-6.67,6.25-36.79,5.33-45.17S316.74,323.2,312.54,325.49Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepImg);
export default __webpack_public_path__ + "static/media/deep_img.ac304680f9e1e06aba715d3a48f019d1.svg";
export { ForwardRef as ReactComponent };